import React, { useState, useEffect, useRef, Component } from "react";
import classnames from "classnames";
import axios from "axios";
import { apiUrl, genevent, genevent2, web5,getfolderfiles,selectedfolder, getimages, apiUrl3 } from "../../config/config";
import { apiUrl2 } from "../../config/config";
import { apiUrl4 } from "../../config/config";
import $, { event } from "jquery";
import { connect } from "react-redux";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import Select from "react-select";
import PropTypes, { func } from "prop-types";
import TopNav from "../../components/common/TopNav";
import socketIOClient from "socket.io-client";
import BeatsTabVerifier from "../verifier/BeatsTabVerifier";
import VerifierSummary from "../verifier/VerifierSummary";
import SettingsTab from "../../components/graph/SettingsTab";
import SideBarGraph from "../verifier/SideBarVerifier";
// import AddFindingsTab from "../../components/graph/AddFindingsTab"; // Findings tab removed
import DiaryNotes from "../../components/graph/DiaryNotes";
import VerifierSelectedBeats from "../verifier/VerifierSelectedBeats";
import AddModal from "../verifier/AddModal";
import AddModalComplete from "../verifier/AddModalComplete";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import "./vc_backup2.css";
import Loader from "react-loader-spinner";
import ReactModal from "react-modal";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./worker.js";
import initHighchartsMulticolor from "../../utils/highchartsMulticolor";
import AddModalReport from "./AddModalReport";
import Addmodaldisclosure from "./Addmodaldisclosure";
import AddModalInside from "./AddModalInside";
import { now } from "moment";
import toast from "react-hot-toast";
import { MissedVideoCall } from "@material-ui/icons";
const deviceFrequency = 15000;
let worker,
  worker2,
  worker3,
  worker4,
  worker5,
  worker7,
  worker13,
  worker14,
  worker15,
  worker6,
  workersum2,
  worker11,
  worker12,
  worker8,
  worker9,
  worker10;
let graphColor = "";
let gainMin = -0.0005;
let gainMax = 0.0015;
let clickContainerIndex = 0;
let chartCount = 0;
let pageIndex = 0;
window.tab = "Beats";
window.prev_tab = "Events";
initHighchartsMulticolor(Highcharts);
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
const arrhythmiaOptions = [
  { value: "Current", label: "Current" },
  { value: "Normal Sinus Rhythm", label: "Normal Sinus Rhythm" },
  { value: "Sinus Tachycardia", label: "Sinus Tachycardia" },
  { value: "Sinus Bradycardia", label: "Sinus Bradycardia" },
  { value: "PAC", label: "PAC" },
  { value: "PVC", label: "PVC" },
  { value: "Sinus Pause", label: "Sinus pause" },
  { value: "Ventricular Tachycardia", label: "Ventricular Tachycardia" },
  { value: "AFib", label: "Atrial Fibrillation" },
  { value: "flutter", label: "Atrial Flutter" },
  { value: "Prolonged QT", label: "J Beat" },
  { value: "Paced", label: "Pacemaker Beat" },
  { value: "Undiagnosed", label: "Undiagnosed" },
  { value: "Short QT", label: "SVT" },
  { value: "Irregular PR", label: "2AVB" },
  { value: "P Absent", label: "3AVB" },
  { value: "Irregular RR", label: "CHB" },
];

const MultiSelectDropdown = ({
  options = [],
  defaultSelected = [],
  onChange,
  placeholder = "Select options",
}) => {
  const [selected, setSelected] = useState(defaultSelected || []);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setSelected(defaultSelected || []);
  }, [defaultSelected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (value) => {
    const nextSelected = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    setSelected(nextSelected);
    if (onChange) {
      onChange(nextSelected);
    }
  };

  const removeChip = (value, e) => {
    e.stopPropagation();
    const nextSelected = selected.filter((v) => v !== value);
    setSelected(nextSelected);
    if (onChange) {
      onChange(nextSelected);
    }
  };

  return (
    <div
      ref={containerRef}
      style={{ position: "relative", width: "100%" }}
    >
      <div
        onClick={() => setOpen((prev) => !prev)}
        style={{
          minHeight: "38px",
          border: "1px solid #ced4da",
          borderRadius: "4px",
          padding: "4px 8px",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "6px",
          backgroundColor: "white",
          color: "black",
          cursor: "pointer",
        }}
      >
        {selected.length === 0 && (
          <span style={{ color: "#6c757d" }}>{placeholder}</span>
        )}
        {selected.map((value) => {
          const option = options.find((opt) => opt.value === value);
          const label = option ? option.label : value;
          return (
            <span
              key={value}
              style={{
                display: "inline-flex",
                alignItems: "center",
                background: "#e9ecef",
                borderRadius: "12px",
                padding: "2px 8px",
                fontSize: "12px",
                color: "#000",
              }}
            >
              {label}
              <span
                onClick={(e) => removeChip(value, e)}
                style={{
                  marginLeft: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                ×
              </span>
            </span>
          );
        })}
      </div>

      {open && (
        <div
          style={{
            position: "absolute",
            zIndex: 9999,
            background: "white",
            border: "1px solid #ced4da",
            borderRadius: "4px",
            marginTop: "4px",
            width: "100%",
            maxHeight: "220px",
            overflowY: "auto",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          {options.map((opt) => (
            <label
              key={opt.value}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "6px 10px",
                cursor: "pointer",
                gap: "8px",
                color: "#000",
              }}
            >
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                onChange={() => toggleOption(opt.value)}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
//const socket = socketIOClient('http://edit.mybiocalculus.com:5000');

// Linear-time flatten: replaces  chunks.map(e => e[idx]).reduce((a,b) => a.concat(b))
// which is O(n²) (each .concat copies the entire growing accumulator). For large
// ECG arrays this can freeze the main thread for several seconds — the linear
// version below is equivalent in output but keeps allocation to a single pass.
function flattenAt(chunks, idx) {
  if (!chunks || chunks.length === 0) return [];
  let total = 0;
  for (let i = 0; i < chunks.length; i++) {
    const inner = chunks[i] && chunks[i][idx];
    if (inner && inner.length) total += inner.length;
  }
  const out = new Array(total);
  let k = 0;
  for (let i = 0; i < chunks.length; i++) {
    const inner = chunks[i] && chunks[i][idx];
    if (!inner) continue;
    for (let j = 0; j < inner.length; j++) out[k++] = inner[j];
  }
  return out;
}

// Set lookup is O(1) per check; the previous if-else-if chain was up to 17
// string compares per data point per strip. For a 100-strip patient that's
// ~125 000 string compares avoided per render pass.
const KNOWN_ARRHYTHMIAS = new Set([
  "Normal Sinus Rhythm",
  "Sinus Tachycardia",
  "Sinus Bradycardia",
  "Sinus Pause",
  "PAC",
  "PVC",
  "Ventricular Tachycardia",
  "AFib",
  "P Absent",
  "Irregular RR",
  "Irregular PR",
  "Short QT",
  "Prolonged QT",
  "Paced",
  "Undiagnosed",
]);

class VerifierChart extends Component {
  constructor() {
    super();
    /********* State Variables*************/
    worker = new Worker();
    worker2 = new Worker();
    worker3 = new Worker();
    worker4 = new Worker();
    worker5 = new Worker();
    worker6 = new Worker();
    worker7 = new Worker();
    worker8 = new Worker();
    worker9 = new Worker();
    worker13 = new Worker();
    worker10 = new Worker();
    worker11 = new Worker();
    worker12 = new Worker();
    worker14 = new Worker();
    worker15 = new Worker();
    workersum2 = new Worker();
    const menus = [
      { title: "Verifier Home", url: "/verifier-home" },
      { title: "Patient list", url: "/patient-list" },
      { title: "Labled Patients", url: "/labled-patients" },
      { title: "Verified", url: "/verification-completed" },
    ];
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
    }
    if (localStorage.getItem("verifierid") === "5d6df589c3d92110fccfde7c") {
      menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
      menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
    }
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
    }
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
    }
    this.state = {
      newAssignmentAlerts: [],
      menus,
      checkArry: [
        { value: "current", label: "Current" },
        { value: "nsr", label: "Normal Sinus Rhythm" },
        { value: "st", label: "Sinus Tachycardia" },
        { value: "sb", label: "Sinus Bradycardia" },
        { value: "pac", label: "PAC" },
        { value: "pvc", label: "PVC" },
        { value: "sp", label: "Sinus pause" },
        { value: "vt", label: "Ventricular Tachycardia" },
        { value: "af", label: "Atrial Fibrillation" },
        { value: "flutter", label: "Atrial Flutter" },
        { value: "jbeat", label: "J Beat" },
        { value: "Paced", label: "Pacemaker Beat" },
        { value: "un", label: "Undiagnosed" },
        { value: "Short QT", label: "SVT" },
        { value: "Irregular PR", label: "2AVB" },
        { value: "Irregular RR", label: "CHB" },
      ],

      arrythymia_array: [],
      profileLink: "/verifier-profile",
      clickdb: "",
      treemenu: [],
      clickedPI: "", //used in updateState()
      rpeaks: [], //For Summar Tab
      arrythymia_type: [],
      databaseid: "",
      reoprtLink: "",
      reportLinkStatus: 0,
      reportStatus: "",
      x: 0,
      y: 0,
      images: {},
      imagess: {},
      endpoint: "localhost:5000",
      datasets: {},
      dblink: "", // check whether it is same as the previous databaseid
      nextDbId: "",
      prevDbId: "",
      fullVerifyStatus: 100,
      chart: "",
      isModalOpen: false,
      isModalReportOpen: false,
      ismodaldisOpen: false,
      isModaldataOpen: false,
      isModalInsideOpen: false,
      rpeak_index: "",

      result3: [],
      charts: [],
      valueList: [],
      stripcount: 1,
      labelinfo: "Yes",
      graph_color: 'Normal',
      sel_arr: "CURRENT",
      arr_list: "CURRENT",
      newName: "CURRENT",
      starr: [],
      errors: {},
      defarr: [],
      selectedChart: 0, //Check Whether it is needed
      mainEcgArray: [],
      mainActivityArray: [],
      datasetMnt: 0, //Check whether we need a state variable for this
      currentTab: "chart_tab_2",
      start: 0,
      end: 9,
      starttime: [],
      endtime: [],
      limitScrollStart: 1,
      limitScrollEnd: 1,
      peakStart: 0,
      graphMarker: {},
      patientMenuTree: {},
      verifyCheck: "",
      patientReportStatus: "",
      scrollStatus: "", //Remove this variable's usages then delete this
      summaryData: "",
      minMaxHrDataCurr: "",
      minMaxHrDataFull: "",
      heartRatesData: "",
      patientwrkdetails: "",
      patientwrktotaldetails: "",
      patientwrkdailydetails: "",
      arrCount: "",
      keyIntegrationStatus: 0,
      responseMessage: "",
      showModalSpinner: false,
      beat_order: 0,
      threshold: 0.86,
      superimposeStatus: "unverify",
      superimpose_start_date: "",
      superimpose_end_date: "",
      superimpose_apply: "no",
      preMS: 200,
      postMS: 450,
      availableTimeOptions: [],
      superimposeErrorMessage: "",
      superimposePreviewModal: false,
      superimposeMatchingBeats: null,
      superimposeLoading: false,
      superimposeConfig: null,
      afibDbStartTime: "",
      afibDbEndTime: "",
      afibStatus: "unverify",
      afibApply: "no",
      afibOutputModalOpen: false,
      afibOutputText: "",
      vtDbStartTime: "",
      vtDbEndTime: "",
      vtStatus: "unverify",
      vtApply: "no",
      vtOutputModalOpen: false,
      vtOutputText: "",
      twoDDbStartTime: "",
      twoDDbEndTime: "",
      twoDStatus: "unverify",
      twoDApply: "no",
      arrModalOpen: false,
      arrLabel: "Afib",
      arrStartTime: "",
      arrEndTime: "",
      arrStatus: "unverify",
      arrApply: "no",
      twoDOutputModalOpen: false,
      twoDOutputText: "",
      missedBeatLoading: false,
      missedBeatOutputText: "",
      missedBeatOutputModalOpen: false,
      missedBeatsStartTime: "",
      missedBeatsEndTime: "",
      missedBeatsStatus: "0",
      removeHrStartDate: "",
      removeHrEndDate: "",
      removeHrStatus: "0",
      removeHrApply: false,
      removeHrMissedBeat: 0,
      removeHrOutputModalOpen: false,
      removeHrOutputText: "",
      removeHrIncludeArr: [],
      removeHrExcludeArr: [],
      hrgt: 0,
      hrlt: 0,
      beatgt: 0,
      beatlt: 0,
      checkArr: "equal",
      qRecatArr: "Current",
      fullCurrent: "Current",
      newArr: "un",
      newArrhy: "PVC",

      lowr: 0,
      highr: 0,
      response: "",
      showResponseModal: false,
      popupX: 0,
      popupY: 0,
      full_current: "Current",
      prev_arh: "Current",
      next_arh: "Current",
      low_2_high: 0,
      high_2_high: 0,
      verifiedStatus: "",
      //minmaxhr state initialize
      afibMinHr: null,
      afibMaxHr: null,
      iprMinHr: null,
      iprMaxHr: null,
      irrMinHr: null,
      irrMaxHr: null,
      pacMinHr: null,
      pacMaxHr: null,
      pvcMinHr: null,
      pvcMaxHr: null,
      stMinHr: null,
      stMaxHr: null,
      spMinHr: null,
      spMaxHr: null,
      nsrMinHr: null,
      nsrMaxHr: null,
      pqtMinHr: null,
      pqtMaxHr: null,
      pabsentMinHr: null,
      pabsentMaxHr: null,
      sqtMinHr: null,
      sqtMaxHr: null,
      vtMinHr: null,
      vtMaxHr: null,
      sbMinHr: null,
      sbMaxHr: null,
      selectedstarttime: null,
      selectedendtime: null,
      verifierNameData: [],
      isCommentModalOpen: false,
      comments: "",
      newComment: "",
      patient_name: "",
      device_id: "",
      showVerifierModal: false,
      verifiersList: [],
      selectedVerifiers: [],
      verifiertype: localStorage.getItem("verifiertype") || "",
      verifierid: localStorage.getItem("verifierid") || "",
      verifiername: localStorage.getItem("verifiername") || "",
    };

    /********* State Variables*************/
    this.fetchminmaxHr = this.fetchminmaxHr.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.openChartPopup = this.openChartPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.clearSelectionState = this.clearSelectionState.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleModalInside = this.handleModalInside.bind(this);
    this.resetModal = this.resetModal.bind(this);
    this.resetModalReport = this.resetModalReport.bind(this);
    this.resetModalData = this.resetModalData.bind(this);
    this.resetmodaldis = this.resetmodaldis.bind(this);
    this.handleDiary = this.handleDiary.bind(this);
    this.updateState = this.updateState.bind(this);
    this.selectImage = this.selectImage.bind(this);
    this.updateRpeaks = this.updateRpeaks.bind(this); //saves peakvalues to state variable
    this.generateReport = this.generateReport.bind(this); //Executes on Generate Report Button
    this.fulldisclosure = this.fulldisclosure.bind(this);
    // mailReport binding removed (mail icon removed from UI)
    this.newDataClick = this.newDataClick.bind(this); //For navigation to Next/Previous database.Currently displayed None
    this.updateMainChartODC = this.updateMainChartODC.bind(this); //Exeutes On Double click on Event Image within updateState()
    this.recategorizeAfterImage = this.recategorizeAfterImage.bind(this);
    this.captureImage = this.captureImage.bind(this);
    this.quickRecat = this.quickRecat.bind(this);
    this.saveQuickRecatPreset = this.saveQuickRecatPreset.bind(this);
    this.resetQuickRecatPreset = this.resetQuickRecatPreset.bind(this);
    this.enableKey = this.enableKey.bind(this);
    this.onStarttimeChange = this.onStarttimeChange.bind(this);
    this.onEndtimeChange = this.onEndtimeChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.removeHrSubmit = this.removeHrSubmit.bind(this);
    this.missedBeatsSubmit = this.missedBeatsSubmit.bind(this);
    this.handleRemoveHrIncludeChange = this.handleRemoveHrIncludeChange.bind(this);
    this.handleRemoveHrExcludeChange = this.handleRemoveHrExcludeChange.bind(this);
    this.getverifierName = this.getverifierName.bind(this);
    // this.closeModal = this.closeModal.bind(this);
    this.submitcommentinfo = this.submitcommentinfo.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.handleAssignVerifierClick = this.handleAssignVerifierClick.bind(this);
    this.closeVerifierModal = this.closeVerifierModal.bind(this);
    this.handleVerifierChange = this.handleVerifierChange.bind(this);
    this.submitVerifierAssignment = this.submitVerifierAssignment.bind(this);
  }

 async handleAssignVerifierClick() {
  const userid = this.props.match.params.userid;

  try {
    const response = await axios.get(
      `${apiUrl}api/users/allverifiers`
    );

    const formattedVerifiers = response.data.map(v => ({
      value: v._id,
      label: v.name,
      patients: v.patients || []
    }));

    const filteredVerifiers = formattedVerifiers.filter(
      v => v.patients.indexOf(userid) !== -1
    );

    this.setState({
      showVerifierModal: true,        // ✅ open AFTER load
      verifiersList: formattedVerifiers,
      selectedVerifiers: filteredVerifiers
    });

  } catch (error) {
    toast.error("Failed to load verifiers list.");
  }
}



  closeVerifierModal() {
    this.setState({ showVerifierModal: false, selectedVerifiers: [] });
  }

  handleVerifierChange(selectedOptions) {
    this.setState({ selectedVerifiers: selectedOptions });
  }

  async submitVerifierAssignment() {
    // Logic to assign verifiers
    // console.log("Selected Verifiers:", this.state.selectedVerifiers);
    // console.log("userid:", this.props.match.params.userid);
const pids = this.props.match.params.userid;
const vids = this.state.selectedVerifiers.map(v => v.value);
 
try {
  const response = await axios.post(
    `${apiUrl}api/common/assign_Verifiers`,
    {
      userid: pids,
      assignedVerifiers: vids
    }
  );
 
  toast.success("Verifiers Assigned Successfully");
} catch (error) {
  // toast.error("Failed to assign verifiers");
}
 
    this.closeVerifierModal();
  }

  setTab(e) {
    var currentTab = e.currentTarget.id;
    this.setState({
      currentTab: currentTab,
    });
    if (
      e.currentTarget.id == "chart_tab_2" &&
      this.props.match.params.start == undefined
    ) {
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="eventsimg" src="../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="beatsimg" src="../../dist/img/BeatsSelect.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../dist/img/Summary.png"/>';
      // document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../dist/img/SelectedEvents.png"/>';
      //    if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../dist/img/Email.png\"/>";}
      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../dist/img/AddFindings.png"/>';
      this.fetchminmaxHr();
    }
    if (
      e.currentTarget.id == "chart_tab_2" &&
      this.props.match.params.start != undefined
    ) {
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="eventsimg" src="../../../../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="beatsimg" src="../../../../../dist/img/BeatsSelect.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../../../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../../../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../../../../dist/img/SelectedEvents.png"/>';
      //   if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../../../../dist/img/Email.png\"/>";}
      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../../../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../../../../dist/img/AddFindings.png"/>';
    } else if (
      e.currentTarget.id == "chart_tab_1" &&
      this.props.match.params.start == undefined
    ) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../dist/img/EventsSelected.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../dist/img/Summary.png"/>';
      // document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../dist/img/SelectedEvents.png"/>';
      //   if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../dist/img/Email.png\"/>";}
      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../dist/img/AddFindings.png"/>';
    } else if (
      e.currentTarget.id == "chart_tab_1" &&
      this.props.match.params.start != undefined
    ) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../../../../dist/img/EventsSelected.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../../../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../../../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../../../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../../../../dist/img/SelectedEvents.png"/>';
      //  if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../../../../dist/img/Email.png\"/>";}
      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../../../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../../../../dist/img/AddFindings.png"/>';
    } else if (
      e.currentTarget.id == "chart_tab_findings" &&
      this.props.match.params.start == undefined
    ) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../dist/img/SelectedEvents.png"/>';
      //    if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../dist/img/Email.png\"/>";}
      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../dist/img/AddFindings_white.png"/>';
    } else if (
      e.currentTarget.id == "chart_tab_findings" &&
      this.props.match.params.start != undefined
    ) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../../../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../../../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../../../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../../../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../../../../dist/img/SelectedEvents.png"/>';
      //       if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../../../../dist/img/Email.png\"/>";}
      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../../../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../../../../dist/img/AddFindings_white.png"/>';
    }

    //  else if(e.currentTarget.id=="chart_tab_settings" && this.props.match.params.start==undefined)
    // {
    //     document.getElementById("chart_tab_1").innerHTML="<img id=\"eventsimg\" src=\"../../dist/img/Events.png\"/>";
    //     document.getElementById("chart_tab_2").innerHTML="<img id=\"beatsimg\" src=\"../../dist/img/Beats.png\"/>";
    //     document.getElementById("chart_tab_3").innerHTML="<img id=\"summaryimg\" src=\"../../dist/img/Summary.png\"/>";
    //      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../dist/img/HeartRate.png\"/>";
    //     document.getElementById("chart_tab_5").innerHTML="<img id=\"selectimg\" src=\"../../dist/img/SelectedEvents.png\"/>";
    //     if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../dist/img/Email.png\"/>";}
    //     //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../dist/img/Settings_white.png\"/>";
    //       if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML="<img id=\"addFindImg\" src=\"../../dist/img/AddFindings.png\"/>";

    // }
    // else if(e.currentTarget.id=="chart_tab_settings" && this.props.match.params.start!=undefined)
    // {
    //     document.getElementById("chart_tab_1").innerHTML="<img id=\"eventsimg\" src=\"../../../../../dist/img/Events.png\"/>";
    //     document.getElementById("chart_tab_2").innerHTML="<img id=\"beatsimg\" src=\"../../../../../dist/img/Beats.png\"/>";
    //     document.getElementById("chart_tab_3").innerHTML="<img id=\"summaryimg\" src=\"../../../../../dist/img/Summary.png\"/>";
    //      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../../../../dist/img/HeartRate.png\"/>";
    //     document.getElementById("chart_tab_5").innerHTML="<img id=\"selectimg\" src=\"../../../../../dist/img/SelectedEvents.png\"/>";
    //     if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../../../../dist/img/Email.png\"/>";}
    //     //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../../../../dist/img/Settings_white.png\"/>";
    //       if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML="<img id=\"addFindImg\" src=\"../../../../../dist/img/AddFindings.png\"/>";

    // }
    else if (
      e.currentTarget.id == "chart_tab_8" &&
      this.props.match.params.start == undefined
    ) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../dist/img/SelectedEvents.png"/>';
      //    if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../dist/img/Email.png\"/>";}

      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../dist/img/AddFindings.png"/>';
    } else if (
      e.currentTarget.id == "chart_tab_8" &&
      this.props.match.params.start != undefined
    ) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../../../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../../../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../../../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../../../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../../../../dist/img/SelectedEvents.png"/>';
      //  if(document.getElementById("chart_tab_email")!=null){document.getElementById("chart_tab_email").innerHTML="<img id=\"emailImg\" src=\"../../../../../dist/img/Email.png\"/>";}
      //  document.getElementById("chart_tab_settings").innerHTML="<img id=\"settingsImg\" src=\"../../../../../dist/img/Settings.png\"/>";
      if (document.getElementById("chart_tab_findings")) document.getElementById("chart_tab_findings").innerHTML =
        '<img id="addFindImg" src="../../../../../dist/img/AddFindings.png"/>';
    }

    window.prev_tab = window.tab;
    window.tab = e.currentTarget.innerHTML;
    //console.log('window.tab Inside', window.prev_tab);
  }

  selectImage(e) {
    var folder = window.eventclass;
    /*console.log(folder);
        console.log(e.currentTarget.className.split(" ")[3]);*/
    if (e.currentTarget.className.split(" ")[3] == folder) {
      if (e.currentTarget.childNodes[1].checked == true) {
        e.currentTarget.childNodes[1].checked = false;
      } else {
        e.currentTarget.childNodes[1].checked = true;
      }
    } else {
      e.currentTarget.childNodes[1].checked = false;
    }
  }
  handlearrythymiaChange = (selectedOptions) => {
    const valueList = selectedOptions.map((option) => option.value);
    this.setState({ valueList: valueList });
    this.setState({ arrythymia_array: selectedOptions || [] });
  };
  updateState(e) {
    window.prev_tab = window.tab;
    window.tab = "Events";
    var clickedPI = e.currentTarget.id.toString();
    var clickedPI_ =
      clickedPI.substring(0, 2) +
      ":" +
      clickedPI.substring(2, 4) +
      ":" +
      clickedPI.substring(4, 6);
    var userid = this.props.match.params.userid;
    var databaseid = this.props.match.params.databaseid;
    var usSelf = this;

    if (typeof databaseid === "undefined") {
      databaseid = "0";
    }
    const data = {
      userid: userid,
      databaseid: databaseid,
      clickedPI_: clickedPI_,
    };
    // console.log('clickedPI_', clickedPI_);
    axios
      .post(apiUrl + "api/common/getRpeakIndex", data)
      .then((response) => {
        var raw = response && response.data && response.data.rpeakindex;
        // null/undefined is the backend's "no beat at this time" signal.
        // Number(null) returns 0 which would silently navigate to strip 0
        // — explicitly reject those before coercing.
        if (raw == null) {
          // eslint-disable-next-line no-console
          console.warn(
            "[updateState] no rpeakindex for " + clickedPI_ +
            " — response: " + JSON.stringify(response && response.data)
          );
          return;
        }
        var rpeakIdx = Number(raw);
        if (!Number.isFinite(rpeakIdx) || rpeakIdx < 0) {
          // eslint-disable-next-line no-console
          console.warn(
            "[updateState] invalid rpeakindex for " + clickedPI_ +
            ": " + raw + " (parsed as " + rpeakIdx + ")"
          );
          return;
        }

        document.getElementById("chart_tab_2").click();

        // Single math path — Math.floor handles every case including 0
        // and exact multiples of deviceFrequency. The old `if > 15000`
        // gate was redundant.
        var stripIndex = Math.max(0, Math.floor(rpeakIdx / 15000));
        window.chartid = 0;
        window.stripXValue = rpeakIdx - stripIndex * 15000;
        var start = stripIndex;
        var end   = stripIndex + 9;
        window.container = start;

        usSelf.setState({ start: start, end: end });

        // Match the original 1000ms timing — the strip charts plus their
        // layout pass need that long to settle. But REMOVE the old
        // prevStart-comparison that silently skipped the scroll on:
        //   • first navigation (prevStart undefined)
        //   • repeat clicks on the same image (prevStart === start)
        //   • diff == 0 (target already perfectly aligned)
        // Now we always perform the scroll once the timeout fires.
        setTimeout(function () {
          var $selWrap = $("#selWrap");
          var $target  = $("#container" + start);
          if ($selWrap.length === 0 || $target.length === 0) {
            // eslint-disable-next-line no-console
            console.warn(
              "[updateState] container/selWrap missing for start=" + start
            );
            return;
          }
          try {
            $selWrap.scrollTop(0);
            $selWrap.scrollTop(
              $target.position().top - $selWrap.position().top
            );
            window.prevStart = start;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("[updateState] scroll failed:", e.message);
          }
        }, 1000);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("[updateState] getRpeakIndex failed:", err.message);
      });
  }

  updateMainChartODC(starts, ends) {
    var userid = userid;
    var mainEcgArray,
      mainActivityArray = [];
    var result,
      result2,
      result3,
      colorArray = [];
    var chart;

    var tonarr = [],
      rarr = [];

    // var parr = [],
    //     tarr = [],
    //     qarr = [],
    //     rarr = [],
    //     sarr = [],
    //     ponarr = [],
    //     poffarr = [],
    //     tonarr = [],
    //     toffarr = [],
    //     jarr = [];
    var peakColorArray = [];
    peakColorArray["Normal Sinus Rhythm"] = "#3D761D";
    peakColorArray["Sinus Tachycardia"] = "#00FFFF";
    peakColorArray["Sinus Bradycardia"] = "#FF9900";
    peakColorArray["PAC"] = "#0000FF";
    peakColorArray["PVC"] = "#FF00FF";
    peakColorArray["Ventricular Tachycardia"] = "#A64D79";
    peakColorArray["AFib"] = "#9900FF";
    peakColorArray["Sinus Pause"] = "#FF0000";
    peakColorArray["P Absent"] = "#bfbebb";
    peakColorArray["Irregular RR"] = "#7F6000";
    peakColorArray["Irregular PR"] = "#351C75";
    peakColorArray["Short QT"] = "#980000";
    peakColorArray["Prolonged QT"] = "#46BDC6";
    peakColorArray["Paced"] = "#FF0000";
    peakColorArray["Undiagnosed"] = "#FFD966";

    function chunkPeakArray(peakArray, start = 0) {
      //console.log(peakArray);
      let presults = [];
      var minIndex = 0;
      var breakVal = deviceFrequency * (window.pageIndex + 1);
      var z;
      var temRpeakindex;

      presults.push([]);
      for (var i = 0; i < peakArray.length; i++) {
        if (window.pageIndex * deviceFrequency < peakArray[i].rpeakindex) {
          if (peakArray[i].rpeakindex > breakVal) {
            presults.push([]);
            minIndex = minIndex + 1;
            breakVal = breakVal + deviceFrequency;
          }
          /*console.log(peakArray[i].rpeakindex);
                    console.log(minIndex);
                    console.log(peakArray[i].rpeakindex);
                    console.log(deviceFrequency);*/
          temRpeakindex =
            parseInt(peakArray[i].rpeakindex) -
            (minIndex + window.pageIndex) * deviceFrequency;
          presults[minIndex].push({
            x: temRpeakindex,
            y: parseFloat(0.8),
            color: peakColorArray[peakArray[i].arrhythmia],
            beat: parseInt(peakArray[i].indexcounter),
            hr: parseInt(peakArray[i].heartrate),
            rr: parseInt(peakArray[i].rr_interval),
            arrhythmia: peakArray[i].arrhythmia,
            peaktime: peakArray[i].peaktime,
          });
        }
      }
      return presults;
    }
    var sliceStart = 0;
    var sliceEnd = sliceStart + 15001;
    var sliceActStart = 0;
    var sliceActEnd = sliceActStart + 61;
    var currentEcgArray = this.ecgValues.slice(sliceStart, sliceEnd);
    var currentActArray = this.activityValues.slice(sliceActStart, sliceActEnd);

    //console.log(sliceStart+" "+sliceEnd);
    var tempChart;
    var colorArray = ["#98FB98", "#f1e4e4", "#f7e0a3", "#f09c67"];

    /* if (val - 500 <= 0) {
               this.state.chart.xAxis[0].setExtremes(val, val + 1000, true, false);
             } else {
               this.state.chart.xAxis[0].setExtremes(val - 500, val + 500);
             }*/

    var acti = 125;
    var actarr = [];
    var tttarr1 = [];

    for (var i = 0; i < currentActArray.length; i++) {
      actarr.push({
        x: acti,
        y: 0.5,
        color: colorArray[currentActArray[i]],
      });
      acti = acti + 150;
    }

    var prevChart = window.prevChart;
    if (window.beatArr.length > 0 && window.container != window.prevChart) {
      var popupCh =
        (typeof window !== "undefined" && window.popupChart) ||
        this.state.chart ||
        null;
      if (popupCh && popupCh.xAxis && popupCh.xAxis[0]) {
        for (var i = 0; i < window.beatArr.length; i++) {
          var j = window.container * deviceFrequency;
          var xBeat = parseInt(window.beatArr[i]) - j;
          popupCh.xAxis[0].removePlotBand("plotband-" + xBeat);
        }
      }
    }

    var currentDataSet = [];
    var self = this;

    this.state.chart.series[0].setData(currentEcgArray, false);
    this.state.chart.series[1].setData(actarr, false);
    
    // Safely set result3 data
    if (this.state.result3 && this.state.result3[0]) {
      this.state.chart.series[2].setData(this.state.result3[0], true);
    } else {
      this.state.chart.series[2].setData([], true);
    }
    
    // Safely set rarr data
    if (this.state.rarr && this.state.rarr[starts]) {
      this.state.chart.series[5].update(
        {
          data: this.state.rarr[starts],
        },
        false
      );
    } else {
      this.state.chart.series[5].update(
        {
          data: [],
        },
        false
      );
    }
    // this.state.chart.series[6].update({
    //     data: this.state.sarr[starts],
    // }, false);
    // this.state.chart.series[7].update({
    //     data: this.state.tarr[starts],
    // }, false);
    // this.state.chart.series[8].update({
    //     data: this.state.ponarr[starts],
    // }, false);
    // this.state.chart.series[9].update({
    //     data: this.state.poffarr[starts],
    // }, false);
    // this.state.chart.series[10].update({
    //     data: this.state.tonarr[starts],
    // }, false);
    // this.state.chart.series[11].update({
    //     data: this.state.toffarr[starts],
    // }, false);
    // this.state.chart.series[12].update({
    //     data: this.state.jarr[starts],
    // }, true);
    // this.state.chart.series[12].update({
    //     data: [],
    // }, true);
    var chart1 = this.state.charts[0];
    var tempChart = this.state.charts[window.prevChart];

    var lineWidth = 2;

    if (this.state.charts[window.prevChart] != undefined) {
      if (this.state.charts[window.prevChart].draggablePlotLine != undefined) {
        this.state.charts[window.prevChart].draggablePlotLine.destroy();
      }
    }
    if (this.props.match.params.start != undefined && window.diaryFlag == 1) {
      window.diaryFlag = 2;
      window.stripXValue = this.props.match.params.xValue;
    }
    this.state.charts[0].draggablePlotLine = this.state.charts[0].renderer
      .rect(
        this.state.charts[0].xAxis[0].toPixels(window.stripXValue) -
        this.state.charts[0].xAxis[0].toPixels(25),
        10,
        50,
        40,
        5
      )
      .attr({
        "stroke-width": 2,
        opacity: 0.5,
        fill: "grey",
        zIndex: 3,
      })
      .add();
    window.prevChart = 0;
    if (window.stripXValue + 500 > 15000) {
      this.state.chart.xAxis[0].setExtremes(
        window.stripXValue - 2250,
        window.stripXValue,
        true,
        false
      );
    } else {
      this.state.chart.xAxis[0].setExtremes(
        window.stripXValue - 1125,
        window.stripXValue + 1125,
        true,
        false
      );
    }

    if (this.state.charts[0].container.onmousemove != undefined) {
      this.state.charts[0].container.onmousemove = function (e) {
        return false;
      };
    }
    var mainCChart = this.state.chart;
    this.state.charts[0].container.onmousemove = function (e) {
      if (chart1.draggablePlotLine.drag) {
        let normalizedEvent = chart1.pointer.normalize(e),
          extremes = {
            left: chart1.plotLeft,
            right: chart1.plotLeft + chart1.plotWidth,
          };
        if (e.chartX >= extremes.left && e.chartX <= extremes.right) {
          var pointValue = chart1.xAxis[0].toValue(e.chartX);
          if (pointValue - 500 <= 0) {
            mainCChart.xAxis[0].setExtremes(
              pointValue,
              pointValue + 2250,
              true,
              false
            );
          } else {
            mainCChart.xAxis[0].setExtremes(
              pointValue - 1125,
              pointValue + 1125,
              true,
              false
            );
          }
          chart1.draggablePlotLine.attr({
            x: e.chartX,
          });
        }
      }
    };

    this.state.charts[0].draggablePlotLine.element.onmousedown = function () {
      chart1.draggablePlotLine.drag = true;
    };

    this.state.charts[0].draggablePlotLine.element.onmouseup = function () {
      chart1.draggablePlotLine.drag = false;
    };
  }

  updateRpeaks(data) {
    this.setState({
      rpeaks: data,
    });
  }
  getInfo() {
    const userid = this.props.match.params.userid;
    axios
      .get(`${apiUrl}api/common/GetVerifierComments?userid=${userid}`)
      .then((res) => {
        this.setState({
          comments: res.data.comments || "",
          patient_name: res.data.name || "",
        });
      })
      .catch((error) => {
      });
  }

  generateReport(e) {
    // NOTE: do not mutate the button DOM here — React owns it.
    // Generation progress is shown via the modal's own progress bar
    // (AddModalReport). The toolbar button stays as "Generate Report"
    // throughout — no swap to "Please Wait" any more (the swap could
    // get stuck if reportStatus didn't refresh in state).
    if (e && e.preventDefault) e.preventDefault();
    this.setState({ isModalReportOpen: true });
  }

  fulldisclosure(e) {
    // Same fix as generateReport: never touch innerHTML directly.
    // The Full Disclosure modal handles its own spinner / progress UI,
    // so the toolbar button just opens the modal and stays as-is.
    if (e && e.preventDefault) e.preventDefault();
    this.setState({ ismodaldisOpen: true });
  }
  // mailReport handler removed (mail icon removed from UI)

  splitFn(value) {
    var res = value.split("_");
    var name =
      res[0].substring(0, 4) +
      "-" +
      res[0].substring(4, 6) +
      "-" +
      res[0].substring(6, 8) +
      " :: " +
      res[1].substring(0, 2) +
      ":" +
      res[1].substring(2, 4) +
      ":" +
      res[1].substring(4, 6);
    res[0] = name;
    return res;
  }

  resetGraph(e) {
    var it = 0;
    var currentChart = this.state.charts;
    var currentNsrarr = this.state.defarr;
    var myRGVar = setInterval(function () {
      currentChart[it].series[0].setData(currentNsrarr[it], true);
      it = it + 1;
      if (it > currentNsrarr.length - 1) {
        clearInterval(myRGVar);
      }
    }, 10);
  }
  async submitcommentinfo(e) {
    const userid = this.props.match.params.userid;
    const newText = (this.state.newComment || "").trim();
    if (!newText) return;
    const verifiername = this.state.verifiername || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", {
      day: "2-digit", month: "short",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    const existing = (this.state.comments || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;
    try {
      await axios.post(`${apiUrl}api/patients/addComment/${userid}`, { comments });
      this.setState({ newComment: "", comments, isCommentModalOpen: false });
    } catch (error) {
    }
  }

  colorGraph(e) {
    var selector = e.currentTarget.value;
    window.sel = selector;
    if (selector == "Sinus Tachycardia") {
      var it = 0;
      var currentChart = this.state.charts;
      var currentStarr = this.state.starr;
      graphColor = "starr";
      var myCGVar = setInterval(function () {
        currentChart[it].series[0].setData(currentStarr[it], true);
        it = it + 1;
        if (it > currentStarr.length - 1) {
          clearInterval(myCGVar);
        }
      }, 1);
    }
  }

  addBeatToReport(e) {
    var beats = window.beatArr;
    var databaseid = this.state.databaseid;
    var userid = this.props.match.params.userid;
    if (beats.length > 0) {
      const data = {
        databaseid: databaseid,
        beats: beats,
        userid: userid,
      };
      axios
        .post(apiUrl + "api/common/addBeatToReport", data)
        .then((res) => {
          var currentChart = window.prevChart;
          var minus_val =
            (parseInt(window.pageIndex) + parseInt(window.prevChart)) *
            deviceFrequency;
          for (var i = 0; i < beats.length; i++) {
            this.state.chart.xAxis[0].removePlotBand(
              "plotband-" + (beats[i] - minus_val)
            );
          }
          window.beatArr = [];
        })
        .catch((err) => {
        });
    }
  }
  async generateEvents(e) {
    const databaseid = this.state.databaseid;
    const userid = this.props.match.params.userid;
    const element = e.currentTarget;
    element.innerHTML = "Please Wait...";

    try {
      const response = await axios.post(
        `${apiUrl}api/graph/GenerateEvent_New`,
        {
          userid,
          databaseid,
        }
      );
    } catch (err) {
      element.innerHTML = "Generate Events"; // Reset button in case of error
      return;
    } finally {
      // This block runs regardless of success or failure above
      const newCon = this;
      worker4.postMessage({
        name: "getfolderfiles",
        url: `${apiUrl}api/common/getfolderfiles_New?userid=${userid}&databaseid=${databaseid}`,
      });

      worker4.onmessage = function () { }; // Optional placeholder

      worker4.addEventListener("message", function (res) {
        newCon.setState({
          images: res.data[0],
          dblink: res.data[1],
          device_id: res.data[2],
        });
        newCon.filter1(window.filterId);
        element.innerHTML = "Generate Events"; // Reset button after everything is done
      });
    }
  }

 listenScrollEvent(e) {
    var databaseid = this.state.databaseid;
    var userid = this.props.match.params.userid;
    var dis = this;
    var ee = e.target;

    var element_height = 53.6833333;
    var positive = Math.abs(ee.scrollTop);
    var divided = positive / element_height;

    var round = divided != 0 ? Math.floor(divided) : 0;

    if (window.timer !== null) {
      clearTimeout(window.timer);
    }

    window.timer = setTimeout(function () {
      var height = document.getElementById("selWrap").scrollHeight;

      round = Math.floor(positive / (height / window.sc));
      var start = round;
      var end = round + 9;

      // Calculate available space
      var totalScrollableHeight = height;
      var currentScrollPosition = ee.scrollTop + ee.clientHeight;
      var availableSpace = totalScrollableHeight - currentScrollPosition;

      dis.setState({
        start: start,
        end: end,
        availableSpace: availableSpace, // Update state with available space
      });
      //console.log("start!!!!!!!!!!!!",start)

      //console.log("end!!!!!!!!!!", end);
      // Log available space
      dis.renderNewSmallCharts();
    }, 500);
  }


  recategorize(e) {
    var beats = window.beatArr;
    var databaseid = this.state.databaseid;
    var userid = this.props.match.params.userid;
    var arrhythmia = e.currentTarget.value;
    if (beats.length > 0) {
      const data = {
        databaseid: databaseid,
        beats: beats,
        arrhythmia: arrhythmia,
        userid: userid,
      };
      axios
        .post(apiUrl + "api/common/updateVerifierArrhythmia", data)
        .then((res) => {
          var stripvalue_resume = parseInt(window.container);
          var xvalue_resume = beats[beats.length - 1];
          axios
            .get(
              apiUrl +
              "api/common/updateResumeInfo?databaseid=" +
              databaseid +
              "&userid=" +
              userid +
              "&stripvalue_resume=" +
              stripvalue_resume +
              "&xvalue_resume=" +
              xvalue_resume
            )
            .then((res) => { })
            .catch((err) => { });

          // Drop ALL selection state (beatArr, selectedBeatNumber,
          // every plotband regardless of id pattern). The old per-id
          // removePlotBand loop only worked for the ±100 single-click
          // ids — it left marquee bands (different widths/ids) behind.
          this.clearSelectionState();
        })
        .catch((err) => {
        });
    }
  }
  recategorizeAfterImage(arr) {
    var beats = window.beatArr;
    var databaseid = this.state.databaseid;
    var userid = this.props.match.params.userid;

    if (beats.length > 0) {
      const data = {
        databaseid: databaseid,
        beats: beats,
        arrhythmia: arr,
        userid: userid,
      };
      axios
        .post(apiUrl + "api/common/updateVerifierArrhythmia", data)
        .then((res) => {
          // Drop full selection state (beatArr + plotbands) so the
          // popup doesn't hold stale picks after the label is applied.
          this.clearSelectionState();
        })
        .catch((err) => {
        });
    }
  }

  verify(e) {
    var databaseid = this.state.databaseid;
    var userid = this.props.match.params.userid;
    const verifiedtime = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
      hour12: false,
    });
    const verifytime = verifiedtime.replace("PM", "").replace(",", "").trim();
    const verifierid = this.state.verifierid;
    const verifierName = this.state.verifiername;
    const data = {
      databaseid: databaseid,
      userid: userid,
      verifyTime: verifytime,
      verifierId: verifierid,
      verifierName: this.state.verifiername,
    };
    axios
      .post(apiUrl + "api/common/verifyArrhythmia_nameNew", data)
      .then((res) => {
        $("#verfiyBtn").css("display", "none");
        $("#verifyBtn").css("display", "none");

        this.checkFullVerify();
      })
      .catch((err) => {
      });
  }

  gainBtn(e) {
    var buttonId = e.currentTarget.id;
    var gainValue = document.getElementById("gainValue").value;
    var it = 0;
    var charts = this.state.charts;
    var arCount = this.state.datasetMnt - 1;
    if (gainValue == 1) {
      gainMin = -0.0005;
      gainMax = 0.0015;
    } else if (gainValue == 2) {
      gainMin = -0.0005;
      gainMax = 0.0008;
    } else if (gainValue == 3) {
      gainMin = -0.0005;
      gainMax = 0.0005;
    }

    var scaleUp = setInterval(function () {
      charts[it].update({
        yAxis: [
          {
            min: gainMin,
            max: gainMax,
          },
        ],
      });
      it = it + 1;
      if (it > arCount) {
        clearInterval(scaleUp);
      }
    }, 1);
  }

  checkFullVerify() {
    var fullVerify = this;
    worker15.postMessage({
      name: "checkFullVerify",
      url:
        apiUrl +
        "api/common/checkFullVerify?userid=" +
        this.props.match.params.userid,
    });
    worker15.onmessage = function (event) { };
    worker15.addEventListener("message", function (res) {
      fullVerify.setState({
        fullVerifyStatus: res.data,
      });
    });
    // axios
    //     .get(apiUrl + 'api/common/checkFullVerify?userid=' + this.props.match.params.userid)
    //     .then(res => {
    //         this.setState({
    //             fullVerifyStatus: res.data
    //         })
    //     })
    //     .catch(err => {
    //         console.log(err)
    //     });
  }
  renderResumeChart(userid, dbId, cont, strip_val) {
    var newThis = this,
      val,
      colorArray = [];
    window.chartid = 0;
    window.container = cont; //container id stored in global variable
    //    console.log('window.container', window.container);
    window.stripXValue = strip_val - cont * 15000; //got the location in the xaxis
    /*************Remove Plotband***********************/

    if (window.beatArr.length > 0 && window.chartid != window.prevChart) {
      for (var i = 0; i < window.beatArr.length; i++) {
        var j = window.container * deviceFrequency;
        var xBeat = parseInt(window.beatArr[i]) - j;

        window.chart.xAxis[0].removePlotBand("plotband-" + xBeat);
      }
      //document.getElementById("beatSlected").value='[]';
      // beatArr=[];
    }

    /*************Remove Plotband***********************/
    if (newThis.state.charts[window.container]) {
      val = newThis.state.charts[window.container].xAxis[0].toValue(
        window.stripXValue
      );
    }

    //console.log(selfNew.state.mainEcgArray);
    var sliceStart = cont * deviceFrequency;
    var sliceEnd = sliceStart + deviceFrequency + 1;
    var sliceActStart = window.container * 60;
    var sliceActEnd = sliceActStart + 61;
    //console.log('window.stripXValue', strip_val);
    /*console.log('sliceStart',sliceEnd);
        console.log('mainEcgArray Two',newThis.state.mainEcgArray);*/
    var ecgArray = newThis.state.mainEcgArray.slice(0, 15001);
    var curActArray = newThis.state.mainActivityArray.slice(0, 61);

    if (val > ecgArray.length) {
      val = ecgArray.length - 500;
    }

    var acti = 125;
    var actarr = [];
    var tttarr1 = [];
    /*console.log('container',window.container);
        console.log(newThis.state.rarr[window.dataArrInd]);*/

    for (var i = 0; i < curActArray.length; i++) {
      actarr.push({
        x: acti,
        y: 0.5,
        color: colorArray[curActArray[i]],
      });
      acti = acti + 250;
    }

    //console.log(result3[window.container]);
    newThis.state.chart.series[0].setData(ecgArray, false);
    newThis.state.chart.series[1].setData(actarr, false);
    
    // Safely set result3 data
    if (newThis.state.result3 && newThis.state.result3[0]) {
      newThis.state.chart.series[2].setData(newThis.state.result3[0], false);
    } else {
      newThis.state.chart.series[2].setData([], false);
    }
    
    // Safely set rarr data
    if (newThis.state.rarr && newThis.state.rarr[window.container]) {
      newThis.state.chart.series[5].update(
        {
          data: newThis.state.rarr[window.container],
        },
        false
      );
    } else {
      newThis.state.chart.series[5].update(
        {
          data: [],
        },
        false
      );
    }
    // newThis.state.chart.series[6].update({
    //     data: newThis.state.sarr[window.container],
    // }, false);
    // newThis.state.chart.series[7].update({
    //     data: newThis.state.tarr[window.container],
    // }, false);
    // newThis.state.chart.series[8].update({
    //     data: newThis.state.ponarr[window.container],
    // }, false);
    // newThis.state.chart.series[9].update({
    //     data: newThis.state.poffarr[window.container],
    // }, false);
    // newThis.state.chart.series[10].update({
    //     data: newThis.state.tonarr[window.container],
    // }, false);
    // newThis.state.chart.series[11].update({
    //     data: newThis.state.toffarr[window.container],
    // }, false);
    // newThis.state.chart.series[12].update({
    //     data: newThis.state.jarr[window.container],
    // }, true);

    if (newThis.state.charts[window.prevChart] != undefined) {
      if (
        newThis.state.charts[window.prevChart].draggablePlotLine != undefined
      ) {
        newThis.state.charts[window.prevChart].draggablePlotLine.destroy();
      }
    }
    var chart1 = newThis.state.charts[0];

    window.prevChart = 0;

    var lineWidth = 2;

    chart1.draggablePlotLine = chart1.renderer
      .rect(
        newThis.state.charts[0].xAxis[0].toPixels(strip_val) -
        newThis.state.charts[0].xAxis[0].toPixels(25),
        10,
        50,
        40,
        5
      )
      .attr({
        "stroke-width": 2,
        opacity: 0.5,
        fill: "grey",
        zIndex: 3,
      })
      .add();
    newThis.state.chart.xAxis[0].setExtremes(
      strip_val - 500,
      strip_val + 500,
      true,
      false
    );

    if (newThis.state.charts[0].container.onmousemove != undefined) {
      newThis.state.charts[0].container.onmousemove = function (e) {
        return false;
      };
    }

    newThis.state.charts[0].container.onmousemove = function (e) {
      if (chart1.draggablePlotLine != undefined) {
        if (chart1.draggablePlotLine.drag) {
          let normalizedEvent = chart1.pointer.normalize(e),
            extremes = {
              left: chart1.plotLeft,
              right: chart1.plotLeft + chart1.plotWidth,
            };

          if (e.chartX >= extremes.left && e.chartX <= extremes.right) {
            var pointValue = chart1.xAxis[0].toValue(e.chartX);
            if (pointValue - 500 <= 0) {
              newThis.state.chart.xAxis[0].setExtremes(
                0,
                pointValue + 2250,
                true,
                false
              );
            } else {
              newThis.state.chart.xAxis[0].setExtremes(
                pointValue - 1125,
                pointValue + 1125,
                true,
                false
              );
            }
            chart1.draggablePlotLine.attr({
              x: e.chartX,
            });
          }
        }
      }
    };

    newThis.state.charts[0].draggablePlotLine.element.onmousedown =
      function () {
        chart1.draggablePlotLine.drag = true;
      };
    newThis.state.charts[0].draggablePlotLine.element.onmouseup = function () {
      chart1.draggablePlotLine.drag = false;
    };
  }

  renderNewChart(userid, dbId, step, start, end) {
    var arr = [],
      charts = [],
      arr2 = [],
      peakarr = [],
      barClick = 0,
      pointValue,
      tempChart,
      tempCont = 0;
    var starr = [],
      beatArr = [],
      defarr = [],
      plotband = [],
      piec;
    // Expose the popup-chart plotband closure on window so the class-
    // level clearSelectionState (which can't reach this closure) can
    // wipe it on popup close. Without this, subsequent clickFunction
    // calls keep pushing onto a stale 58-entry array, replaying old
    // marquee bands on every fresh click.
    window.popupPlotbandRef = plotband;
    var maximumval;
    var b;
    var js_array = [];
    var chart;
    var minVal, maxVal, val, val2;
    var rarr = [];
    // var parr = [],
    //     tarr = [],
    //     qarr = [],
    //     rarr = [],
    //     sarr = [],
    //     ponarr = [],
    //     poffarr = [],
    //     tonarr = [],
    //     toffarr = [],
    //     jarr = [];
    // console.log("chart:", rarr);
    var result3,
      colorArray = [];
    var rpeakArray = [];
    /*  var markerAarray = [],*/
    var result4 = [];
    var peakColorArray = [];

    peakColorArray["Normal Sinus Rhythm"] = "#3D761D";
    peakColorArray["Sinus Tachycardia"] = "#00FFFF";
    peakColorArray["Sinus Bradycardia"] = "#FF9900";
    peakColorArray["PAC"] = "#0000FF";
    peakColorArray["PVC"] = "#FF00FF";
    peakColorArray["Ventricular Tachycardia"] = "#A64D79";
    peakColorArray["AFib"] = "#9900FF";
    peakColorArray["Sinus Pause"] = "#FF0000";
    peakColorArray["P Absent"] = "#bfbebb";
    peakColorArray["Irregular RR"] = "#7F6000";
    peakColorArray["Irregular PR"] = "#351C75";
    peakColorArray["Short QT"] = "#980000";
    peakColorArray["Prolonged QT"] = "#46BDC6";
    peakColorArray["Paced"] = "#c96936";
    peakColorArray["Undiagnosed"] = "#FFD966";
    var userid = userid;
    var databaseid = dbId;
    var selfNew = this;
    var mainEcgArray,
      mainActivityArray = [];
    var datasetMnt = 0;

    //Split the array in chunks with given size
    function chunkArray(myArray, chunk_size) {
      let results = [];

      while (myArray.length) {
        results.push(myArray.splice(0, chunk_size));
      }
      return results;
    }

    function chunkPeakArray(peakArray, start = 0) {
      let presults = [];
      var minIndex = 0;
      var breakVal = (start + 1) * deviceFrequency;
      var z;
      var temRpeakindex;
      presults.push([]);
      for (var i = 0; i < peakArray.length; i++) {
        if (start * deviceFrequency < peakArray[i].rpeakindex) {
          if (peakArray[i].rpeakindex > breakVal) {
            presults.push([]);
            minIndex = minIndex + 1;
            breakVal = breakVal + deviceFrequency;
          }
          temRpeakindex =
            parseInt(peakArray[i].rpeakindex) -
            (minIndex + start) * deviceFrequency;
          presults[minIndex].push({
            x: temRpeakindex,
            y: parseFloat(0.8),
            color: peakColorArray[peakArray[i].arrhythmia],
            beat: parseInt(peakArray[i].indexcounter),
            hr: parseInt(peakArray[i].heartrate),
            rr: parseInt(peakArray[i].rr_interval),
            arrhythmia: peakArray[i].arrhythmia,
            peaktime: peakArray[i].peaktime,
          });
        }
      }
      return presults;
    }

    function chunkMarkerArray(markArrayX, markArrayY, start = 0) {
      var ppeakIndex = markArrayX.split(",");
      var ppeakAmp = markArrayY.split(",");
      let mresults = [];
      var minIndex = 0;
      var breakVal = (start + 1) * deviceFrequency;
      var z;
      var temindex;
      mresults.push([]);

      for (var i = 0; i < ppeakIndex.length; i++) {
        if (ppeakIndex[i] > start * deviceFrequency) {
          if (ppeakIndex[i] > breakVal) {
            mresults.push([]);
            minIndex = minIndex + 1;
            breakVal = breakVal + deviceFrequency;
          }
          temindex =
            parseInt(ppeakIndex[i]) - (minIndex + start) * deviceFrequency;
          mresults[minIndex].push([temindex, parseFloat(ppeakAmp[i])]);
        }
      }
      return mresults;
    }

    // ─── Add beat from inside the strip popup ─────────────────────────
    // Armed by the "＋ Add beat" button in the popup header (JSX,
    // id="addBeatBtn"). One-shot: after pressing the button, the next
    // plain click on the popup chart places a new beat there — same
    // dialog + rules as /addlabel-chart (auto beat number, HR from the
    // neighbouring beats, settings-based arrhythmia, and next-beat
    // HR/arrhythmia correction via updateNextBeat).
    window.__armAddBeat = function () {
      var tt = document.getElementById("tt_container");
      var popupEl = document.getElementById("popup");
      if (!tt || !chart || !popupEl || popupEl.classList.contains("popup-close")) {
        alert("Open a strip popup first, then press Add beat.");
        return;
      }
      if (window.__addBeatArmed) return;
      if (window.__removeBeatArmed) {
        alert("Remove-beat mode is active — press Esc first.");
        return;
      }
      // Block re-arming while a previous add/remove is still saving or
      // refreshing — clicking again in that window would read the OLD beat
      // list and compute wrong beat numbers / HR.
      if (window.__beatOpBusy) {
        beatStatusChip("Previous beat operation still saving — wait for ✓", "busy");
        return;
      }
      window.__addBeatArmed = true;
      tt.style.cursor = "crosshair";
      var btn = document.getElementById("addBeatBtn");
      if (btn) {
        btn.textContent = "Click on the wave…";
        btn.style.background = "#ff9f0a";
      }

      function disarm() {
        window.__addBeatArmed = false;
        tt.style.cursor = "";
        tt.removeEventListener("click", onPick, true);
        if (btn) {
          btn.textContent = "＋ Add beat";
          btn.style.background = "";
        }
      }

      function escHandler(ev) {
        if (ev.key === "Escape") disarm();
        if (!window.__addBeatArmed)
          document.removeEventListener("keydown", escHandler);
      }
      document.addEventListener("keydown", escHandler);

      function onPick(e) {
        e.preventDefault();
        e.stopPropagation();
        disarm();
        try {
          var norm = chart.pointer.normalize(e);
          var clickedX = Math.round(chart.xAxis[0].toValue(norm.chartX));
          if (!isFinite(clickedX)) throw new Error("could not resolve click position");
          if (clickedX < 0) clickedX = 0;
          if (clickedX > deviceFrequency - 1) clickedX = deviceFrequency - 1;
          var yData = (chart.series[0] && chart.series[0].yData) || [];
          var clickedY = yData[clickedX] != null ? yData[clickedX] : 0;
          openAddBeatPopup(clickedX, clickedY);
        } catch (err) {
          console.error("[addbeat] pick failed:", err);
          alert("Add beat: could not read the click position (" + err.message + ")");
        }
      }
      // Capture phase: runs before Highcharts' own handlers (and before
      // the popup chart marquee, which only reacts to Cmd/Ctrl anyway).
      tt.addEventListener("click", onPick, true);
    };

    // Floating status chip — non-blocking feedback for beat add/remove.
    // kind: "busy" | "ok" | "error". autoHideMs hides it after a delay.
    function beatStatusChip(text, kind, autoHideMs) {
      var chip = document.getElementById("beatStatusChip");
      if (!chip) {
        chip = document.createElement("div");
        chip.id = "beatStatusChip";
        chip.style.position = "fixed";
        chip.style.bottom = "24px";
        chip.style.left = "50%";
        chip.style.transform = "translateX(-50%)";
        chip.style.padding = "10px 22px";
        chip.style.borderRadius = "20px";
        chip.style.fontSize = "14px";
        chip.style.fontWeight = "600";
        chip.style.zIndex = "10001";
        chip.style.boxShadow = "0 4px 16px rgba(0,0,0,0.45)";
        chip.style.transition = "opacity 0.3s";
        document.body.appendChild(chip);
      }
      if (chip.__hideTimer) clearTimeout(chip.__hideTimer);
      var colors = {
        busy: { bg: "#0f2a2e", border: "#2eaabb", color: "#7fd8e5" },
        ok: { bg: "#0f2e1c", border: "#30d158", color: "#7fe5a8" },
        error: { bg: "#2e0f12", border: "#ff453a", color: "#ff9a94" },
      };
      var c = colors[kind] || colors.busy;
      chip.style.background = c.bg;
      chip.style.border = "1px solid " + c.border;
      chip.style.color = c.color;
      chip.style.opacity = "1";
      chip.textContent = text;
      if (autoHideMs) {
        chip.__hideTimer = setTimeout(function () {
          chip.style.opacity = "0";
          setTimeout(function () {
            if (chip && chip.parentNode) chip.parentNode.removeChild(chip);
          }, 350);
        }, autoHideMs);
      }
    }

    // Build + show the add-beat dialog. Styled to match the app theme.
    // Save is NON-BLOCKING: the dialog closes immediately and the status
    // chip reports progress while addBeatsToDB → updateNextBeat →
    // getUpdatedBeats run in the background.
    async function openAddBeatPopup(clickedX, clickedY) {
      var prevBeatNumber = null;
      var prevRRIntervalMs = null, prevRRTimeSeconds = null, prevHeartRateBPM = null;
      var nextRRIntervalMs = null, nextRRTimeSeconds = null, nextHeartRateBPM = null;
      var nextBeatArrhythmia = null;
      // Pin the strip identity at PICK time. clickedX is relative to the
      // chunk shown when the wave was clicked — the popup has no backdrop,
      // so clicking another strip while the dialog is open moves
      // window.container / window.chartid, and reading them at Save time
      // would compute a wrong global rpeakindex / repaint the wrong chunk.
      var pickContainer = parseInt(window.container, 10) || 0;
      var pickChartId = window.chartid || 0;
      try {
        // Read the CURRENT chunk's beats from the authoritative result3
        // array (refreshed synchronously after every add/remove), NOT from
        // chart.series[2].options.data. Highcharts' setData() updates the
        // rendered points but does NOT reliably refresh options.data — so
        // after adding one beat the chart still reported the OLD beats, and
        // the next add computed a wrong previous-beat number / HR (the
        // "must refresh first, else wrong HR" bug). result3 chunks carry the
        // same {x, beat, hr, arrhythmia} shape and the same per-chunk x
        // coordinates as options.data, so clickedX still lines up.
        var chunks = (selfNew.state && selfNew.state.result3) || window.result3 || [];
        var cid = pickChartId;
        var beatPts =
          (chunks[cid] && chunks[cid].length ? chunks[cid] : null) ||
          (chart.series[2] && chart.series[2].options && chart.series[2].options.data) ||
          [];
        var prevBeatPoint = null, nextBeatPoint = null;
        for (var i = 0; i < beatPts.length; i++) {
          var pt = beatPts[i];
          if (!pt || pt.x == null) continue;
          if (pt.x < clickedX) prevBeatPoint = pt;
          else if (pt.x > clickedX && !nextBeatPoint) { nextBeatPoint = pt; break; }
        }
        prevBeatNumber = prevBeatPoint ? prevBeatPoint.beat : null;
        var prevGap = prevBeatPoint ? clickedX - prevBeatPoint.x : null;
        if (!prevBeatPoint && cid > 0 && chunks[cid - 1] && chunks[cid - 1].length) {
          var lp = chunks[cid - 1][chunks[cid - 1].length - 1];
          prevBeatNumber = lp.beat;
          prevGap = clickedX + (deviceFrequency - lp.x);
        }
        var nextGap = nextBeatPoint ? nextBeatPoint.x - clickedX : null;
        nextBeatArrhythmia = nextBeatPoint ? nextBeatPoint.arrhythmia || null : null;
        if (!nextBeatPoint && chunks[cid + 1] && chunks[cid + 1].length) {
          var np = chunks[cid + 1][0];
          nextGap = deviceFrequency - clickedX + np.x;
          nextBeatArrhythmia = np.arrhythmia || null;
        }
        if (prevGap != null && prevGap > 0) {
          prevRRIntervalMs = Math.round((prevGap / 250) * 1000);
          prevRRTimeSeconds = prevRRIntervalMs / 1000;
          prevHeartRateBPM = prevRRTimeSeconds > 0 ? 60 / prevRRTimeSeconds : "N/A";
        }
        if (nextGap != null && nextGap > 0) {
          nextRRIntervalMs = Math.round((nextGap / 250) * 1000);
          nextRRTimeSeconds = nextRRIntervalMs / 1000;
          nextHeartRateBPM = nextRRTimeSeconds > 0 ? 60 / nextRRTimeSeconds : "N/A";
        }
      } catch (autoErr) {
        console.error("[addbeat] neighbour auto-detect failed:", autoErr);
      }

      var existing = document.getElementById("beatPopup");
      if (existing) existing.remove();

      var pop = document.createElement("div");
      pop.id = "beatPopup";
      pop.style.cssText =
        "position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);" +
        "background:#0f2a2e;color:#c8dde0;padding:20px 22px;min-width:330px;" +
        "border:1px solid #1e4a52;border-radius:12px;z-index:10000;" +
        "box-shadow:0 12px 40px rgba(0,0,0,0.55);font-size:14px;";

      var title = document.createElement("div");
      title.textContent = "Add beat";
      title.style.cssText =
        "font-size:16px;font-weight:700;color:#7fd8e5;margin-bottom:4px;";
      pop.appendChild(title);

      function fieldLabel(text) {
        var l = document.createElement("div");
        l.textContent = text;
        l.style.cssText =
          "font-size:11px;font-weight:600;letter-spacing:0.5px;" +
          "text-transform:uppercase;color:#89a8c0;margin:12px 0 5px;";
        return l;
      }
      var inputCss =
        "width:100%;box-sizing:border-box;padding:8px 12px;background:#0a1f20;" +
        "border:1px solid #1a5a62;border-radius:7px;color:#c8dde0;" +
        "font-size:14px;outline:none;";

      pop.appendChild(fieldLabel("Previous beat number"));
      var beatInput = document.createElement("input");
      beatInput.type = "number";
      beatInput.placeholder = "existing beat index";
      beatInput.style.cssText = inputCss;
      if (
        prevBeatNumber !== null &&
        prevBeatNumber !== undefined &&
        !Number.isNaN(parseInt(prevBeatNumber, 10))
      ) {
        beatInput.value = parseInt(prevBeatNumber, 10);
      }
      pop.appendChild(beatInput);

      pop.appendChild(fieldLabel("Rhythm type"));
      var select = document.createElement("select");
      select.style.cssText = inputCss + "cursor:pointer;";
      [
        "Normal Sinus Rhythm", "PVC", "PAC", "Irregular PR", "Irregular RR",
        "P Absent", "Prolonged QT", "Short QT", "Sinus Bradycardia",
        "Sinus Pause", "Sinus Tachycardia", "Undiagnosed",
        "Ventricular Tachycardia", "AFib", "Paced",
      ].forEach(function (type) {
        var option = document.createElement("option");
        option.value = type;
        option.textContent = type;
        select.appendChild(option);
      });
      pop.appendChild(select);

      var info = document.createElement("div");
      info.style.cssText =
        "font-size:12px;color:#89a8c0;margin-top:12px;min-height:16px;";
      info.textContent = "Loading patient settings\u2026";
      pop.appendChild(info);

      var btnRow = document.createElement("div");
      btnRow.style.cssText =
        "display:flex;justify-content:flex-end;gap:10px;margin-top:16px;";
      var cancelButton = document.createElement("button");
      cancelButton.textContent = "Cancel";
      cancelButton.style.cssText =
        "padding:8px 18px;background:transparent;border:1px solid #2a5a62;" +
        "border-radius:7px;color:#89a8c0;cursor:pointer;font-size:13px;";
      var saveButton = document.createElement("button");
      saveButton.textContent = "Save beat";
      saveButton.style.cssText =
        "padding:8px 22px;background:#0a8aa0;border:none;border-radius:7px;" +
        "color:#ffffff;font-weight:700;cursor:pointer;font-size:13px;";
      btnRow.appendChild(cancelButton);
      btnRow.appendChild(saveButton);
      pop.appendChild(btnRow);
      document.body.appendChild(pop);
      try { beatInput.focus(); } catch (eF) {}

      // Enter = save, Esc = close (dialog-local keys)
      pop.addEventListener("keydown", function (ev) {
        if (ev.key === "Escape") pop.remove();
        if (ev.key === "Enter") {
          ev.preventDefault();
          saveButton.click();
        }
      });

      cancelButton.onclick = function () {
        pop.remove();
      };

      saveButton.onclick = function (event) {
        var beatNumber = parseInt(beatInput.value, 10);
        var selectedType = select.value;
        var useCtrlRoute = !!(event.ctrlKey || event.metaKey);

        // ── Validation BEFORE closing the popup ──────────────────────
        // 1. A previous-beat number must exist (auto-detected or typed);
        //    otherwise the backend would insert at index 0 with garbage RR.
        if (Number.isNaN(beatNumber)) {
          info.textContent =
            "Could not detect the previous beat — type its number manually.";
          info.style.color = "#ff9f0a";
          return;
        }
        // 2. The new beat's RR/HR must be computable and finite — else
        //    "N/A"/null would be written to the DB and the report prints
        //    overlapping garbage labels.
        if (
          prevRRIntervalMs == null ||
          prevRRIntervalMs <= 0 ||
          !isFinite(parseFloat(prevHeartRateBPM))
        ) {
          info.textContent =
            "Cannot compute RR/HR here — click between two visible beats.";
          info.style.color = "#ff9f0a";
          return;
        }

        var sendIndex = Math.max(0, beatNumber);
        // Use the strip identity pinned at PICK time — clickedX is relative
        // to THAT chunk, and window.container may have moved if another
        // strip was clicked while this dialog sat open.
        var globalRpeakIndex = pickContainer * deviceFrequency + clickedX;
        var savedChartId = pickChartId;

        // Close instantly — everything below runs in the background and
        // reports through the status chip instead of freezing the UI.
        pop.remove();
        window.__beatOpBusy = true;
        beatStatusChip("Adding beat after #" + sendIndex + "\u2026", "busy");

        (async function () {
          var payload = {
            userid: userid,
            arrhythmia: selectedType,
            indexcounter: sendIndex,
            rrtime: JSON.stringify(prevRRTimeSeconds),
            rr_interval: prevRRTimeSeconds != null ? prevRRTimeSeconds * 1000 : null,
            rpeakindex: globalRpeakIndex,
            heartrate: prevHeartRateBPM,
            clickedY: JSON.stringify(clickedY),
            databaseid: dbId,
          };

          // Next-beat arrhythmia: remap HR-based labels only — morphology
          // labels (PVC, PAC, VT, AFib, Paced, \u2026) are never overwritten.
          var nextArrUpdate = null;
          try {
            var pset = window.__patientSettings || {};
            var hrLabels = ["Normal Sinus Rhythm", "Sinus Bradycardia", "Sinus Tachycardia"];
            var nextHrNum = parseFloat(nextHeartRateBPM);
            if (
              nextBeatArrhythmia &&
              hrLabels.indexOf(nextBeatArrhythmia) !== -1 &&
              isFinite(nextHrNum)
            ) {
              var minhrN = parseFloat(pset.nor_minhr);
              var maxhrN = parseFloat(pset.nor_maxhr);
              if (isFinite(maxhrN) && nextHrNum > maxhrN) nextArrUpdate = "Sinus Tachycardia";
              else if (isFinite(minhrN) && nextHrNum < minhrN) nextArrUpdate = "Sinus Bradycardia";
              else nextArrUpdate = "Normal Sinus Rhythm";
              if (nextArrUpdate === nextBeatArrhythmia) nextArrUpdate = null;
            }
          } catch (e2) {
            nextArrUpdate = null;
          }

          try {
            var addUrl = useCtrlRoute
              ? apiUrl + "api/common/addBeatsToDBCtrl"
              : apiUrl + "api/common/addBeatsToDB";
            await axios.post(addUrl, payload);

            // Correct the FOLLOWING beat's RR/HR — but only when a next
            // beat was actually found and its values are finite. Adding
            // after the LAST loaded beat used to fire this with nulls,
            // which nulled out a real beat's RR/HR whenever one existed
            // at that index (e.g. in a chunk that wasn't loaded).
            if (
              nextRRIntervalMs != null &&
              nextRRIntervalMs > 0 &&
              isFinite(parseFloat(nextHeartRateBPM))
            ) {
              var nextUpdateIndex = sendIndex + 2;
              var nextBody = {
                userid: userid,
                databaseid: dbId,
                indexcounter: nextUpdateIndex,
                rrtime: nextRRTimeSeconds,
                rr_interval: nextRRIntervalMs,
                heartrate: nextHeartRateBPM,
              };
              if (nextArrUpdate) nextBody.arrhythmia = nextArrUpdate;
              await axios.post(apiUrl + "api/common/updateNextBeat", nextBody);
            }

            beatStatusChip("Saved \u2014 refreshing beats\u2026", "busy");
            var updatedBeatsRes = await axios.get(
              apiUrl + "api/common/getUpdatedBeats?userid=" + userid + "&databaseid=" + dbId
            );
            var formattedRpeaks = chunkPeakArray(
              updatedBeatsRes.data.beats,
              selfNew.state.start
            );
            selfNew.setState({ result3: formattedRpeaks });
            window.result3 = formattedRpeaks;
            if (chart && chart.series && chart.series[2]) {
              var freshChunk = formattedRpeaks[savedChartId] || [];
              chart.series[2].setData(freshChunk, true);
              // Keep options.data in sync too \u2014 setData alone doesn't, and a
              // stale options.data is what broke the next add.
              chart.series[2].options.data = freshChunk;
            }
            beatStatusChip("Beat added \u2713", "ok", 3500);
          } catch (error) {
            console.error("[addbeat] save failed:", error);
            beatStatusChip(
              "Add beat failed: " +
                (error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : error.message),
              "error",
              9000
            );
          } finally {
            // Re-allow arming Add/Remove beat only once the save +
            // authoritative refresh has fully settled.
            window.__beatOpBusy = false;
          }
        })();
      };

      // Rhythm auto-select from patient settings — after the dialog is
      // visible, so a slow settings request can never block it.
      (async function () {
        try {
          if (!window.__patientSettings) {
            var sres = await axios.get(
              apiUrl + "api/patients/settings?userid=" + userid,
              { timeout: 8000 }
            );
            window.__patientSettings = sres.data || {};
          }
          var pset2 = window.__patientSettings;
          var hrNum = parseFloat(prevHeartRateBPM);
          var minhr = parseFloat(pset2.nor_minhr);
          var maxhr = parseFloat(pset2.nor_maxhr);
          var autoType = "Normal Sinus Rhythm";
          if (isFinite(hrNum)) {
            if (isFinite(maxhr) && hrNum > maxhr) autoType = "Sinus Tachycardia";
            else if (isFinite(minhr) && hrNum < minhr) autoType = "Sinus Bradycardia";
          }
          if (document.getElementById("beatPopup") && select.value === "Normal Sinus Rhythm") {
            select.value = autoType;
          }
          info.textContent =
            "New beat HR: " + (isFinite(hrNum) ? Math.round(hrNum) : "?") +
            " bpm (normal " + (isFinite(minhr) ? minhr : "?") + "\u2013" +
            (isFinite(maxhr) ? maxhr : "?") + ") \u2192 " + autoType;
        } catch (e3) {
          info.textContent = "Settings unavailable \u2014 pick the rhythm manually.";
        }
      })();
    }


    // ─── Remove beat from inside the strip popup ──────────────────────
    // Same one-shot pattern as Add beat. After arming, the next plain
    // click removes the NEAREST beat marker (must click within ~2s of
    // one). Mirrors /removelabel-chart exactly: deleteBeat +
    // updateDeletedNextbeat with the merged RR/HR, then a full beat
    // refresh from getUpdatedBeats.
    window.__armRemoveBeat = function () {
      var tt = document.getElementById("tt_container");
      var popupEl = document.getElementById("popup");
      if (!tt || !chart || !popupEl || popupEl.classList.contains("popup-close")) {
        alert("Open a strip popup first, then press Remove beat.");
        return;
      }
      if (window.__removeBeatArmed) return;
      if (window.__addBeatArmed) {
        alert("Add-beat mode is active — press Esc first.");
        return;
      }
      // Same busy-guard as Add beat: never arm while a previous beat
      // operation is still saving/refreshing (stale beat numbers).
      if (window.__beatOpBusy) {
        beatStatusChip("Previous beat operation still saving — wait for ✓", "busy");
        return;
      }
      window.__removeBeatArmed = true;
      tt.style.cursor = "crosshair";
      var btn = document.getElementById("removeBeatBtn");
      if (btn) {
        btn.textContent = "Click a beat…";
        btn.style.background = "#ff453a";
        btn.style.color = "#fff";
      }

      function disarm() {
        window.__removeBeatArmed = false;
        tt.style.cursor = "";
        tt.removeEventListener("click", onPickRemove, true);
        if (btn) {
          btn.textContent = "− Remove beat";
          btn.style.background = "";
          btn.style.color = "";
        }
      }

      function escHandler(ev) {
        if (ev.key === "Escape") disarm();
        if (!window.__removeBeatArmed)
          document.removeEventListener("keydown", escHandler);
      }
      document.addEventListener("keydown", escHandler);

      function onPickRemove(e) {
        e.preventDefault();
        e.stopPropagation();
        disarm();
        try {
          var norm = chart.pointer.normalize(e);
          var clickedX = Math.round(chart.xAxis[0].toValue(norm.chartX));
          if (!isFinite(clickedX)) throw new Error("could not resolve click position");
          // Read the current chunk from the authoritative result3 array
          // (fresh after every add/remove) rather than series[2].options.data,
          // which setData() leaves stale — same fix as Add beat.
          var rmChunks = (selfNew.state && selfNew.state.result3) || window.result3 || [];
          var rmCid = window.chartid || 0;
          var beatPts =
            (rmChunks[rmCid] && rmChunks[rmCid].length ? rmChunks[rmCid] : null) ||
            (chart.series[2] && chart.series[2].options && chart.series[2].options.data) ||
            [];
          var target = null;
          var bestDist = Infinity;
          for (var i = 0; i < beatPts.length; i++) {
            var pt = beatPts[i];
            if (!pt || pt.x == null) continue;
            var d = Math.abs(pt.x - clickedX);
            if (d < bestDist) {
              bestDist = d;
              target = pt;
            }
          }
          if (!target || bestDist > 500) {
            alert("No beat near that spot — click closer to the beat marker.");
            return;
          }
          doRemoveBeat(target);
        } catch (err) {
          console.error("[removebeat] pick failed:", err);
          alert("Remove beat: could not read the click position (" + err.message + ")");
        }
      }
      tt.addEventListener("click", onPickRemove, true);
    };

    async function doRemoveBeat(target) {
      // Flatten all loaded chunks into one global-ordered list so the
      // previous/next neighbours work across strip boundaries.
      var chunks = (selfNew.state && selfNew.state.result3) || window.result3 || [];
      var startSec = selfNew.state.start || 0;
      var flat = [];
      for (var c = 0; c < chunks.length; c++) {
        var arr = chunks[c] || [];
        for (var k = 0; k < arr.length; k++) {
          var p = arr[k];
          if (!p || p.x == null) continue;
          flat.push({
            beat: p.beat,
            x: p.x,
            y: p.y,
            arrhythmia: p.arrhythmia || null,
            gx: (c + startSec) * deviceFrequency + p.x,
          });
        }
      }
      flat.sort(function (a, b) { return a.gx - b.gx; });
      var ti = -1;
      for (var f = 0; f < flat.length; f++) {
        if (flat[f].beat === target.beat) { ti = f; break; }
      }
      if (ti === -1) {
        alert("Could not locate beat #" + target.beat + " in the loaded data.");
        return;
      }
      var previousBeat = ti > 0 ? flat[ti - 1] : null;
      var nextBeat = ti < flat.length - 1 ? flat[ti + 1] : null;

      // Merged RR across the removed beat — same math/units as
      // /removelabel-chart (rr_interval in samples @250Hz).
      var rrInterval = null;
      var rrTimeMs = null;
      var rrTimeSec = null;
      var heartRate = null;
      if (previousBeat && nextBeat) {
        rrInterval = nextBeat.gx - previousBeat.gx;
        rrTimeMs = Math.round((rrInterval / 250) * 1000);
        rrTimeSec = rrTimeMs / 1000;
        heartRate = rrTimeSec > 0 ? Math.round(60 / rrTimeSec) : "N/A";
      }

      var confirmation = window.confirm(
        "Delete beat #" + target.beat +
        (target.arrhythmia ? " (" + target.arrhythmia + ")" : "") +
        (heartRate ? " — merged HR becomes " + heartRate + " bpm?" : "?")
      );
      if (!confirmation) return;

      // Pin the popup's current chunk before any await (chartid can move
      // if another strip is clicked mid-save).
      var savedChartIdR = window.chartid || 0;
      window.__beatOpBusy = true;
      beatStatusChip("Removing beat #" + target.beat + "…", "busy");
      try {
        await axios.post(apiUrl + "api/common/deleteBeat", {
          userid: userid,
          databaseid: dbId,
          indexcounter: target.beat,
          rpeak_index: target.x,
          rpeak_amp: target.y,
          previousIndexCounter: previousBeat ? previousBeat.beat : null,
          nextIndexCounter: nextBeat ? nextBeat.beat : null,
          rr_interval: rrInterval,
          rrtime: rrTimeMs,
          heartrate: heartRate,
        });

        if (nextBeat) {
          if (!previousBeat) {
            // First beat deleted → reset the (new) first beat, same as
            // removelabel-chart does.
            await axios.post(apiUrl + "api/common/updateDeletedNextbeat", {
              userid: userid,
              databaseid: dbId,
              indexcounter: 0,
              rrtime: 0,
              rr_interval: 0,
              heartrate: 0,
            });
          } else {
            var nextBody = {
              userid: userid,
              databaseid: dbId,
              indexcounter: nextBeat.beat,
              rrtime: rrTimeSec,
              rr_interval: rrInterval,
              heartrate: heartRate,
            };
            // Remap the merged beat's HR-based label from settings —
            // morphology labels are never overwritten. Backend applies
            // this only if updateDeletedNextbeat supports the field.
            try {
              var pset = window.__patientSettings || {};
              var hrLabels = ["Normal Sinus Rhythm", "Sinus Bradycardia", "Sinus Tachycardia"];
              var hrNum = parseFloat(heartRate);
              if (
                nextBeat.arrhythmia &&
                hrLabels.indexOf(nextBeat.arrhythmia) !== -1 &&
                isFinite(hrNum)
              ) {
                var minhr = parseFloat(pset.nor_minhr);
                var maxhr = parseFloat(pset.nor_maxhr);
                var remap = "Normal Sinus Rhythm";
                if (isFinite(maxhr) && hrNum > maxhr) remap = "Sinus Tachycardia";
                else if (isFinite(minhr) && hrNum < minhr) remap = "Sinus Bradycardia";
                if (remap !== nextBeat.arrhythmia) nextBody.arrhythmia = remap;
              }
            } catch (e4) { /* keep body without arrhythmia */ }
            await axios.post(apiUrl + "api/common/updateDeletedNextbeat", nextBody);
          }
        }

        // Authoritative refresh — beat numbers shift after a delete.
        beatStatusChip("Deleted — refreshing beats…", "busy");
        var updatedBeatsRes = await axios.get(
          apiUrl + "api/common/getUpdatedBeats?userid=" + userid + "&databaseid=" + dbId
        );
        var formattedRpeaks = chunkPeakArray(
          updatedBeatsRes.data.beats,
          selfNew.state.start
        );
        selfNew.setState({ result3: formattedRpeaks });
        window.result3 = formattedRpeaks;
        if (chart && chart.series && chart.series[2]) {
          var freshChunkR = formattedRpeaks[savedChartIdR] || [];
          chart.series[2].setData(freshChunkR, true);
          chart.series[2].options.data = freshChunkR; // keep options.data in sync
        }
        beatStatusChip("Beat #" + target.beat + " removed ✓", "ok", 3500);
      } catch (error) {
        console.error("[removebeat] delete failed:", error);
        beatStatusChip(
          "Remove beat failed: " +
            (error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : error.message),
          "error",
          9000
        );
      } finally {
        window.__beatOpBusy = false;
      }
    }

    function clickFunction(event, that) {
      var containerId = that.renderTo.id; // Get the Container ID
      window.container = parseInt(containerId.replace("container", ""));
      window.chartid = window.container - selfNew.state.start;
      window.stripXValue = event.chartX; // Get the location on the x-axis

      /*************Remove Plotband***********************/
      if (window.beatArr.length > 0 && window.chartid != window.prevChart) {
        for (var i = 0; i < window.beatArr.length; i++) {
          var j = parseInt(window.container) * deviceFrequency;
          var xBeat = parseInt(window.beatArr[i]) - j;
          chart.xAxis[0].removePlotBand("plotband-" + xBeat);
        }
      }
      /*************Remove Plotband***********************/

      // Convert click position to x-axis value
      var val = charts[window.container].xAxis[0].toValue(event.chartX);

      // Get the start and end indices for slicing the ECG array
      var sliceStart = window.container * deviceFrequency;
      var sliceEnd = sliceStart + deviceFrequency;
      var ecgArray = selfNew.state.mainEcgArray.slice(sliceStart, sliceEnd);

      // Get the activity array
      var sliceActStart = window.container * 60;
      var sliceActEnd = sliceActStart + 60;
      var curActArray = selfNew.state.mainActivityArray.slice(
        sliceActStart,
        sliceActEnd
      );

      // Prepare activity data for plotting
      var actarr = [];
      var acti = 125;
      for (var i = 0; i < curActArray.length; i++) {
        actarr.push({
          x: acti,
          y: 0.5,
          color: colorArray[curActArray[i]],
        });
        acti += 250;
      }

      // Update chart series with new data
      chart.series[0].setData(ecgArray, false);
      chart.series[1].setData(actarr, false);
      
      // Safely update result3 data if available
      if (selfNew.state.result3 && selfNew.state.result3[window.chartid]) {
        chart.series[2].setData(selfNew.state.result3[window.chartid], false);
      } else {
        chart.series[2].setData([], false);
      }
      
      // Safely update rarr data if available
      if (selfNew.state.rarr && selfNew.state.rarr[window.container]) {
        chart.series[5].update(
          {
            data: selfNew.state.rarr[window.container],
          },
          false
        );
      } else {
        chart.series[5].update(
          {
            data: [],
          },
          false
        );
      }

      // Handle draggable plot line
      if (
        charts[window.prevChart] != undefined &&
        charts[window.prevChart].draggablePlotLine != undefined
      ) {
        charts[window.prevChart].draggablePlotLine.destroy();
      }
      window.prevChart = window.chartid;

      // Add draggable plot line at the clicked position
      var chart1 = that;
      chart1.draggablePlotLine = chart1.renderer
        .rect(
          event.chartX - charts[window.chartid].xAxis[0].toPixels(25),
          10,
          50,
          40,
          5
        )
        .attr({
          "stroke-width": 2,
          opacity: 0.5,
          fill: "grey",
          zIndex: 3,
        })
        .add();

      charts[window.chartid].container.onmousemove = function (e) {
        if (chart1.draggablePlotLine && chart1.draggablePlotLine.drag) {
          let normalizedEvent = chart1.pointer.normalize(e);
          let extremes = {
            left: chart1.plotLeft,
            right: chart1.plotLeft + chart1.plotWidth,
          };
          if (e.chartX >= extremes.left && e.chartX <= extremes.right) {
            pointValue = chart1.xAxis[0].toValue(e.chartX);
            chart1.draggablePlotLine.attr({ x: e.chartX });
            chart.xAxis[0].setExtremes(
              Math.max(0, pointValue - 1125),
              Math.min(ecgArray.length, pointValue + 1125),
              true,
              false
            );
          }
        }
      };

      charts[window.chartid].draggablePlotLine.element.onmousedown =
        function () {
          chart1.draggablePlotLine.drag = true;
        };

      charts[window.chartid].draggablePlotLine.element.onmouseup = function () {
        chart1.draggablePlotLine.drag = false;
      };

      chart.xAxis[0].setExtremes(
        Math.max(0, val - 1125),
        Math.min(ecgArray.length, val + 1125),
        true,
        false
      );

      /************* Accurate Beat Selection Code ******************/
      // Check if result3 data exists for current chart
      if (!window.result3 || !window.result3[window.chartid] || !Array.isArray(window.result3[window.chartid])) {
        return;
      }
      
      const closestArray = window.result3[window.chartid].map(
        (point) => point.x
      );
      
      // Check if closestArray has elements
      if (!closestArray || closestArray.length === 0) {
        return;
      }
      
      const jBeat = parseInt(window.container) * deviceFrequency;

      // Find the closest beat
      const closest = closestArray.reduce((prev, curr) =>
        Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev
      );

      const plotbandExists = window.beatArr.includes(closest + jBeat);

      // Find the beat object with its indexcounter
      const selectedBeatObj = window.result3[window.chartid].find(
        (point) => point.x === closest
      );
      
      if (!event.shiftKey) {
        // Always update selectedBeatNumber and beat_order state
        if (selectedBeatObj && selectedBeatObj.beat) {
          window.selectedBeatNumber = selectedBeatObj.beat;
          if (selfNew && selfNew.setState) {
            selfNew.setState({ beat_order: window.selectedBeatNumber });
          }
        }
        if (!plotbandExists) {
          plotband.push({
            color: "#ff9999",
            from: closest - 100,
            to: closest + 100,
            id: "plotband-" + closest,
          });
          chart.update({ xAxis: { plotBands: plotband } });
          window.beatArr.push(closest + jBeat);
        } else {
          const index = window.beatArr.indexOf(closest + jBeat);
          if (index > -1) {
            window.beatArr.splice(index, 1);
          }
          chart.xAxis[0].removePlotBand("plotband-" + closest);
        }
      } else {
        handleShiftKeyPlotbands(closest, jBeat, closestArray, chart);
      }

      /************* Accurate Beat Selection Code ******************/
    }

    function handleShiftKeyPlotbands(closest, jBeat, closestArray, chart) {
      let plotband = [];

      if (window.beatArr.length === 1) {
        let comStart, comEnd;
        if (closest > window.beatArr[0] - jBeat) {
          comEnd = closest;
          comStart = window.beatArr[0] - jBeat;
        } else {
          comStart = closest;
          comEnd = window.beatArr[0] - jBeat;
        }
        window.beatArr = [];
        for (let i = 0; i < closestArray.length; i++) {
          if (closestArray[i] >= comStart && closestArray[i] <= comEnd) {
            plotband.push({
              color: "#ff3333",
              // Narrow band (±25) for range-select so adjacent beats
              // stay visually distinct (was ±100 → merged into blobs).
              from: closestArray[i] - 25,
              to: closestArray[i] + 25,
              id: "plotband-" + closestArray[i],
            });
            window.beatArr.push(closestArray[i] + jBeat);
          }
        }
        chart.update({ xAxis: { plotBands: plotband } });
      } else {
        resetPlotbands(closest, jBeat, chart);
      }

      document.addEventListener("keydown", function (event) {
        if (event.key === "z" || event.key === "Z") {
          const index = window.beatArr.indexOf(closest + jBeat);
          if (index > -1) {
            window.beatArr.splice(index, 1);
          }
          chart.xAxis[0].removePlotBand("plotband-" + closest);
        }
      });
    }

    function resetPlotbands(closest, jBeat, chart) {
      chart.update({ xAxis: { plotBands: [] } });
      window.beatArr = [];
      let plotband = [
        {
          color: "#ff9999",
          from: closest - 100,
          to: closest + 100,
          id: "plotband-" + closest,
        },
      ];
      chart.update({ xAxis: { plotBands: plotband } });
      window.beatArr.push(closest + jBeat);
    }

    function renderSmallCharts(clickPointIndex = 0) {
      var i = 0;
      var t = 0;
      var limit = 9;
      var stcolor = "#09ff08",
        defcolour = "#09ff08";
      //console.log("small chart");
      if (window.sc < 9) {
        limit = window.sc - 1;
      }
      if (selfNew.props.match.params.start != undefined) {
        var targetStrip = parseInt(selfNew.props.match.params.start, 10);
        if (!isNaN(targetStrip) && targetStrip > limit) {
          limit = Math.min(targetStrip, window.sc - 1);
        }
      }

      var currentDataSet = [];

      var selWrapElement = document.getElementById("selWrap");
      if (!selWrapElement) {
        return;
      }

      for (var j = 0; j < window.sc; j++) {
        var newDiv = document.createElement("div");
        newDiv.id = "container" + j;
        newDiv.style = "min-width: 200px; height: 60px; margin: 0 auto";
        var newSpan = document.createElement("div");
        newSpan.id = "span" + j;
        newSpan.style = "color:#FF000; height: 21px;";
        selWrapElement.appendChild(newSpan);
        selWrapElement.appendChild(newDiv);
      }

      var myVar = setInterval(function () {
        var sliceStartI = i * deviceFrequency;
        var sliceEndI = sliceStartI + deviceFrequency + 1;
        // console.log("devicefrequency!!!!!!!", deviceFrequency);
        currentDataSet = selfNew.state.mainEcgArray.slice(
          sliceStartI,
          sliceEndI
        );

        var arrayIndex = 0;
        var k = 0;

        starr.push([]);

        defarr.push([]);

        if (selfNew.state.result3[i] != undefined) {
          if (selfNew.state.result3[i][0] != undefined) {
            var time1 = document.createTextNode(
              selfNew.state.result3[i][0].peaktime
            );
            document.getElementById("span" + i).appendChild(time1);

            for (var j = 0; j < currentDataSet.length; j++) {
              if (
                selfNew.state.result3[i][k] != null &&
                (j + 70 == selfNew.state.result3[i][k].x ||
                  selfNew.state.result3[i][k].x < 70)
              ) {
                stcolor = "09ff08";
                defcolour = "09ff08";

                // O(1) Set lookup — replaces 15-branch if/else chain.
                if (KNOWN_ARRHYTHMIAS.has(selfNew.state.result3[i][k].arrhythmia)) {
                  stcolor = selfNew.state.result3[i][k].color;
                }

                if (k < selfNew.state.result3[i].length - 1) {
                  k++;
                }
              }

              defarr[i].push({
                x: j,
                y: parseFloat(currentDataSet[j]),
                segmentColor: stcolor,
                //segmentColor: 'black'
              });

              starr[i].push({
                x: j,
                y: parseFloat(currentDataSet[j]),
                segmentColor: stcolor,
              });
            }
          }
        }

        // Check if container exists before creating chart
        var containerElement = document.getElementById("container" + i);
        if (!containerElement) {
          return;
        }

        charts[i] = new Highcharts.Chart("container" + i, {
          credits: {
            enabled: false,
          },
          chart: {
            height: 4 + "%",
            resetZoomButton: {
              theme: {
                display: "none",
              },
            },
            events: {
              click: function (e) {
                /* Do something with the event */

                clickFunction(e, this); // ...which means you can access it from inside the click handler function
              },
              // Cmd (Mac) / Ctrl (Win/Linux) + drag on a strip →
              // marquee-select beats in the dragged x-range, open the
              // popup via clickFunction, then highlight those beats on
              // the popup chart with pink plotBands.
              load: function () {
                var stripInst = this;
                // The strip's outer "containerN" div is `renderTo`. The
                // `container` property is Highcharts' internal wrapper
                // with an auto-generated id like "highcharts-abc123".
                // clickFunction (line ~1851) uses renderTo.id for the
                // strip index — mirror that here.
                var renderToEl = stripInst.renderTo || stripInst.container;
                var stripIndex = parseInt(
                  String((renderToEl && renderToEl.id) || "")
                    .replace("container", "")
                );
                if (isNaN(stripIndex)) return;
                var isMac = typeof navigator !== "undefined"
                  && /MAC|MACINTOSH/.test(
                       (navigator.platform || "").toUpperCase()
                     );
                function modifierHeld(e) {
                  return isMac ? !!e.metaKey : !!e.ctrlKey;
                }
                function relPos(e) {
                  var bb = stripInst.container.getBoundingClientRect();
                  return {
                    x: e.clientX - bb.left,
                    y: e.clientY - bb.top,
                  };
                }

                var startPx = null;
                var rectEl  = null;

                // Document-level move/up so cleanup fires even when the
                // mouse leaves this strip (cross-strip drags were leaving
                // the blue marquee rectangle stuck in place).
                function onDocMove(e) {
                  if (startPx == null) return;
                  var p = relPos(e);
                  var x = Math.min(startPx, p.x);
                  var w = Math.abs(p.x - startPx);
                  if (rectEl) {
                    try { rectEl.attr({ x: x, width: w }); } catch (err) {}
                  }
                }

                function onDocUp(e) {
                  if (startPx == null) return;
                  document.removeEventListener("mousemove", onDocMove);
                  document.removeEventListener("mouseup", onDocUp);
                  finishMarquee(e);
                }

                stripInst.container.addEventListener("mousedown", function (e) {
                  if (!modifierHeld(e)) return;
                  if (e.button !== 0)    return;

                  startPx = relPos(e).x;
                  try {
                    rectEl = stripInst.renderer
                      .rect(startPx, stripInst.plotTop, 0, stripInst.plotHeight)
                      .attr({
                        fill: "rgba(0,100,255,0.20)",
                        stroke: "#0064ff",
                        "stroke-width": 1,
                        zIndex: 10,
                      })
                      .add();
                  } catch (err) { rectEl = null; }

                  // Use document listeners so mouseup outside this
                  // chart still triggers cleanup.
                  document.addEventListener("mousemove", onDocMove);
                  document.addEventListener("mouseup",   onDocUp);

                  e.preventDefault();
                  e.stopPropagation();
                });

                function finishMarquee(e) {
                  if (startPx == null) return;
                  var endPx = relPos(e).x;
                  var localStart = startPx;
                  startPx = null;

                  if (rectEl) {
                    try { rectEl.destroy(); } catch (err) {}
                    rectEl = null;
                  }

                  // <5px = treat as click, let normal handler take over.
                  if (Math.abs(endPx - localStart) < 5) return;

                  // Cross-strip Cmd+drag: if mouseup landed on a different
                  // strip than mousedown, fan out to every spanned strip
                  // and skip the popup. Verifier sees red bands on each
                  // strip thumbnail and applies a label via Ctrl shortcut.
                  var endStripIdx = selfNew && selfNew.findStripIndexAt
                    ? selfNew.findStripIndexAt(e.clientX, e.clientY)
                    : null;
                  if (
                    endStripIdx != null
                    && endStripIdx !== stripIndex
                    && selfNew
                    && selfNew.applyCrossStripSelection
                  ) {
                    var xsStartOffset = (selfNew.state && selfNew.state.start) || 0;
                    var endChart = ((selfNew.state && selfNew.state.charts) || [])[endStripIdx - xsStartOffset];
                    if (endChart && endChart.xAxis && endChart.xAxis[0] && endChart.container) {
                      var endBB = endChart.container.getBoundingClientRect();
                      var endPxOnEnd = e.clientX - endBB.left;
                      var startXValue, endXValue;
                      try {
                        startXValue = stripInst.xAxis[0].toValue(localStart);
                        endXValue   = endChart.xAxis[0].toValue(endPxOnEnd);
                      } catch (err) { return; }
                      selfNew.applyCrossStripSelection({
                        startStrip:  stripIndex,
                        endStrip:    endStripIdx,
                        startXValue: startXValue,
                        endXValue:   endXValue,
                      });
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                  }

                  var pxMin = Math.min(localStart, endPx);
                  var pxMax = Math.max(localStart, endPx);

                  var xMin, xMax;
                  try {
                    xMin = stripInst.xAxis[0].toValue(pxMin);
                    xMax = stripInst.xAxis[0].toValue(pxMax);
                  } catch (err) { return; }
                  if (xMin == null || xMax == null) return;

                  // Strip-index → chartid mapping mirrors clickFunction:
                  //   chartid = container - state.start.
                  var startOffset = (selfNew && selfNew.state && selfNew.state.start) || 0;
                  var chartId = stripIndex - startOffset;
                  var beats = (selfNew
                    && selfNew.state
                    && selfNew.state.result3
                    && selfNew.state.result3[chartId]) || [];
                  var j = stripIndex * deviceFrequency;

                  // 1. Compute picks. Band half-width is adaptive: wider
                  //    drag ranges = wider bands so they stay visible at
                  //    zoomed-out popup view. Min ±25 (tight clicks),
                  //    max ±60 (still distinguishable at typical 150-unit
                  //    beat spacing).
                  var pickedXs = [];
                  var newPlotband = [];
                  var rangeW = Math.abs(xMax - xMin);
                  var bandHalf = Math.max(25, Math.min(60, Math.round(rangeW / 200)));
                  for (var k = 0; k < beats.length; k++) {
                    var bx = beats[k] && beats[k].x;
                    if (bx == null) continue;
                    if (bx >= xMin && bx <= xMax) {
                      pickedXs.push(bx);
                      newPlotband.push({
                        color: "#ff3333",
                        from: bx - bandHalf,
                        to: bx + bandHalf,
                        id: "plotband-" + bx,
                      });
                    }
                  }

                  console.log(
                    "[marquee] BEFORE clickFunction:" +
                    " strip=" + stripIndex +
                    " chartid=" + chartId +
                    " state.start=" + startOffset +
                    " beats.length=" + beats.length +
                    " xMin=" + Math.round(xMin) +
                    " xMax=" + Math.round(xMax) +
                    " picked=" + pickedXs.length +
                    " window.beatArr.length=" + ((window.beatArr || []).length) +
                    " window.prevChart=" + window.prevChart +
                    " window.chartid=" + window.chartid
                  );

                  if (!pickedXs.length) return;

                  // 2a. Clean slate BEFORE clickFunction.
                  //
                  // clickFunction has two known side-effects that fight
                  // a fresh marquee on a different strip:
                  //   • Lines ~1858: if window.beatArr is non-empty, it
                  //     tries to remove old plotbands by id — but uses
                  //     the NEW container offset, so the ids are wrong
                  //     and the OLD plotbands stick around.
                  //   • Lines ~2024: pushes the closest beat into the
                  //     `plotband` closure array — leftovers from the
                  //     previous drag get carried into the chart.update
                  //     call inside clickFunction, briefly showing them.
                  //
                  // Wiping both means clickFunction starts from zero and
                  // our override at step 3 has a clean canvas to work on.
                  window.beatArr = [];
                  if (typeof plotband !== "undefined") {
                    plotband.length = 0;
                  }
                  if (typeof chart !== "undefined" && chart && chart.update) {
                    try { chart.update({ xAxis: { plotBands: [] } }, false); }
                    catch (err) { /* ignore */ }
                  }

                  // 2b. Open the popup via clickFunction. This sets up the
                  //    popup chart with this strip's data AND adds a single
                  //    "closest beat" plotband + beatArr entry.
                  try {
                    clickFunction(
                      { chartX: (localStart + endPx) / 2,
                        xAxis: [{ value: (xMin + xMax) / 2 }] },
                      stripInst
                    );
                  } catch (err) {
                    console.error("[marquee] clickFunction failed:", err);
                  }

                  console.log(
                    "[marquee] AFTER clickFunction:" +
                    " window.container=" + window.container +
                    " window.chartid=" + window.chartid +
                    " window.prevChart=" + window.prevChart +
                    " window.beatArr.length=" + ((window.beatArr || []).length)
                  );

                  // 3. Replace plotBands via chart.update — propagates to
                  //    chart-level config (the source-of-truth that
                  //    Highcharts redraws read from). The previous
                  //    addPlotBand + ax.options.plotBands approach left
                  //    chart.options.xAxis.plotBands holding clickFunction's
                  //    single click-closest band; subsequent setExtremes
                  //    redraw rebuilt from THAT, throwing away the 58
                  //    addPlotBand'd entries → bands logged but invisible.
                  try {
                    window.beatArr = pickedXs.map(function (bx) { return bx + j; });
                    if (typeof chart !== "undefined" && chart && chart.update && chart.xAxis && chart.xAxis[0]) {
                      // Sync the closure `plotband` array so future
                      // clickFunction calls operate on the right base.
                      if (typeof plotband !== "undefined") {
                        plotband.length = 0;
                        for (var pcp = 0; pcp < newPlotband.length; pcp++) {
                          plotband.push(newPlotband[pcp]);
                        }
                      }

                      chart.update(
                        { xAxis: { plotBands: newPlotband.slice() } },
                        false
                      );

                      var ax = chart.xAxis[0];
                      console.log(
                        "[marquee L2194] bands after update:" +
                        " requested=" + newPlotband.length +
                        " runtime=" + (ax.plotLinesAndBands || []).length +
                        " options=" + ((ax.options.plotBands || []).length)
                      );

                      var pad = 150;
                      var dataLen = (chart.series
                        && chart.series[0]
                        && chart.series[0].xData
                        && chart.series[0].xData.length) || deviceFrequency;
                      var lo = Math.max(0, xMin - pad);
                      var hi = Math.min(dataLen - 1, xMax + pad);
                      ax.setExtremes(lo, hi, true, false);

                      console.log(
                        "[marquee L2194] after setExtremes:" +
                        " runtime=" + (ax.plotLinesAndBands || []).length +
                        " options=" + ((ax.options.plotBands || []).length)
                      );
                    }
                  } catch (err) {
                    console.warn("[marquee] chart update failed:", err);
                  }

                  console.log(
                    "[marquee] FINAL:" +
                    " window.beatArr=" + JSON.stringify((window.beatArr || []).slice(0, 5)) +
                    (window.beatArr && window.beatArr.length > 5
                      ? " ... (" + window.beatArr.length + " total)"
                      : "")
                  );

                  // Anchor beat = first picked, so single-beat code paths
                  // (e.g. some popup buttons) still have a sensible target.
                  var firstX = pickedXs[0];
                  var firstObj = beats.find(function (p) { return p.x === firstX; });
                  if (firstObj && firstObj.beat) {
                    window.selectedBeatNumber = firstObj.beat;
                    if (selfNew && selfNew.setState) {
                      selfNew.setState({ beat_order: window.selectedBeatNumber });
                    }
                  }

                  e.preventDefault();
                  e.stopPropagation();
                }
              },
            },
            zoomType: "",
          },

          navigator: {
            enabled: false,
          },

          xAxis: [
            {
              min: 0,
              max: deviceFrequency,
              gridLineWidth: 0,
              minorGridLineWidth: 0,
              minorTicks: false,
              labels: {
                enabled: false,
              },
              title: {
                enabled: false,
              },
              visible: false,
            },
          ],
          yAxis: [
            {
              min: gainMin,
              max: gainMax,
              gridLineWidth: 0,
              minorGridLineWidth: 0,
              minorTicks: false,
              labels: {
                enabled: false,
              },
              title: {
                enabled: false,
              },
            },
          ],
          rangeSelector: {
            enabled: false,
          },
          plotOptions: {
            series: {
              turboThreshold: 15500,
            },
          },
          title: {
            text: "",
          },

          series: [
            {
              type: "coloredline",
              data: [],
              color: "#09ff08",
              allowPointSelect: false,
              animation: false,
              enableMouseTracking: false,
              lineWidth: 2,
              marker: {
                enabled: false,
              },
              shadow: false,
              stickyTracking: false,
              showInLegend: false,
            },
          ],
        });
        charts[i].series[0].setData(starr[i], true);

        if (i == 0) {
          clickContainerIndex = clickPointIndex;
          window.stripXValue = 100;
          window.container = 0;
          window.chartid = 0;
          window.pageIndex = 0;
        }

        window.prevChart = clickContainerIndex;
        if (i == clickContainerIndex) {
          charts[i].draggablePlotLine = charts[i].renderer
            .rect(
              charts[i].xAxis[0].toPixels(50) - charts[i].xAxis[0].toPixels(25),
              10,
              50,
              40,
              5
            )
            .attr({
              "stroke-width": 2,
              opacity: 0.5,
              fill: "grey",
              zIndex: 3,
            })
            .add();
          tempChart = charts[i];

          if (charts[i].container.onmousemove != undefined) {
            charts[i].container.onmousemove = function (e) {
              return false;
            };
          }
          var stripIndex = i;
          charts[stripIndex].container.onmousemove = function (e) {
            if (charts[stripIndex].draggablePlotLine.drag) {
              let normalizedEvent = charts[stripIndex].pointer.normalize(e),
                extremes = {
                  left: charts[stripIndex].plotLeft,
                  right:
                    charts[stripIndex].plotLeft + charts[stripIndex].plotWidth,
                };

              if (e.chartX >= extremes.left && e.chartX <= extremes.right) {
                var pointValue = charts[stripIndex].xAxis[0].toValue(e.chartX);
                if (pointValue - 500 <= 0) {
                  chart.xAxis[0].setExtremes(0, pointValue + 2250, true, false);
                } else {
                  chart.xAxis[0].setExtremes(
                    pointValue - 1125,
                    pointValue + 1125,
                    true,
                    false
                  );
                }
                charts[stripIndex].draggablePlotLine.attr({
                  x: e.chartX,
                });
              }
            }
          };
          charts[stripIndex].draggablePlotLine.element.onmousedown =
            function () {
              charts[stripIndex].draggablePlotLine.drag = true;
            };

          charts[stripIndex].draggablePlotLine.element.onmouseup = function () {
            charts[stripIndex].draggablePlotLine.drag = false;
          };
        }
        i = i + 1;

        if (i > limit) {
          clearInterval(myVar);
          if (selfNew.props.match.params.start != undefined) {
            setTimeout(function () {
              $("#selWrap").scrollTop(
                $("#container" + selfNew.props.match.params.start).position()
                  .top - $("#selWrap").position().top
              );

              /*var chart1=selfNew.state.charts[0];
                            selfNew.state.charts[0].draggablePlotLine = selfNew.state.charts[0].renderer.rect(selfNew.state.charts[0].xAxis[0].toPixels(selfNew.props.match.params.xValue) - selfNew.state.charts[0].xAxis[0].toPixels(25), 10, 50, 40, 5)
                                .attr({
                                    'stroke-width': 2,
                                    opacity: 0.5,
                                    fill: 'grey',
                                    zIndex: 3
                                })
                                .add();
                                window.prevChart=0;
                            selfNew.state.chart.xAxis[0].setExtremes(selfNew.props.match.params.xValue - 500, selfNew.props.match.params.xValue + 500, true, false);

                            if (selfNew.state.charts[0].container.onmousemove != undefined) {
                                selfNew.state.charts[0].container.onmousemove = function(e) {
                                    return false;
                                }
                            }
                            var mainCChart = selfNew.state.chart;
                            selfNew.state.charts[0].container.onmousemove = function(e) {
                                if (chart1.draggablePlotLine.drag) {

                                    let normalizedEvent = chart1.pointer.normalize(e),
                                        extremes = {
                                            left: chart1.plotLeft,
                                            right: chart1.plotLeft + chart1.plotWidth
                                        };

                                    if (e.chartX >= extremes.left && e.chartX <= extremes.right) {
                                        var pointValue = chart1.xAxis[0].toValue(e.chartX);
                                        if (pointValue - 500 <= 0) {
                                            mainCChart.xAxis[0].setExtremes(pointValue, pointValue + 1000, true, false);
                                        } else {
                                            mainCChart.xAxis[0].setExtremes(pointValue - 500, pointValue + 500, true, false);
                                        }
                                        chart1.draggablePlotLine.attr({
                                            x: e.chartX
                                        })
                                    }
                                }
                            }

                            selfNew.state.charts[0].draggablePlotLine.element.onmousedown = function() {
                                chart1.draggablePlotLine.drag = true;
                            }

                            selfNew.state.charts[0].draggablePlotLine.element.onmouseup = function() {
                                chart1.draggablePlotLine.drag = false;
                            }
*/
            }, 1000);
          }
        }
      }, 5);
    }
    let firstSelectedPoint = null;
    let measurementLine = null;

    // Function to plot the background graph
    function renderMainChart(self) {
      maximumval = 1000;
      b = 0;
      // var self = this;
      // Ensure correct ID for the popup
      const popup = document.getElementById("popup");
      const ttContainer = document.getElementById("tt_container");

      if (popup && ttContainer) {
        // Update tt_container content
        ttContainer.style.width = "70vw";

        ttContainer.innerHTML = ""; // Clear previous content

        // Create a new Highcharts chart inside tt_container.
        // Store the CURRENT instance on window so clearSelectionState
        // (called from closePopup / recategorize) always reaches the
        // live popup chart — this.state.chart was a stale reference
        // captured at initial mount and never updated.
        chart = new Highcharts.StockChart("tt_container", {
          exporting: {
            enabled: false,
          },
          scrollbar: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          chart: {
            type: "coloredline",
            height: 20 + "%",

            // Don't enable Highcharts zoom — our `load` handler below wires
            // up custom mousedown/move/up so Cmd/Ctrl+drag does marquee
            // selection. Plain drag does nothing.
            zoomType: "",

            resetZoomButton: {
              theme: {
                display: "none",
              },
            },
            events: {
              // After the chart is rendered, attach DOM listeners directly
              // to chart.container. This bypasses Highcharts's own zoom
              // logic — which doesn't fire `selection` reliably on
              // StockChart variants — and gives us pixel-level control.
              //
              // Cmd (Mac) / Ctrl (Win/Linux) + drag → marquee-select beats
              // whose x falls inside the rectangle. Reuses window.beatArr
              // + plotBands so the existing multi-beat popup works as-is.
              load: function () {
                var chartInst = this;
                var isMac = typeof navigator !== "undefined"
                  && /MAC|MACINTOSH/.test(
                       (navigator.platform || "").toUpperCase()
                     );

                function modifierHeld(e) {
                  return isMac ? !!e.metaKey : !!e.ctrlKey;
                }
                function relPos(e) {
                  var bb = chartInst.container.getBoundingClientRect();
                  return {
                    x: e.clientX - bb.left,
                    y: e.clientY - bb.top,
                  };
                }

                var startPx = null;          // pixel x where drag began
                var rectEl  = null;          // visible overlay rectangle

                chartInst.container.addEventListener("mousedown", function (e) {
                  if (!modifierHeld(e)) return;     // not our gesture
                  if (e.button !== 0)    return;    // left-button only

                  var p = relPos(e);
                  startPx = p.x;

                  // Draw a visible blue rectangle overlay so the user sees
                  // exactly what's being selected. plotTop/plotHeight pin
                  // it to the chart area (not header / legend).
                  try {
                    rectEl = chartInst.renderer
                      .rect(startPx, chartInst.plotTop, 0, chartInst.plotHeight)
                      .attr({
                        fill: "rgba(0,100,255,0.15)",
                        stroke: "#0064ff",
                        "stroke-width": 1,
                        zIndex: 10,
                      })
                      .add();
                  } catch (err) { rectEl = null; }

                  e.preventDefault();
                  e.stopPropagation();
                });

                chartInst.container.addEventListener("mousemove", function (e) {
                  if (startPx == null) return;
                  var p = relPos(e);
                  var x = Math.min(startPx, p.x);
                  var w = Math.abs(p.x - startPx);
                  if (rectEl) {
                    try { rectEl.attr({ x: x, width: w }); } catch (err) {}
                  }
                });

                chartInst.container.addEventListener("mouseup", function (e) {
                  if (startPx == null) return;

                  var endPx = relPos(e).x;
                  var localStart = startPx;
                  startPx = null;

                  // Tear down the overlay rectangle.
                  if (rectEl) {
                    try { rectEl.destroy(); } catch (err) {}
                    rectEl = null;
                  }

                  // Tiny drag = click → bail and let the existing click
                  // handler take over.
                  if (Math.abs(endPx - localStart) < 5) return;

                  var pxMin = Math.min(localStart, endPx);
                  var pxMax = Math.max(localStart, endPx);

                  // Convert pixel positions into axis values so we can
                  // match against beat .x coordinates.
                  var xMin, xMax;
                  try {
                    xMin = chartInst.xAxis[0].toValue(pxMin);
                    xMax = chartInst.xAxis[0].toValue(pxMax);
                  } catch (err) { return; }
                  if (xMin == null || xMax == null) return;

                  var beats = (window.result3 || [])[parseInt(window.chartid)] || [];
                  var j = parseInt(window.container) * deviceFrequency;

                  // FRESH selection — wipe previous beatArr + plotBands.
                  try { chartInst.update({ xAxis: { plotBands: [] } }); } catch (err) {}
                  window.beatArr = [];
                  plotband = [];

                  var pickedXs = [];
                  for (var i = 0; i < beats.length; i++) {
                    var bx = beats[i] && beats[i].x;
                    if (bx == null) continue;
                    if (bx >= xMin && bx <= xMax) {
                      pickedXs.push(bx);
                      plotband.push({
                        color: "#ff3333",
                        // Narrow band (±25) so adjacent marqueed beats
                        // stay visually distinct — wide bands at typical
                        // 150-sample beat spacing merge into one blob.
                        from: bx - 25,
                        to: bx + 25,
                        id: "plotband-" + bx,
                      });
                      window.beatArr.push(bx + j);
                    }
                  }

                  console.log(
                    "[marquee] xMin=" + Math.round(xMin) +
                    " xMax=" + Math.round(xMax) +
                    " beatsInRange=" + pickedXs.length +
                    "/" + beats.length
                  );

                  if (plotband.length) {
                    try { chartInst.update({ xAxis: { plotBands: plotband } }); } catch (err) {}
                  }

                  // Mirror Shift+click: set anchor beat so the popup has
                  // a sensible single-beat fallback if an action needs one.
                  if (pickedXs.length) {
                    var firstX = pickedXs[0];
                    var firstObj = beats.find(function (p) { return p.x === firstX; });
                    if (firstObj && firstObj.beat) {
                      window.selectedBeatNumber = firstObj.beat;
                      if (self && self.setState) {
                        self.setState({ beat_order: window.selectedBeatNumber });
                      }
                    }
                  }

                  e.preventDefault();
                  e.stopPropagation();
                });
              },

              click: function (event) {
                if (event.shiftKey) {
                  var k = 0,
                    plotbi = 0;
                  var dis = this;
                  var t = Math.floor(event.xAxis[0]["value"]);
                  var closestArray = [];
                  var multiArray = [];
                  var comStart, comEnd;

                  var j = parseInt(window.container) * deviceFrequency;

                  for (
                    var i = 0;
                    i < window.result3[parseInt(window.chartid)].length;
                    i++
                  ) {
                    closestArray[i] =
                      window.result3[parseInt(window.chartid)][i].x;
                  }
                  var closest = closestArray.reduce(function (prev, curr) {
                    return Math.abs(curr - t) < Math.abs(prev - t)
                      ? curr
                      : prev;
                  });
                  const selectedBeatObj = window.result3[parseInt(window.chartid)].find(
                    (point) => point.x === closest
                  );
                  if (selectedBeatObj && selectedBeatObj.beat) {
                    window.selectedBeatNumber = selectedBeatObj.beat;
                    if (self && self.setState) {
                      self.setState({ beat_order: window.selectedBeatNumber });
                    }
                  }
                  if (window.beatArr.length == 1) {
                    if (closest > window.beatArr[0] - j) {
                      comEnd = closest;
                      comStart = window.beatArr[0] - j;
                    } else {
                      comStart = closest;
                      comEnd = window.beatArr[0] - j;
                    }
                    window.beatArr = [];
                    for (var i = 1; i < closestArray.length; i++) {
                      if (
                        closestArray[i] >= comStart &&
                        closestArray[i] <= comEnd
                      ) {
                        plotband.push({
                          color: "#ff3333",
                          // Narrow band (±25) for range-select so adjacent
                          // beats stay visually distinct.
                          from: closestArray[i] - 25,
                          to: closestArray[i] + 25,
                          id: "plotband-" + closestArray[i],
                        });
                        window.beatArr.push(closestArray[i] + j);
                        /* window.captureArr=window.result3*/
                      }
                    }
                    chart.update({
                      xAxis: {
                        plotBands: plotband,
                      },
                    });

                    //console.log('beatArr',window.beatArr);
                  } else {
                    chart.update({
                      xAxis: {
                        plotBands: [],
                      },
                    });

                    window.beatArr = [];
                    plotband = [];
                    var check = $.inArray(closest + j, window.beatArr);

                    if (check == -1) {
                      plotband.push({
                        color: "#ff9999",
                        from: closest - 100,
                        to: closest + 100,
                        id: "plotband-" + closest,
                      });
                      chart.update({
                        xAxis: {
                          plotBands: plotband,
                        },
                      });
                      window.beatArr.push(closest + j);
                    } else {
                      var index = window.beatArr.indexOf(closest + j);
                      if (index > -1) {
                        window.beatArr.splice(index, 1);
                      }
                      chart.xAxis[0].removePlotBand("plotband-" + closest);
                    }
                  }
                } else {
                  var k = 0;
                  var closestArray = [];
                  var t = Math.floor(event.xAxis[0]["value"]);

                  var j = parseInt(window.container) * deviceFrequency;

                  //beatArr = JSON.parse($('#beatSlected').val());

                  //console.log('index',parseInt(window.pageIndex)+parseInt(window.container));

                  for (
                    var i = 0;
                    i < window.result3[parseInt(window.chartid)].length;
                    i++
                  ) {
                    closestArray[i] =
                      window.result3[parseInt(window.chartid)][i].x;
                  }
                  var closest = closestArray.reduce(function (prev, curr) {
                    return Math.abs(curr - t) < Math.abs(prev - t)
                      ? curr
                      : prev;
                  });
                  const selectedBeatObj = window.result3[parseInt(window.chartid)].find(
                    (point) => point.x === closest
                  );
                  if (selectedBeatObj && selectedBeatObj.beat) {
                    window.selectedBeatNumber = selectedBeatObj.beat;
                    if (self && self.setState) {
                      self.setState({ beat_order: window.selectedBeatNumber });
                    }
                  }
                  var captureIndex = closestArray.indexOf(closest);
                  var beatVal = JSON.parse($("#beatSlected").val());
                  var check = $.inArray(closest + j, window.beatArr);
                  if (check == -1) {
                    plotband.push({
                      color: "#ff9999",
                      from: closest - 100,
                      to: closest + 100,
                      id: "plotband-" + closest,
                    });
                    chart.update({
                      xAxis: {
                        plotBands: plotband,
                      },
                    });

                    window.beatArr.push(closest + j);
                    //       console.log(self);
                    /*self.setState({
                                       'sel_arr':window.result3[parseInt(window.chartid)][captureIndex].arrhythmia
                                   });*/
                  } else {
                    var index = window.beatArr.indexOf(closest + j);
                    if (index > -1) {
                      window.beatArr.splice(index, 1);
                    }
                    chart.xAxis[0].removePlotBand("plotband-" + closest);
                  }
                }
                // Add a keydown event listener to the document
                document.addEventListener("keydown", function (event) {
                  if (event.key === "z" || event.key === "Z") {
                    if (window.beatArr.length > 0) {
                      const lastBeat = window.beatArr.pop(); // Remove the last selected beat
                      const closest =
                        lastBeat - parseInt(window.container) * deviceFrequency;

                      // Remove the specific plot band
                      chart.xAxis[0].removePlotBand("plotband-" + closest);
                    }
                  }
                });
              },
            },
            zoomType: "",
          },
          navigator: {
            enabled: false,
          },
          title: {
            text: "",
          },

          xAxis: [
            {
              min: 0, //setting min to 0
              max: 2250,
              events: {
                setExtremes: function (e) {
                  //val = e.min + 500;
                  if (e.min <= 500) {
                    val = e.min;
                  } else {
                    val = e.min + 500;
                  }
                  tempChart = charts[window.prevChart];
                  if (tempChart != undefined) {
                    if (tempChart.draggablePlotLine != undefined) {
                      val2 = tempChart.xAxis[0].toPixels(val);
                      tempChart.draggablePlotLine.attr({
                        x: val2,
                      });
                    }
                  }
                },
              },
              scrollbar: {
                enabled: true,
              },
              labels: {
                enabled: false,
              },

              tickInterval: 50,
              minorTicks: true,
              minorTickInterval: 10,
              gridLineWidth: 1,
              gridLineColor: "#D3D3D3",
            },
          ],
          yAxis: [
            {
              min: 0,
              max: 10,
              reversed: true,
              gridLineWidth: 0,
              minorGridLineWidth: 0,
              minorTicks: false,

              labels: {
                enabled: true,
              },
              title: {
                enabled: false,
              },
              visible: false,
            },
            {
              min: -0.002,
              max: 0.002,
              tickPositions: [
                -0.002, -0.0015, -0.001, -0.0005, 0.0, 0.0005, 0.001, 0.0015,
                0.002,
              ],
              tickInterval: 0.0005,
              gridLineWidth: 3,
              minorGridLineWidth: 1,
              minorTicks: true,
              minorTickInterval: 0.0001,

              gridLineWidth: 2,
              gridLineColor: "#D3D3D3",
              labels: {
                enabled: false,
              },
              title: {
                enabled: false,
              },
            },
            {
              min: 0,
              max: 10,
              gridLineWidth: 0,
              minorGridLineWidth: 0,
              minorTicks: false,

              labels: {
                enabled: true,
              },
              title: {
                enabled: false,
              },
              visible: false,
            },
          ],
          series: [
            {
              data: [],
              yAxis: 1,
              xAxis: 0,
              color: "#09ff08",
              states: {
                inactive: {
                  opacity: 1,
                },
              },

              allowPointSelect: false,
              animation: false,
              enableMouseTracking: false,
              lineWidth: 2,
              marker: {
                enabled: false,
              },
              shadow: false,
              stickyTracking: false,
              showInLegend: false,
            },
          ],
          rangeSelector: {
            enabled: false,
          },
          plotOptions: {
            series: {
              turboThreshold: 15500,
              colorByPoint: false,
            },
          },
        });

        // Expose the just-created popup chart on window so the central
        // cleanup helper (closePopup → clearSelectionState) can always
        // reach the live instance, regardless of whether state.chart is
        // stale from initial mount.
        window.popupChart = chart;

        // Display the popup
        popup.classList.remove("popup-hidden");
        chart.addSeries(
          {
            yAxis: 0,

            type: "column",

            data: [],
            pointWidth: 400,
            inverted: true,
            tooltip: {
              enabled: false,
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },

            allowPointSelect: false,
            animation: false,
            enableMouseTracking: false,
            lineWidth: 1,

            shadow: false,
            stickyTracking: false,
            showInLegend: false,
          },
          true
        );
        chart.addSeries(
          {
            dataLabels: [
              {
                enabled: true,
                inside: true,
                align: "center",
                format: "B:{point.beat}; HR:{point.hr}", // RR:{point.rr}'
                //format: 'HR:{point.hr}; RR:{point.rr}'
              },
            ],
            yAxis: 2,
            type: "column",
            turboThreshold: 10000,
            data: [],
            pointWidth: 130,
            tooltip: {
              enabled: false,
            },
            point: {
              events: {
                click: function () { },
              },
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },
            allowPointSelect: false,
            animation: false,
            enableMouseTracking: false,
            marker: {
              enabled: false,
            },
            showInLegend: false,
          },
          true
        );
        chart.addSeries(
          {
            name: "R Peak",
            yAxis: 1,
            data: [],

            lineWidth: 0,
            marker: {
              enabled: true,
              radius: 4,
              symbol: "circle",
            },

            tooltip: {
              enabled: false,
            },
            states: {
              hover: {
                lineWidthPlus: 0,
              },
              inactive: {
                opacity: 1,
              },
            },
            enableMouseTracking: false,
          },
          true
        );
        chart.addSeries(
          {
            name: "T Peak",
            yAxis: 1,
            data: [],

            lineWidth: 0,
            marker: {
              enabled: true,
              radius: 4,

              symbol: "circle",
            },

            tooltip: {
              enabled: false,
            },
            states: {
              hover: {
                lineWidthPlus: 0,
              },
              inactive: {
                opacity: 1,
              },
            },
            enableMouseTracking: false,
          },
          true
        );
        chart.addSeries(
          {
            name: "Place Holder",
            yAxis: 1,
            data: [], // Populate with objects like {x: time, y: value, beat: beatNumber}
            lineWidth: 0,
            marker: {
              enabled: true,
              radius: 4,
              symbol: "circle",
            },
            tooltip: {
              pointFormatter: function (event) {
                try {
                  const rpeak_index = this.x;
                  const seriesPoints = chart.series[2].data;
                  const rpeak_amp = this.y;
                  for (let i = 0; i < seriesPoints.length; i++) {
                    if (seriesPoints[i].x == rpeak_index) {
                      return `RPeak: ${rpeak_index} <br> 
                HR: ${seriesPoints[i].hr} <br>  
                Arrythmia: ${seriesPoints[i].arrhythmia} <br>
                RR Time: ${seriesPoints[i].rr} <br>
                `;
                    }
                  }
                } catch (err) {
                }
              },
            },
            states: {
              hover: {
                lineWidthPlus: 0,
              },
              inactive: {
                opacity: 1,
              },
            },
            enableMouseTracking: true, // 👈 This enables hover detection
            point: {
              events: {
                click: function (event) {
                  const chart = this.series.chart;
                  const clickedX = chart.xAxis[0].toValue(event.chartX); // Convert pixel to value
                  const clickedY = chart.yAxis[0].toValue(event.chartY); // Convert pixel to value

                  // Clear previous measurement line and text if they exist
                  if (measurementLine) {
                    measurementLine.destroy();
                    measurementLine = null;
                  }
                  chart.renderer
                    .text("", 0, 0) // Clear any existing text
                    .add();

                  if (!firstSelectedPoint) {
                    // First click: store point
                    firstSelectedPoint = { x: clickedX, y: clickedY };
                    toast(
                      "First beat selected. Now click second beat to measure."
                    );
                  } else {
                    // Second click: measure distance and draw scale
                    const secondPoint = { x: clickedX, y: clickedY };
                    const distance = Math.abs(
                      secondPoint.x - firstSelectedPoint.x
                    );

                    const samplingRate = 250;
                    const rrIntervalMs = Math.round(
                      (distance / samplingRate) * 1000
                    );
                    const rrTimeSec = rrIntervalMs / 1000;
                    const heartRate =
                      rrTimeSec > 0 ? Math.round(60 / rrTimeSec) : "N/A";


                    // Draw measurement scale (horizontal line + label)
                    const x1 = chart.xAxis[0].toPixels(firstSelectedPoint.x); // Convert value to pixel
                    const x2 = chart.xAxis[0].toPixels(secondPoint.x); // Convert value to pixel
                    const yCoord = chart.yAxis[0].toPixels(1.1); // Adjust Y for visual clarity

                    measurementLine = chart.renderer
                      .path(["M", x1, yCoord, "L", x2, yCoord])
                      .attr({
                        stroke: "red",
                        "stroke-width": 2,
                        zIndex: 10,
                      })
                      .add();

                    // Remove previous text if it exists
                    if (chart.measurementText) {
                      chart.measurementText.destroy();
                    }

                    // Add new text
                    chart.measurementText = chart.renderer
                      .text(
                        `RR: ${rrIntervalMs}ms | HR: ${heartRate} bpm`,
                        (x1 + x2) / 2,
                        yCoord - 10
                      )
                      .attr({
                        zIndex: 10,
                        fill: "red",
                      })
                      .css({
                        fontSize: "12px",
                        fontWeight: "bold",
                      })
                      .add();

                    // Reset first point
                    firstSelectedPoint = null;
                  }
                },
              },
            },
          },
          true
        );

        return chart;
      } else {
      }
    }
    if (step == 2) {
      this.state.chart.destroy();
      this.setState({
        databaseid: databaseid,
      });
    }

    document.getElementById("selWrap").innerHTML = "";
    // Speed-up: removed obsolete 2-second setTimeout that wrapped this block.
    // The `beforeGetFolderFiles` worker message has no handler in worker.js
    // (it was silently ignored), so the wait served no purpose — just added
    // 2s of dead time to every chart open. Worker calls are async anyway.
    var newCon = this;
    worker4.postMessage({
      name: "getfolderfiles",
      url: `${apiUrl}api/common/getfolderfiles_New?userid=${userid}&databaseid=${databaseid}`,
    });
    worker4.onmessage = function (event) { };
    worker4.addEventListener("message", function (res) {
      newCon.setState({
        images: res.data[0],
        device_id: res.data[2],
      });
      newCon.setState({
        dblink: res.data[1],
      });
      newCon.filter1(window.filterId);
    });

    // axios
    //     .get('https://web.mybiocalculus.com:5000api/common/getfolderfiles_New?userid=' + userid + '&databaseid=' + databaseid)
    //     .then(res => {

    //         this.setState({
    //             images: res.data[0]
    //         });
    //         this.setState({
    //             dblink: res.data[1]
    //         });
    //         this.filter1(window.filterId);

    //     })
    //     .catch(err => {
    //         console.log(err);
    //     });
    /*this.setState({
            minutes_no: "0"
        });*/

    // renderMainChart(this);

    this.setState({
      result3: [],
    });
    this.setState({
      defarr: [],
    });
    this.setState({
      starr: [],
    });

    var setEcgData = (res) => {
      for (var i = this.state.start; i < res.data.length; i++) {
        // Guard: mainArray[i] may not have been initialised when sc < state.end
        if (window.mainArray[i]) {
          window.mainArray[i].push(res.data[i]);
        }
      }
      if (!this.preEcgValues) {
        this.preEcgValues = res.data;
        this.ecgValues      = flattenAt(res.data, 0);
        this.activityValues = flattenAt(res.data, 1);
        this.peakValues     = flattenAt(res.data, 2);
      } else {
        if (this.state.scrollStatus === "next") {
          this.preEcgValues = this.preEcgValues.filter(
            (e, i) => i > this.state.limitScrollStart - 1
          );

          this.preEcgValues = this.preEcgValues.concat(res.data);
        } else if (this.state.scrollStatus === "prev") {
          this.preEcgValues = this.preEcgValues.filter(
            (e, i) => i < this.state.limitScrollStart - 1
          );
          this.preEcgValues = res.data.concat(this.preEcgValues);
        }
        this.ecgValues      = flattenAt(this.preEcgValues, 0);
        this.activityValues = flattenAt(this.preEcgValues, 1);
        this.peakValues     = flattenAt(this.preEcgValues, 2);
      }

      /*console.log("preEcgValues",this.preEcgValues);
            console.log("this.ecgValues.length",this.ecgValues.length);*/
      datasetMnt = Math.floor(this.ecgValues.length / deviceFrequency);
      //console.log("datasetMnt",datasetMnt);
      if (this.ecgValues.length % deviceFrequency > 0) {
        datasetMnt += 1;
      }

      /*mainEcgArray = this.ecgValues;
            mainActivityArray = this.activityValues;*/

      this.updateRpeaks(this.peakValues);
      var graphPointIndex = 0;
      if (this.state.scrollStatus === "next") {
        if (clickContainerIndex > 2) {
          graphPointIndex = parseInt(clickContainerIndex) - 2;
        }
      } else if (this.state.scrollStatus === "prev") {
        graphPointIndex = 4;
        if (clickContainerIndex < 2) {
          graphPointIndex = parseInt(clickContainerIndex) + 2;
        }
      }

      result3 = chunkPeakArray(this.peakValues, this.state.peakStart);
      window.result3 = result3;
      this.setState({
        result3: result3,
      });

      var acti = 125;
      var counteri = 249;
      var counter = 0;
      var t = 0;
      var actarr = [];
      colorArray = ["#98FB98", "#f1e4e4", "#f7e0a3", "#f09c67"];

      var sliceActStart = graphPointIndex * window.sc;
      var sliceActEnd = sliceActStart + window.sc + 1;
      var curDataArray = this.activityValues.slice(sliceActStart, sliceActEnd);
      // console.log(this.ecgValues.slice(sliceStart, sliceEnd));

      for (var i = 0; i < curDataArray.length; i++) {
        actarr.push({
          x: acti,
          y: 0.5,
          color: colorArray[curDataArray[i]],
        });
        acti = acti + 250;
      }

      chart.hideLoading();
      var sliceStart = graphPointIndex * deviceFrequency;
      var sliceEnd = sliceStart + deviceFrequency + 1;
      // console.log('ECG Valuess',this.ecgValues.slice(sliceStart, sliceEnd));
      chart.series[0].setData(this.ecgValues.slice(sliceStart, sliceEnd), true);

      chart.series[1].setData(actarr, true);
      chart.series[2].setData(result3[graphPointIndex], true);

      renderSmallCharts(graphPointIndex);

      this.setState({
        datasetMnt: datasetMnt,
      });
      this.setState({
        mainEcgArray: this.ecgValues,
      });
      //console.log('mainOne', this.state.mainEcgArray);
      this.setState({
        mainActivityArray: this.activityValues,
      });
      this.setState({
        result3: result3,
      });

      this.setState({
        charts: charts,
      });
      this.setState({
        chart: chart,
      });
      this.setState({
        defarr: defarr,
      });

      this.setState({
        starr: starr,
      });
    };

    //this.state.charts[0].destroy();

    for (var k = 0; k < this.state.charts.length; k++) {
      if (this.state.charts[k] != undefined) {
        //console.log('chart length',this.state.charts);
        this.state.charts[k].destroy();
      }
    }
    /*this.setState({
            minutes_no: start.toString()

        });*/
    //console.log('charts New',this.props.auth.user.minutes_no);
    /* start=parseInt(this.props.auth.user.minutes_no);
         end=parseInt(this.props.auth.user.minutes_no)+4;*/

    // axios
    //     .get(apiUrl + 'api/common/getEcgNewData?start=' + start + '&end=9&userid=' + userid + '&databaseid=' + databaseid)
    //     .then(

    //         setEcgData
    //     )
    //     .catch(err => {});
    var selfOne = this;

    worker2.postMessage({
      name: "getEcgNewData",
      url:
        apiUrl +
        "api/common/getEcgNewData?start=" +
        start +
        "&end=9&userid=" +
        userid +
        "&databaseid=" +
        databaseid,
    });
    worker2.onmessage = function (event) { };
    worker2.addEventListener("message", function (res) {
      for (var i = selfOne.state.start; i < res.data.length; i++) {
        // Guard: mainArray[i] may not exist if sc < res.data.length
        if (window.mainArray[i]) {
          window.mainArray[i].push(res.data[i]);
        }
      }
      if (!selfOne.preEcgValues) {
        selfOne.preEcgValues = res.data;
        selfOne.ecgValues      = flattenAt(res.data, 0);
        selfOne.activityValues = flattenAt(res.data, 1);
        selfOne.peakValues     = flattenAt(res.data, 2);
      } else {
        if (selfOne.state.scrollStatus === "next") {
          selfOne.preEcgValues = selfOne.preEcgValues.filter(
            (e, i) => i > selfOne.state.limitScrollStart - 1
          );

          selfOne.preEcgValues = selfOne.preEcgValues.concat(res.data);
        } else if (selfOne.state.scrollStatus === "prev") {
          selfOne.preEcgValues = selfOne.preEcgValues.filter(
            (e, i) => i < selfOne.state.limitScrollStart - 1
          );
          selfOne.preEcgValues = res.data.concat(selfOne.preEcgValues);
        }
        selfOne.ecgValues      = flattenAt(selfOne.preEcgValues, 0);
        selfOne.activityValues = flattenAt(selfOne.preEcgValues, 1);
        selfOne.peakValues     = flattenAt(selfOne.preEcgValues, 2);
      }

      // console.log("preEcgValues", selfOne.preEcgValues);
      // console.log("selfOne.ecgValues.length", selfOne.ecgValues.length);
      datasetMnt = Math.floor(selfOne.ecgValues.length / deviceFrequency);
      //console.log("datasetMnt",datasetMnt);
      if (selfOne.ecgValues.length % deviceFrequency > 0) {
        datasetMnt += 1;
      }

      /*mainEcgArray = selfOne.ecgValues;
                mainActivityArray = selfOne.activityValues;*/
      selfOne.updateRpeaks(selfOne.peakValues);
      var graphPointIndex = 0;
      if (selfOne.state.scrollStatus === "next") {
        if (clickContainerIndex > 2) {
          graphPointIndex = parseInt(clickContainerIndex) - 2;
        }
      } else if (selfOne.state.scrollStatus === "prev") {
        graphPointIndex = 4;
        if (clickContainerIndex < 2) {
          graphPointIndex = parseInt(clickContainerIndex) + 2;
        }
      }

      result3 = chunkPeakArray(selfOne.peakValues, selfOne.state.peakStart);
      window.result3 = result3;
      selfOne.setState({
        result3: result3,
      });

      var acti = 125;
      var counteri = 249;
      var counter = 0;
      var t = 0;
      var actarr = [];
      colorArray = ["#98FB98", "#f1e4e4", "#f7e0a3", "#f09c67"];

      var sliceActStart = graphPointIndex * window.sc;
      var sliceActEnd = sliceActStart + window.sc + 1;
      var curDataArray = selfOne.activityValues.slice(
        sliceActStart,
        sliceActEnd
      );
      // console.log(selfOne.ecgValues.slice(sliceStart, sliceEnd));

      for (var i = 0; i < curDataArray.length; i++) {
        actarr.push({
          x: acti,
          y: 0.5,
          color: colorArray[curDataArray[i]],
        });
        acti = acti + 250;
      }

      chart.hideLoading();
      var sliceStart = graphPointIndex * deviceFrequency;
      var sliceEnd = sliceStart + deviceFrequency + 1;
      // console.log('ECG Valuess',selfOne.ecgValues.slice(sliceStart, sliceEnd));
      chart.series[0].setData(
        selfOne.ecgValues.slice(sliceStart, sliceEnd),
        true
      );
      chart.series[1].setData(actarr, true);
      chart.series[2].setData(result3[graphPointIndex], true);

      renderSmallCharts(graphPointIndex);

      selfOne.setState({
        datasetMnt: datasetMnt,
      });
      selfOne.setState({
        mainEcgArray: selfOne.ecgValues,
      });
      //console.log('mainOne', selfOne.state.mainEcgArray);
      selfOne.setState({
        mainActivityArray: selfOne.activityValues,
      });
      selfOne.setState({
        result3: result3,
      });

      selfOne.setState({
        charts: charts,
      });
      selfOne.setState({
        chart: chart,
      });
      selfOne.setState({
        defarr: defarr,
      });

      selfOne.setState({
        starr: starr,
      });
    });

    var newArrAxiosRes2 = [];

    this.getData(userid, databaseid).then((value) => {
      // console.log("value", value);
      for (var ij = 0; ij < window.sc - 10; ij++) {
        newArrAxiosRes2[ij] = value[ij].data;
      }
      if (newArrAxiosRes2 != undefined) {
        var ind = 0;
        for (var i = 10; i < window.sc; i++) {
          // Guard: skip if either side is missing (mainArray slot or fetched chunk)
          if (
            window.mainArray[i] &&
            window.mainArray[i].length == 0 &&
            newArrAxiosRes2[ind]
          ) {
            window.mainArray[i].push(newArrAxiosRes2[ind][0]);
            ind = ind + 1;
          }
        }
      }
    });

    var setGraphMarker = (res) => {
      this.state.graphMarker = res;

      var clickPointIndex = 0;
      if (this.state.scrollStatus === "next") {
        if (clickContainerIndex > 2) {
          clickPointIndex = parseInt(clickContainerIndex) - 2;
        }
      } else if (this.state.scrollStatus === "prev") {
        clickPointIndex = 4;
        if (clickContainerIndex < 2) {
          clickPointIndex = parseInt(clickContainerIndex) + 2;
        }
      }
      var graphPointIndex = pageIndex * 3;
      // parr = chunkMarkerArray(res.data.ppeak_index, res.data.ppeak_amp, graphPointIndex);

      // chart.series[3].update({
      //     data: parr[clickPointIndex],
      // }, true);
      // this.setState({
      //     parr: parr
      // });
      // tarr = chunkMarkerArray(res.data.tpeak_index, res.data.tpeak_amp, graphPointIndex);
      // chart.series[7].update({
      //     data: tarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     tarr: tarr
      // });
      // ponarr = chunkMarkerArray(res.data.pon_index, res.data.pon_amp, graphPointIndex);
      // chart.series[8].update({
      //     data: ponarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     ponarr: ponarr
      // });
      // qarr = chunkMarkerArray(res.data.q_index, res.data.q_amp, graphPointIndex);
      // chart.series[4].update({
      //     data: qarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     qarr: qarr
      // });
      rarr = chunkMarkerArray(
        res.data.rpeak_index,
        res.data.rpeak_amp,
        graphPointIndex
      );
      chart.series[5].update(
        {
          data: rarr[clickPointIndex],
        },
        true
      );
      this.setState({
        rarr: rarr,
      });
      // sarr = chunkMarkerArray(res.data.s_index, res.data.s_amp, graphPointIndex);
      // chart.series[6].update({
      //     data: sarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     sarr: sarr
      // });
      // poffarr = chunkMarkerArray(res.data.poff_index, res.data.poff_amp, graphPointIndex);
      // chart.series[9].update({
      //     data: poffarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     poffarr: poffarr
      // });
      // tonarr = chunkMarkerArray(res.data.ton_index, res.data.ton_amp, graphPointIndex);
      // chart.series[10].update({
      //     data: tonarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     tonarr: tonarr
      // });
      // toffarr = chunkMarkerArray(res.data.toff_index, res.data.toff_amp, graphPointIndex);
      // chart.series[11].update({
      //     data: toffarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     toffarr: toffarr
      // });
      // jarr = chunkMarkerArray(res.data.j_index, res.data.j_amp, graphPointIndex);
      // chart.series[12].update({
      //     data: jarr[clickPointIndex],
      // }, true);
      // this.setState({
      //     jarr: jarr
      // });
      // chart.series[13].update({
      //     data: [],
      // }, true);
      // console.log(this.state.rarr);
    };
    if (Object.keys(this.state.graphMarker).length > 0) {
      setGraphMarker(this.state.graphMarker);
    } else {
      // axios
      //     .get(apiUrl + 'api/common/getGraphMarker?userid=' + userid + '&databaseid=' + databaseid)
      //     .then(
      //         setGraphMarker
      //     )
      var markerThis = this;
      worker7.postMessage({
        name: "getGraphMarker",
        url:
          apiUrl +
          "api/common/getGraphMarker?userid=" +
          userid +
          "&databaseid=" +
          databaseid,
      });
      worker7.onmessage = function (event) { };
      worker7.addEventListener("message", function (res) {
        if (res.data != null) {
          markerThis.state.graphMarker = res;

          var clickPointIndex = 0;
          if (markerThis.state.scrollStatus === "next") {
            if (clickContainerIndex > 2) {
              clickPointIndex = parseInt(clickContainerIndex) - 2;
            }
          } else if (markerThis.state.scrollStatus === "prev") {
            clickPointIndex = 4;
            if (clickContainerIndex < 2) {
              clickPointIndex = parseInt(clickContainerIndex) + 2;
            }
          }
          var graphPointIndex = pageIndex * 3;
          // parr = chunkMarkerArray(res.data.ppeak_index, res.data.ppeak_amp, graphPointIndex);

          // chart.series[3].update({
          //     data: parr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     parr: parr
          // });
          // tarr = chunkMarkerArray(res.data.tpeak_index, res.data.tpeak_amp, graphPointIndex);
          // chart.series[7].update({
          //     data: tarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     tarr: tarr
          // });
          // ponarr = chunkMarkerArray(res.data.pon_index, res.data.pon_amp, graphPointIndex);
          // chart.series[8].update({
          //     data: ponarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     ponarr: ponarr
          // });
          // qarr = chunkMarkerArray(res.data.q_index, res.data.q_amp, graphPointIndex);
          // chart.series[4].update({
          //     data: qarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     qarr: qarr
          // });
          rarr = chunkMarkerArray(
            res.data.rpeak_index,
            res.data.rpeak_amp,
            graphPointIndex
          );
          chart.series[5].update(
            {
              data: rarr[clickPointIndex],
            },
            true
          );
          markerThis.setState({
            rarr: rarr,
          });
          // sarr = chunkMarkerArray(res.data.s_index, res.data.s_amp, graphPointIndex);
          // chart.series[6].update({
          //     data: sarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     sarr: sarr
          // });
          // poffarr = chunkMarkerArray(res.data.poff_index, res.data.poff_amp, graphPointIndex);
          // chart.series[9].update({
          //     data: poffarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     poffarr: poffarr
          // });
          // tonarr = chunkMarkerArray(res.data.ton_index, res.data.ton_amp, graphPointIndex);
          // chart.series[10].update({
          //     data: tonarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     tonarr: tonarr
          // });
          // toffarr = chunkMarkerArray(res.data.toff_index, res.data.toff_amp, graphPointIndex);
          // chart.series[11].update({
          //     data: toffarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     toffarr: toffarr
          // });
          // jarr = chunkMarkerArray(res.data.j_index, res.data.j_amp, graphPointIndex);
          // chart.series[12].update({
          //     data: jarr[clickPointIndex],
          // }, true);
          // markerThis.setState({
          //     jarr: jarr
          // });
          // chart.series[13].update({
          //     data: [],
          // }, true);
        }
      });
    }

    const data = {
      databaseid: dbId,
      userid: userid,
    };
    var setVerifyCheck = (res) => {
      this.state.verifyCheck = res;
      if (res.data == 0) {
        $("#verfiyBtn").css("display", "inline-block");
      } else if (res.data == 1) {
        $("#verfiyBtn").css("display", "none");
      }
    };
    if (Object.keys(this.state.verifyCheck).length > 0) {
      setVerifyCheck(this.state.verifyCheck);
    } else {
      var verifycon = this;
      worker3.postMessage({
        name: "checkVerify",
        url: apiUrl + "api/common/checkVerify",
        dat: data,
      });
      worker3.onmessage = function (event) { };
      worker3.addEventListener("message", function (res) {
        verifycon.state.verifyCheck = res;
        if (res.data == 0) {
          $("#verfiyBtn").css("display", "inline-block");
        } else if (res.data == 1) {
          $("#verfiyBtn").css("display", "none");
        }
      });
      axios
        .post(`${apiUrl}api/common/checkVerify`, data)
        .then((response) => {
          this.setState({ verifiedStatus: response.data });
          // You can add any other logic to handle the response if needed
          // console.log("reposne:", this.state.verifiedStatus);
        })
        .catch((error) => {
          // Optionally, add further error handling logic here
        });
    }
    renderMainChart(this);
  }
  nextBtnLink(userid, databaseid) {
    const treemenudb = this.state.treemenu;

    // Array to store the extracted date and time
    let dateTimeArray = [];

    // Iterate through the treemenu and extract the date and time part
    Object.keys(treemenudb).forEach((dateKey) => {
      treemenudb[dateKey].forEach((item) => {
        const dateTime = item.date.split("+")[0].replace("T", " "); // Extract date and time
        dateTimeArray.push(dateTime);
      });
    });

    // Sort the extracted dateTimeArray (lexicographically works for date strings)
    dateTimeArray.sort();

    // console.log("Sorted date and time:", dateTimeArray);

    // Check if the sorted date and time matches the databaseid and get the index
    const matchedIndex = dateTimeArray.findIndex(
      (dateTime) => dateTime === databaseid
    );

    if (matchedIndex !== -1) {
      // console.log("Matched databaseid:", databaseid);
      // console.log("Matched date and time:", dateTimeArray[matchedIndex]);
      // console.log("Matched index:", matchedIndex);

      // Check if the next index (matchedIndex + 1) exists and update state with nextDateTime
      if (matchedIndex + 1 < dateTimeArray.length) {
        const nextDateTime = dateTimeArray[matchedIndex + 1];

        // Set the state with the nextDateTime
        this.setState({ databaseid: nextDateTime, dblink: nextDateTime });
        //  this.renderNewChart(userid,nextDateTime,2)
        window.location.href = "/verifier-chart/" + userid + "/" + nextDateTime;
      } else {
      }
    } else {
    }
  }

  prevBtnLink(userid, databaseid) {
    // console.log("databaseid!!!!!!!!!!!!", databaseid);
    const treemenudb = this.state.treemenu;

    // Array to store the extracted date and time
    let dateTimeArray = [];

    // Iterate through the treemenu and extract the date and time part
    Object.keys(treemenudb).forEach((dateKey) => {
      treemenudb[dateKey].forEach((item) => {
        const dateTime = item.date.split("+")[0].replace("T", " "); // Extract date and time
        dateTimeArray.push(dateTime);
      });
    });

    // Sort the extracted dateTimeArray (lexicographically works for date strings)
    dateTimeArray.sort();

    // console.log("Sorted date and time:", dateTimeArray);

    // Check if the sorted date and time matches the databaseid and get the index
    const matchedIndex = dateTimeArray.findIndex(
      (dateTime) => dateTime === databaseid
    );

    if (matchedIndex !== -1) {
      // console.log("Matched databaseid:", databaseid);
      // console.log("Matched date and time:", dateTimeArray[matchedIndex]);
      // console.log("Matched index:", matchedIndex);

      // Check if the previous index (matchedIndex - 1) exists and update state with prevDateTime
      if (matchedIndex - 1 >= 0) {
        const prevDateTime = dateTimeArray[matchedIndex - 1];
        // console.log("Previous Date and Time (index - 1):", prevDateTime);

        // Set the state with the prevDateTime
        this.setState({ databaseid: prevDateTime, dblink: prevDateTime });
        this.state.chart.destroy();
        this.setState({
          chart: null,
        });
        //  this.renderNewChart(userid,prevDateTime,2)
        window.location.href = "/verifier-chart/" + userid + "/" + prevDateTime;
      } else {
      }
    } else {
    }
  }

  newDataClick(e) {
    const buttonId = e.currentTarget.id;
    const databaseid = this.state.databaseid;
    const userid = this.props.match.params.userid;

    //  this.clearCurrentChart()

    // Call the appropriate link functions and render the new chart based on button clicked
    if (buttonId === "nextBtn") {
      this.nextBtnLink(userid, databaseid);
    } else if (buttonId === "prevBtn") {
      this.prevBtnLink(userid, databaseid);
    }
  }

  componentDidMount(prevProps, prevState) {
    // Fetch the doctor list once on mount so any patient-info / edit
    // modal opened on this page (and its children) can render a
    // populated doctor dropdown. Mirrors the worker-based pattern used
    // on every other admin page (patient-list:366, VerifierHome:383,
    // QC-Home:221, Labled-patients:245, Reporting-page:197). Without
    // this, state.doctors stays undefined → dropdown is empty even
    // though the doctor exists.
    if (!this._doctorsFetched) {
      this._doctorsFetched = true;
      try {
        var doctorWorker = new Worker();
        var newstat = this;
        doctorWorker.postMessage({
          name: "alldoctors",
          url: apiUrl + "api/users/alldoctors",
        });
        doctorWorker.addEventListener("message", function (event) {
          if (event && event.data) {
            newstat.setState({ doctors: event.data });
          }
        });
      } catch (e) {
        // Worker setup failed (very rare). Fall back to direct axios so
        // the dropdown still gets populated.
        axios
          .get(apiUrl + "api/users/alldoctors")
          .then(function (res) {
            if (Array.isArray(res.data)) {
              newstat.setState({ doctors: res.data });
            }
          })
          .catch(function () { /* silent */ });
      }
    }

    // Which day/half/quarter of this patient's recording is mine (set via
    // the admin's Quick Assigner Notes). Informational only — shown as a
    // badge near the patient header so the verifier knows their intended
    // scope without it restricting which files they can actually open.
    axios
      .get(apiUrl + "api/users/myBlockAssignments")
      .then((res) => {
        var blocks = (res.data && res.data.blocks) || {};
        var userid = this.props.match.params.userid;
        this.setState({ myBlock: blocks[userid] || "" });
      })
      .catch(() => {});

    // Analysed chart: Verifier (2), Admin Verifier (8), and the restricted
    // Verifier tier (10) only. Partners (7) are intentionally NOT allowed
    // here — they get raw data via /verifier-unanalysed only.
    //
    // Ownership (whether this patient is in the logged-in verifier's own
    // `patients` array) is intentionally NOT enforced here anymore — any
    // verifier can open a shared link to any patient for doubt clearance /
    // second opinion. This only gates VIEWING: verifyArrhythmia_nameNew
    // (the actual verify-write action) has no ownership check server-side
    // either way, so this never changed who could record a verification,
    // only who could load the page to look.
    if (
      this.state.verifiertype !== "8" &&
      this.state.verifiertype !== "2" &&
      this.state.verifiertype !== "10" &&
      this.state.verifiertype !== "6"
    ) {
      this.props.history.push("/error");
    }

    // Restore Quick Recategorization preset from local cache (per patient).
    // localStorage is browser-local, so each verifier sees only their own saved preset.
    try {
      const { userid: _puid } = this.props.match.params || {};
      if (_puid) {
        const _raw = localStorage.getItem("qrecat:" + _puid);
        if (_raw) {
          const _preset = JSON.parse(_raw);
          if (_preset && typeof _preset === "object") {
            this.setState(_preset);
          }
        }
      }
    } catch (e) { /* ignore corrupt cache */ }

    window.container = 0;
    window.resumeFlag = 0;
    window.eventclass = "all";
    window.selectAll = 0;
    window.beatArr = [];
    window.timer = null;
    window.chartid = 0;
    window.mainArray = [];
    window.prevStart = 0;
    window.titleFlag = 0;
    window.diaryFlag = 0;
    this.addDragListeners();

    /* console.log(socket.connected);
    socket.on('connect', function(){console.log('connected')});
    socket.on('connect_error', function(err){console.log(err)});
    socket.on('data', function(data){console.log(data)});
    socket.on('disconnect', function(){console.log('disconnected')});*/
    //window.addEventListener('beforeunload', this.keepOnPage);

    this.callDataAPIs();
    if (!this.state.keyIntegrationStatus) {
      this.keyIntegration();
      this.state.keyIntegrationStatus = 1;
    }
    document.addEventListener("keydown", this.handleKeyPress);

    // Ctrl + wheel inside the graph area scrolls the outer page (the
    // second scrollbar) instead of the graph's own scroll. Plain wheel
    // still scrolls the graph as before.
    // React's onWheel is passive in React 17+, so preventDefault() inside
    // it has no effect — we must register natively with { passive: false }.
    this._ctrlWheelHandler = (e) => {
      if (!e.ctrlKey) return;                // plain scroll → graph (default)
      e.preventDefault();                    // stop graph scroll + browser zoom
      // Find the page-level scrollable ancestor. window scroll handles the
      // common case; if the page wraps content in a scrolling div, fall
      // back to scrolling document.scrollingElement.
      const delta = e.deltaY;
      window.scrollBy({ top: delta, left: 0, behavior: "auto" });
    };
    this._installCtrlWheelTimer = setInterval(() => {
      const selWrap = document.getElementById("selWrap");
      if (selWrap && !selWrap._ctrlWheelInstalled) {
        selWrap.addEventListener("wheel", this._ctrlWheelHandler, { passive: false });
        selWrap._ctrlWheelInstalled = true;
        clearInterval(this._installCtrlWheelTimer);
        this._installCtrlWheelTimer = null;
      }
    }, 100);

    // Type-10 only: popup when the admin assigns a new patient, so a
    // verifier who's deep in a long verification here still notices
    // without having to leave this page.
    if (localStorage.getItem("verifiertype") === "10") {
      this.checkNewAssignments();
      this.assignmentAlertInterval = setInterval(this.checkNewAssignments, 60000);
    }
  }
  checkNewAssignments = () => {
    axios
      .get(apiUrl + "api/users/myNewAssignments")
      .then((res) => {
        const alerts = (res.data && res.data.alerts) || [];
        if (alerts.length) {
          this.setState({ newAssignmentAlerts: alerts });
        }
      })
      .catch(() => {});
  };

  acknowledgeNewAssignments = () => {
    const alertIds = this.state.newAssignmentAlerts.map((a) => a.id);
    axios
      .post(apiUrl + "api/users/ackNewAssignments", { alertIds })
      .catch(() => {})
      .finally(() => {
        this.setState({ newAssignmentAlerts: [] });
      });
  };
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPress);
    if (this.assignmentAlertInterval) clearInterval(this.assignmentAlertInterval);
    if (this._installCtrlWheelTimer) {
      clearInterval(this._installCtrlWheelTimer);
    }
    const selWrap = document.getElementById("selWrap");
    if (selWrap && this._ctrlWheelHandler) {
      selWrap.removeEventListener("wheel", this._ctrlWheelHandler);
      selWrap._ctrlWheelInstalled = false;
    }
  }

  addDragListeners() {
    const popup = document.querySelector("#popup");
    let isDragging = false;
    let startX, startY, initialX, initialY;

    const dragMouseDown = (e) => {
      e.preventDefault();
      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      initialX = popup.offsetLeft;
      initialY = popup.offsetTop;
      document.addEventListener("mousemove", elementDrag);
      document.addEventListener("mouseup", closeDragElement);
    };

    const elementDrag = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const deltaX = e.clientX - startX;
      const deltaY = e.clientY - startY;
      popup.style.left = initialX + deltaX + "px";
      popup.style.top = initialY + deltaY + "px";
    };

    const closeDragElement = () => {
      isDragging = false;
      document.removeEventListener("mousemove", elementDrag);
      document.removeEventListener("mouseup", closeDragElement);
    };

    if (popup) {
      const draggableArea = popup.querySelector(".draggable-area");
      draggableArea.addEventListener("mousedown", dragMouseDown);
    }
  }
  keyIntegration() {
    $(document).keydown((e) => {
      //console.log('key down');
      if (this.state.showVerifierModal) {
      return;
    }

    // ✅ 2. If user is typing in input / textarea / react-select
    const tag = e.target.tagName;
    const isReactSelect =
      e.target.closest &&
      e.target.closest(".basic-multi-select");

    if (
      tag === "INPUT" ||
      tag === "TEXTAREA" ||
      isReactSelect
    ) {
      return;
    }

      if (
        this.state.currentTab == "chart_tab_2" &&
        this.state.keyIntegrationStatus != 0
      ) {
        let chart = this.state.chart.xAxis[0];
        let extremes = chart.getExtremes();
        let zoomLevel = extremes.max - extremes.min;
        switch (e.which) {
          case 65:
          case 37: // lefty
            var minL = extremes.min - zoomLevel;
            var maxL = extremes.min;
            if (minL <= 0) {
              maxL = 2250;
              minL = 0;
            }
            if (extremes.min == 0) {
              var e = $.Event("keydown");

              // e.which is used to set the keycode
              e.which = 40; // it is down
              $("body").trigger(e);
            } else {
              chart.setExtremes(minL, maxL);
            }
            break;

          case 87:
          case 38: // up
            // this.handleTopScroll();

            break;

          case 68:
          case 39: // right
            var min = extremes.max;
            var max = extremes.max + zoomLevel;
            var stripIndex = window.prevChart;
            var sliceStart = stripIndex * deviceFrequency;
            var sliceEnd = sliceStart + deviceFrequency + 1;
            var currentEcgArray = this.state.mainEcgArray.slice(
              sliceStart,
              sliceEnd
            );
            if (max >= deviceFrequency) {
              max = deviceFrequency - 1;
              min = deviceFrequency - 2250;
            } else if (max > currentEcgArray.length) {
              max = currentEcgArray.length;
              min = currentEcgArray.length - zoomLevel;
            }
            if (extremes.max == deviceFrequency - 1) {
              var e = $.Event("keydown");

              // e.which is used to set the keycode
              e.which = 40; // it is down
              $("body").trigger(e);
            } else {
              chart.setExtremes(min, max);
            }
            break;

          case 83:
          case 40: // down
            //  this.handleBottomScroll();

            break;

          default:
            return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
      }
    });
  }

  recategorizeImg(e) {
    var checkedArray = [];
    var userid = this.props.match.params.userid;
    var databaseid = this.state.dblink;
    var folder = e.currentTarget.value;
    var self = this;
    var clickedPI_;
    var value1;
    const data = [];
    var i = 0;
    $("input:checkbox[name=test]:checked").each(function () {
      checkedArray.push($(this).val());
      this.checked = false;
      var clickedPI = this.id.toString();
      clickedPI = clickedPI.split("_");
      clickedPI_ =
        clickedPI[1].substring(0, 2) +
        ":" +
        clickedPI[1].substring(2, 4) +
        ":" +
        clickedPI[1].substring(4, 6);
      data[i] = {
        userid: userid,
        databaseid: databaseid,
        clickedPI_: clickedPI_,
      };
      i = i + 1;

      window.beatArr.push(clickedPI[2].split(".")[0]);
      value1 = this.value.toString();
    });

    if (folder == "un") {
      value1 = "Undiagnosed";
    } else if (folder == "nsr") {
      value1 = "Normal Sinus Rhythm";
    } else if (folder == "sb") {
      value1 = "Sinus Bradycardia";
    } else if (folder == "st") {
      value1 = "Sinus Tachycardia";
    } else if (folder == "pac") {
      value1 = "PAC";
    } else if (folder == "pvc") {
      value1 = "PVC";
    } else if (folder == "vt") {
      value1 = "Ventricular Tachycardia";
    } else if (folder == "af") {
      value1 = "AFib";
    } else if (folder == "sp") {
      value1 = "Sinus Pause";
    } else if (folder == "pa") {
      value1 = "P Absent";
    } else if (folder == "irr") {
      value1 = "Irregular RR";
    } else if (folder == "ipr") {
      value1 = "Irregular PR";
    } else if (folder == "sqt") {
      value1 = "Short QT";
    } else if (folder == "lqt") {
      value1 = "Prolonged QT";
    } else if (folder == "pbt") {
      value1 = "Paced";
    }

    self.recategorizeAfterImage(value1);

    if (checkedArray.length > 0) {
      const data = {
        userid: userid,
        databaseid: databaseid,
        checkedArray: checkedArray,
        folder: folder,
      };
      //console.log("reCatData",data);
      axios
        .post(
          `${apiUrl}api/common/reCategorize_New`,

          data
        )
        .then((res) => {
          axios
            .get(
              `${apiUrl}api/common/getfolderfiles_New?userid=${userid}&databaseid=${databaseid}`
            )
            .then((res) => {
              this.setState({
                images: res.data[0],
              });
              this.setState({
                dblink: res.data[1],
                device_id: res.data[2],
              });
            })
            .catch((err) => {
            });
        })
        .catch((err) => {
        });
      // axios
      //     .post('https://web.mybiocalculus.com:5000api/common/reCategorize', data)
      //     .then(res => {
      //         var newCon=this;
      //         worker4.postMessage({ name:'getfolderfiles',url: 'https://web.mybiocalculus.com:5000api/common/getfolderfiles_New?userid=' + userid + '&databaseid=' + databaseid});
      //         worker4.onmessage = function (event) {};
      //         worker4.addEventListener("message", function (res) {
      //             newCon.setState({
      //                     images: res.data[0]
      //                 });
      //                 newCon.setState({
      //                     dblink: res.data[1]
      //                 });
      //                 newCon.filter1(window.filterId);

      //             });

      //     })
      //     .catch(err => {
      //         console.log(err);
      //     });
    }
  }

  removeFiles(e) {
    var checkedArray = [];
    var userid = this.props.match.params.userid;
    var databaseid = this.state.dblink;
    var folder = window.eventclass;
    $("input:checkbox[name=test]:checked").each(function () {
      checkedArray.push($(this).val());
      this.checked = false;
    });
    if (checkedArray.length > 0) {
      const data = {
        userid: userid,
        databaseid: databaseid,
        checkedArray: checkedArray,
        folder: folder,
      };
      axios
        .post(`${apiUrl}api/common/removeFiles`, data)
        .then((res) => {
          alert("Files Removed");
          var newCon = this;
          worker4.postMessage({
            name: "getfolderfiles",
            url: `${genevent2}api/common/getfolderfiles_New_New?userid=${userid}&databaseid=${databaseid}`,
          });
          worker4.onmessage = function (event) { };
          worker4.addEventListener("message", function (res) {
            newCon.setState({
              images: res.data[0],
            });
            newCon.setState({
              dblink: res.data[1],
              device_id: res.data[2],
            });
            newCon.filter1(window.filterId);
          });
          // axios
          //     .get('https://web.mybiocalculus.com:5000api/common/getfolderfiles_New?userid=' + userid + '&databaseid=' + databaseid)
          //     .then(res => {
          //         //  console.log(res.data[0]);
          //         this.setState({
          //             images: res.data[0]
          //         });
          //         this.setState({
          //             dblink: res.data[1]
          //         });

          //     })
          //     .catch(err => {
          //         console.log(err);
          //     });
        })
        .catch((err) => {
        });
    }
  }
  removeAll(e) {
    if (window.confirm("Do you want to delete all the ECG Event Strips?")) {

      var userid = this.props.match.params.userid;
      const data = {
        userid: userid,
      };

      axios
        .post(`${apiUrl}/api/common/removeAll`, data)
        .then((res) => {
        })
        .catch((err) => {
        });
    }
  }
  /* getDiaryInfo(e) {
           var userid = this.props.match.params.userid;
          axios
                        .get(apiUrl+'api/patients/getDiaryInfo?userid=' + userid )
                        .then(res => {

                        })
                        .catch(err => {
                        });

    } */

  selectAll(e) {
    var searchDiv = document.getElementById("portfolio");
    var selBtn = document.getElementById("SA");
    //console.log(searchDiv);
    /* var cds= document.getElementById('currentDataSet');
         var fds = document.getElementById('fullDataSet');*/
    //console.log(fds);

    if (window.selectAll == 0) {
      selBtn.childNodes[0].text = "Deselect All";
      for (var i = 0; i < searchDiv.childNodes.length; i++) {
        if (
          searchDiv.childNodes[i].childNodes[1].className == window.eventclass
        ) {
          searchDiv.childNodes[i].childNodes[1].checked = "checked";
        }
      }
      window.selectAll = 1;
    } else if (window.selectAll == 1) {
      selBtn.childNodes[0].text = "Select All";
      for (var i = 0; i < searchDiv.childNodes.length; i++) {
        if (
          searchDiv.childNodes[i].childNodes[1].className == window.eventclass
        ) {
          searchDiv.childNodes[i].childNodes[1].checked = "";
        }
      }
      window.selectAll = 0;
    }
  }

  addImageToReport(e) {
    var checkedArray = [];
    var userid = this.props.match.params.userid;
    var databaseid = this.state.dblink;
    var folder = window.eventclass;
    $("input:checkbox[name=test]:checked").each(function () {
      checkedArray.push($(this).val());
      this.checked = false;
    });
    if (checkedArray.length > 0) {
      const data = {
        userid: userid,
        databaseid: databaseid,
        checkedArray: checkedArray,
        folder: folder,
      };
      axios
        .post(
          `${apiUrl}api/common/reCategorizeImg`,

          data
        )
        .then((res) => {
        })
        .catch((err) => {
        });
    }
  }

  filter(e) {
    var selected = e.currentTarget.id;
    //console.log('Main filter',selected);
    if (selected == "all") {
      $("#portfolio").children().show();
      $(".filterMain a").removeClass("active");
      $("#" + e.currentTarget.id).addClass("active");
      window.eventclass = e.currentTarget.id;
    } else {
      $("#portfolio").children().hide();
      var thisclass = "#portfolio ." + selected;
      $("#portfolio ." + selected).show();
      $(".filterMain a").removeClass("active");
      $("#" + e.currentTarget.id + " a").addClass("active");
      window.eventclass = e.currentTarget.id;
    }
  }
  filter1(selected) {
    //console.log('Main filter1',selected);
    if (selected == "all") {
      $("#portfolio").children().show();
      $(".filterMain a").removeClass("active");
      $("#" + selected).addClass("active");
      window.eventclass = selected;
    } else {
      $("#portfolio").children().hide();
      var thisclass = "#portfolio ." + selected;
      $("#portfolio ." + selected).show();
      $(".filterMain a").removeClass("active");
      $("#" + selected + " a").addClass("active");
      window.eventclass = selected;
    }
  }

  filter2(selected) {
    //console.log('Main filter2',selected);
    if (selected == "all") {
      $("#portfolio").children().show();
      $(".filtersNewMain a").removeClass("active");
      $("." + selected).addClass("active");
      window.eventclass = selected;
    } else {
      $("#portfolio1").children().hide();
      var thisclass = "#portfolio ." + selected;
      $("#portfolio1 ." + selected).show();
      //$(".filtersNewMain a").removeClass('active');
      $("." + selected + " a").addClass("active");
      $("#" + "allImage" + " a").addClass("active");
      window.eventclass = selected;
    }
  }

  resumeVerify() {
    var userid = this.props.match.params.userid;
    window.resumeFlag = 1;
    /* console.log('top',$('#selWrap').position().top);
         console.log('top',$('#container20').position().top-($('#selWrap').position().top+53.6833333));*/

    axios
      .get(
        apiUrl +
        "api/patients/getResumeDetails?userid=" +
        this.props.match.params.userid
      )
      .then((res) => {
        this.setState({
          databaseid: res.data.db_resume,
        });
        /* this.setState({
                     start: res.data.stripvalue_resume
                 });
                 this.setState({
                     end: res.data.stripvalue_resume + 4
                 });*/
        window.stripXValue =
          res.data.xvalue_resume - res.data.stripvalue_resume * 15000;
        window.container = res.data.stripvalue_resume;

        $("#selWrap").scrollTop(
          $("#container" + res.data.stripvalue_resume).position().top -
          $("#selWrap").position().top
        );
        //  $('#selWrap').scrollTop($('#span').offset().top);
        // this.renderResumeDataOnly(userid,res.data,1);
        //this.nextBtnLink(userid,res.data);
        //this.prevBtnLink(userid,res.data);
      })
      .catch((err) => {
      });
  }
  saveVerify() {
    var userid = this.props.match.params.userid;
    axios
      .get(
        apiUrl +
        "api/patients/saveChartDetails?userid=" +
        this.props.match.params.userid
      )
      .then((res) => {
        this.setState({
          databaseid: res.data.db_resume,
        });
        this.setState({
          start: res.data.stripvalue_resume,
        });
        this.setState({
          databaseid: res.data.stripvalue_resume + 9,
        });
        this.renderNewChart(
          userid,
          res.data.db_resume,
          1,
          this.state.start,
          this.state.end
        );
        // this.renderResumeDataOnly(userid,res.data,1);
        //this.nextBtnLink(userid,res.data);
        //this.prevBtnLink(userid,res.data);
      })
      .catch((err) => {
      });
  }
  renderNewSmallCharts() {
    var j = this.state.start;
    var datasetMnt = j + 10;
    var start = this.state.start;
    var end = this.state.end;
    var userid = this.props.match.params.userid;

    //   console.log("Rendersmall chart");
    for (var i = 0; i < this.state.charts.length; i++) {
      this.state.charts[i].destroy();
    }

    var i = 0;
    this.state.charts = [];
    var dis = this;
    var charts = [];

    var myVar = setInterval(function () {
      // Check if container exists before creating chart
      var containerElement = document.getElementById("container" + j);
      if (!containerElement) {
        return;
      }

      charts[i] = new Highcharts.Chart("container" + j, {
        credits: {
          enabled: false,
        },
        chart: {
          height: 4 + "%",
          resetZoomButton: {
            theme: {
              display: "none",
            },
          },
          events: {
            click: function (e) {
              /* Do something with the event */
              clickFunction(e, this); // ...which means you can access it from inside the click handler function
            },
            // Cmd (Mac) / Ctrl (Win/Linux) + drag marquee selection on
            // scroll-rendered strips. Mirrors the handler on the initial
            // strip charts (see line ~2194).
            load: function () {
              var stripInst = this;
              // See note in renderNewChart's strip load handler — use
              // renderTo.id for the strip index (NOT container.id, which
              // is Highcharts' internal "highcharts-XXX" wrapper).
              var renderToEl = stripInst.renderTo || stripInst.container;
              var stripIndex = parseInt(
                String((renderToEl && renderToEl.id) || "")
                  .replace("container", "")
              );
              if (isNaN(stripIndex)) return;
              var isMac = typeof navigator !== "undefined"
                && /MAC|MACINTOSH/.test(
                     (navigator.platform || "").toUpperCase()
                   );
              function modifierHeld(e) {
                return isMac ? !!e.metaKey : !!e.ctrlKey;
              }
              function relPos(e) {
                var bb = stripInst.container.getBoundingClientRect();
                return {
                  x: e.clientX - bb.left,
                  y: e.clientY - bb.top,
                };
              }

              var startPx = null;
              var rectEl  = null;

              // Document-level move/up so a drag that exits this strip
              // (cross-strip marquee, mouse off-screen, etc.) still
              // cleans up — mirrors the L2194 handler.
              function onDocMove(e) {
                if (startPx == null) return;
                var p = relPos(e);
                var x = Math.min(startPx, p.x);
                var w = Math.abs(p.x - startPx);
                if (rectEl) {
                  try { rectEl.attr({ x: x, width: w }); } catch (err) {}
                }
              }
              function onDocUp(e) {
                if (startPx == null) return;
                document.removeEventListener("mousemove", onDocMove);
                document.removeEventListener("mouseup",   onDocUp);
                finishMarquee(e);
              }

              stripInst.container.addEventListener("mousedown", function (e) {
                if (!modifierHeld(e)) return;
                if (e.button !== 0)    return;

                startPx = relPos(e).x;
                try {
                  rectEl = stripInst.renderer
                    .rect(startPx, stripInst.plotTop, 0, stripInst.plotHeight)
                    .attr({
                      fill: "rgba(0,100,255,0.20)",
                      stroke: "#0064ff",
                      "stroke-width": 1,
                      zIndex: 10,
                    })
                    .add();
                } catch (err) { rectEl = null; }

                document.addEventListener("mousemove", onDocMove);
                document.addEventListener("mouseup",   onDocUp);

                e.preventDefault();
                e.stopPropagation();
              });

              function finishMarquee(e) {
                var endPx = relPos(e).x;
                var localStart = startPx;
                startPx = null;

                if (rectEl) {
                  try { rectEl.destroy(); } catch (err) {}
                  rectEl = null;
                }

                if (Math.abs(endPx - localStart) < 5) return;

                // Cross-strip Cmd+drag: if mouseup landed on a different
                // strip than mousedown, fan out and skip the popup.
                var endStripIdx = dis && dis.findStripIndexAt
                  ? dis.findStripIndexAt(e.clientX, e.clientY)
                  : null;
                if (
                  endStripIdx != null
                  && endStripIdx !== stripIndex
                  && dis
                  && dis.applyCrossStripSelection
                ) {
                  var xsStartOffset = (dis.state && dis.state.start) || 0;
                  var endChart = ((dis.state && dis.state.charts) || [])[endStripIdx - xsStartOffset];
                  if (endChart && endChart.xAxis && endChart.xAxis[0] && endChart.container) {
                    var endBB = endChart.container.getBoundingClientRect();
                    var endPxOnEnd = e.clientX - endBB.left;
                    var startXValue, endXValue;
                    try {
                      startXValue = stripInst.xAxis[0].toValue(localStart);
                      endXValue   = endChart.xAxis[0].toValue(endPxOnEnd);
                    } catch (err) { return; }
                    dis.applyCrossStripSelection({
                      startStrip:  stripIndex,
                      endStrip:    endStripIdx,
                      startXValue: startXValue,
                      endXValue:   endXValue,
                    });
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                }

                var pxMin = Math.min(localStart, endPx);
                var pxMax = Math.max(localStart, endPx);

                var xMin, xMax;
                try {
                  xMin = stripInst.xAxis[0].toValue(pxMin);
                  xMax = stripInst.xAxis[0].toValue(pxMax);
                } catch (err) { return; }
                if (xMin == null || xMax == null) return;

                var startOffset = (dis && dis.state && dis.state.start) || 0;
                var chartId = stripIndex - startOffset;
                var beats = (dis
                  && dis.state
                  && dis.state.result3
                  && dis.state.result3[chartId]) || [];
                var jOff = stripIndex * deviceFrequency;

                // 1. Compute picks. Band half-width is adaptive to drag
                //    range so bands stay visible at zoomed-out popup view.
                var pickedXs = [];
                var newPlotband = [];
                var rangeW = Math.abs(xMax - xMin);
                var bandHalf = Math.max(25, Math.min(60, Math.round(rangeW / 200)));
                for (var k = 0; k < beats.length; k++) {
                  var bx = beats[k] && beats[k].x;
                  if (bx == null) continue;
                  if (bx >= xMin && bx <= xMax) {
                    pickedXs.push(bx);
                    newPlotband.push({
                      color: "#ff3333",
                      from: bx - bandHalf,
                      to: bx + bandHalf,
                      id: "plotband-" + bx,
                    });
                  }
                }

                console.log(
                  "[marquee] BEFORE clickFunction:" +
                  " strip=" + stripIndex +
                  " chartid=" + chartId +
                  " state.start=" + startOffset +
                  " beats.length=" + beats.length +
                  " xMin=" + Math.round(xMin) +
                  " xMax=" + Math.round(xMax) +
                  " picked=" + pickedXs.length +
                  " window.beatArr.length=" + ((window.beatArr || []).length) +
                  " window.prevChart=" + window.prevChart +
                  " window.chartid=" + window.chartid
                );

                if (!pickedXs.length) return;

                // Clean slate BEFORE clickFunction so its toggle/remove
                // logic starts fresh (same fix as in renderNewChart strip
                // handler — see comments there for the underlying bug in
                // clickFunction).
                window.beatArr = [];
                if (typeof chart !== "undefined" && chart && chart.update) {
                  try { chart.update({ xAxis: { plotBands: [] } }, false); }
                  catch (err) { /* ignore */ }
                }

                // 2. Open the popup. clickFunction will set window.beatArr
                //    to its own single-beat pick — we override it next.
                try {
                  clickFunction(
                    { chartX: (localStart + endPx) / 2,
                      xAxis: [{ value: (xMin + xMax) / 2 }] },
                    stripInst
                  );
                } catch (err) {
                  console.error("[marquee] clickFunction failed:", err);
                }

                console.log(
                  "[marquee] AFTER clickFunction:" +
                  " window.container=" + window.container +
                  " window.chartid=" + window.chartid +
                  " window.prevChart=" + window.prevChart +
                  " window.beatArr.length=" + ((window.beatArr || []).length)
                );

                // 3. Replace plotBands via chart.update on the popup chart.
                //    See note in L2194 marquee — addPlotBand alone leaves
                //    chart.options.xAxis.plotBands holding clickFunction's
                //    single click-closest band, which setExtremes rebuilds
                //    from on redraw → bands "logged but invisible".
                //    IMPORTANT: closure `chart` in renderNewSmallCharts
                //    scope is declared (var chart;) but NEVER assigned —
                //    use window.popupChart (set by renderMainChart).
                try {
                  window.beatArr = pickedXs.map(function (bx) { return bx + jOff; });
                  var popupCh = (typeof window !== "undefined" && window.popupChart) || null;
                  if (!popupCh && typeof chart !== "undefined" && chart) popupCh = chart;
                  if (popupCh && popupCh.update && popupCh.xAxis && popupCh.xAxis[0]) {
                    // Sync the popup-chart's closure plotband array (lives
                    // in renderNewChart's scope, exposed via
                    // window.popupPlotbandRef) so subsequent click events
                    // start from the right base.
                    if (window.popupPlotbandRef) {
                      window.popupPlotbandRef.length = 0;
                      for (var pcp = 0; pcp < newPlotband.length; pcp++) {
                        window.popupPlotbandRef.push(newPlotband[pcp]);
                      }
                    }

                    popupCh.update(
                      { xAxis: { plotBands: newPlotband.slice() } },
                      false
                    );

                    var ax = popupCh.xAxis[0];
                    console.log(
                      "[marquee L4735] bands after update:" +
                      " requested=" + newPlotband.length +
                      " runtime=" + (ax.plotLinesAndBands || []).length +
                      " options=" + ((ax.options.plotBands || []).length)
                    );

                    var pad = 150;
                    var dataLen = (popupCh.series
                      && popupCh.series[0]
                      && popupCh.series[0].xData
                      && popupCh.series[0].xData.length) || deviceFrequency;
                    var lo = Math.max(0, xMin - pad);
                    var hi = Math.min(dataLen - 1, xMax + pad);
                    ax.setExtremes(lo, hi, true, false);

                    console.log(
                      "[marquee L4735] after setExtremes:" +
                      " runtime=" + (ax.plotLinesAndBands || []).length +
                      " options=" + ((ax.options.plotBands || []).length)
                    );
                  } else {
                    console.warn(
                      "[marquee L4735] no popup chart available — " +
                      "window.popupChart=" + !!window.popupChart +
                      " closure-chart=" + (typeof chart !== "undefined" ? !!chart : "undeclared")
                    );
                  }
                } catch (err) {
                  console.warn("[marquee] chart update failed:", err);
                }

                console.log(
                  "[marquee] FINAL:" +
                  " window.beatArr=" + JSON.stringify((window.beatArr || []).slice(0, 5)) +
                  (window.beatArr && window.beatArr.length > 5
                    ? " ... (" + window.beatArr.length + " total)"
                    : "")
                );

                var firstX = pickedXs[0];
                var firstObj = beats.find(function (p) { return p.x === firstX; });
                if (firstObj && firstObj.beat) {
                  window.selectedBeatNumber = firstObj.beat;
                  if (dis && dis.setState) {
                    dis.setState({ beat_order: window.selectedBeatNumber });
                  }
                }

                e.preventDefault();
                e.stopPropagation();
              }
            },
          },
          zoomType: "",
        },

        navigator: {
          enabled: false,
        },

        xAxis: [
          {
            min: 0,
            max: deviceFrequency,
            labels: {
              enabled: false,
            },
            visible: false,
          },
        ],
        yAxis: [
          {
            min: gainMin,
            max: gainMax,
            gridLineWidth: 0,
            minorGridLineWidth: 0,
            minorTicks: false,
            labels: {
              enabled: false,
            },
            title: {
              enabled: false,
            },
          },
        ],
        rangeSelector: {
          enabled: false,
        },
        plotOptions: {
          series: {
            turboThreshold: 0,
          },
        },
        title: {
          text: "",
        },

        series: [
          {
            type: "coloredline",
            data: [],
            color: "#09ff08",
            allowPointSelect: false,
            animation: false,
            enableMouseTracking: false,
            lineWidth: 2,
            marker: {
              enabled: false,
            },
            shadow: false,
            stickyTracking: false,
            showInLegend: false,
          },
        ],
      });

      j = j + 1;
      i = i + 1;

      if (j > datasetMnt - 1) {
        clearInterval(myVar);
      }
    }, 1);

    this.setState({
      charts: charts,
    });

    var newThis = this,
      val;

    var databaseid = this.state.databaseid;
    var mainEcgArray,
      mainActivityArray = [];
    var result3,
      colorArray = [];
    var chart;

    var tonarr = [],
      rarr = [];

    // var parr = [],
    //     tarr = [],
    //     qarr = [],
    //     rarr = [],
    //     sarr = [],
    //     ponarr = [],
    //     poffarr = [],
    //     tonarr = [],
    //     toffarr = [],
    //     jarr = [];
    var peakColorArray = [];
    peakColorArray["Normal Sinus Rhythm"] = "#3D761D";
    peakColorArray["Sinus Tachycardia"] = "#00FFFF";
    peakColorArray["Sinus Bradycardia"] = "#FF9900";
    peakColorArray["PAC"] = "#0000FF";
    peakColorArray["PVC"] = "#FF00FF";
    peakColorArray["Ventricular Tachycardia"] = "#A64D79";
    peakColorArray["AFib"] = "#9900FF";
    peakColorArray["Sinus Pause"] = "#FF0000";
    peakColorArray["P Absent"] = "#bfbebb";
    peakColorArray["Irregular RR"] = "#7F6000";
    peakColorArray["Irregular PR"] = "#351C75";
    peakColorArray["Short QT"] = "#980000";
    peakColorArray["Prolonged QT"] = "#46BDC6";
    peakColorArray["Paced"] = "#c96936";
    peakColorArray["Undiagnosed"] = "#FFD966";

    function chunkPeakArray(peakArray, start) {
      let presults = [];
      var minIndex = 0;
      /*if(window.tab=='event'){

               start=window.pageIndex;
            }
            else
            {
                start=this.state.start;
            }*/
      var breakVal = (start + 1) * deviceFrequency; //165000
      var z;
      var temRpeakindex;
      presults.push([]);

      for (var i = 0; i < peakArray.length; i++) {
        /*console.log('start',start);
                console.log(peakArray[i].rpeakindex);*/
        if (start * deviceFrequency < peakArray[i].rpeakindex) {
          if (peakArray[i].rpeakindex > breakVal) {
            presults.push([]);
            minIndex = minIndex + 1;
            breakVal = breakVal + deviceFrequency;
          }

          temRpeakindex =
            parseInt(peakArray[i].rpeakindex) -
            (minIndex + start) * deviceFrequency;
          presults[minIndex].push({
            x: temRpeakindex,
            y: parseFloat(0.8),
            color: peakColorArray[peakArray[i].arrhythmia],
            beat: parseInt(peakArray[i].indexcounter),
            hr: parseInt(peakArray[i].heartrate),
            rr: parseInt(peakArray[i].rr_interval),
            arrhythmia: peakArray[i].arrhythmia,
            peaktime: peakArray[i].peaktime,
          });
        }
      }
      return presults;
    }

    function chunkMarkerArray(markArrayX, markArrayY, start = 0) {
      var ppeakIndex = markArrayX.split(",");

      var ppeakAmp = markArrayY.split(",");
      let mresults = [];

      var minIndex = 0;
      var breakVal = (start + 1) * deviceFrequency;
      var z;
      var temindex;
      mresults.push([]);
      for (var i = 0; i < ppeakIndex.length; i++) {
        if (ppeakIndex[i] > start * deviceFrequency) {
          if (ppeakIndex[i] > breakVal) {
            mresults.push([]);
            minIndex = minIndex + 1;
            breakVal = breakVal + deviceFrequency;
          }
          temindex =
            parseInt(ppeakIndex[i]) - (minIndex + start) * deviceFrequency;
          mresults[minIndex].push([temindex, parseFloat(ppeakAmp[i])]);
        }
      }
      return mresults;
    }

    function clickFunction(event, that) {
      var containerId = that.renderTo.id; // got the Container ID
      window.container = containerId.replace("container", "");
      window.chartid =
        parseInt(containerId.replace("container", "")) - newThis.state.start; // container id stored in global variable
      window.stripXValue = event.chartX; // got the location in the x-axis

      /*************Remove Plotband***********************/
      if (window.beatArr.length > 0 && window.chartid != window.prevChart) {
        for (var i = 0; i < window.beatArr.length; i++) {
          var j = parseInt(window.container) * deviceFrequency;
          var xBeat = parseInt(window.beatArr[i]) - j;
          newThis.state.chart.xAxis[0].removePlotBand("plotband-" + xBeat);
        }
      }
      /*************Remove Plotband***********************/

      if (newThis.state.charts[window.chartid]) {
        val = newThis.state.charts[window.chartid].xAxis[0].toValue(
          event.chartX
        );
      }

      var sliceStart = window.chartid * deviceFrequency;
      var sliceEnd = sliceStart + deviceFrequency + 1;
      var sliceActStart = window.chartid * 60;
      var sliceActEnd = sliceActStart + 61;

      var ecgArray = newThis.state.mainEcgArray.slice(sliceStart, sliceEnd);
      var curActArray = newThis.state.mainActivityArray.slice(
        sliceActStart,
        sliceActEnd
      );

      if (val > ecgArray.length) {
        val = ecgArray.length - 500;
      }

      var acti = 125;
      var actarr = [];
      var colorArray = ["#98FB98", "#f1e4e4", "#f7e0a3", "#f09c67"];

      for (var i = 0; i < curActArray.length; i++) {
        actarr.push({
          x: acti,
          y: 0.5,
          color: colorArray[curActArray[i]],
        });
        acti = acti + 250;
      }

      newThis.state.chart.series[0].setData(ecgArray, false);
      newThis.state.chart.series[1].setData(actarr, false);
      newThis.state.chart.series[2].setData(
        newThis.state.result3[window.chartid],
        false
      );

      newThis.state.chart.series[5].update(
        {
          data: newThis.state.rarr[window.container],
        },
        false
      );

      if (newThis.state.charts[window.prevChart] != undefined) {
        if (
          newThis.state.charts[window.prevChart].draggablePlotLine != undefined
        ) {
          newThis.state.charts[window.prevChart].draggablePlotLine.destroy();
        }
      }
      var chart1 = that;

      window.prevChart = window.chartid;
      var lineWidth = 2;

      chart1.draggablePlotLine = chart1.renderer
        .rect(
          event.chartX -
          newThis.state.charts[window.chartid].xAxis[0].toPixels(25),
          10,
          50,
          40,
          5
        )
        .attr({
          "stroke-width": 2,
          opacity: 0.5,
          fill: "grey",
          zIndex: 3,
        })
        .add();

      if (newThis.state.charts[0].container.onmousemove != undefined) {
        newThis.state.charts[0].container.onmousemove = function (e) {
          return false;
        };
      }

      newThis.state.charts[window.chartid].container.onmousemove = function (
        e
      ) {
        if (chart1.draggablePlotLine != undefined) {
          if (chart1.draggablePlotLine.drag) {
            let normalizedEvent = chart1.pointer.normalize(e),
              extremes = {
                left: chart1.plotLeft,
                right: chart1.plotLeft + chart1.plotWidth,
              };

            if (e.chartX >= extremes.left && e.chartX <= extremes.right) {
              var pointValue = chart1.xAxis[0].toValue(e.chartX);
              if (pointValue - 500 <= 0) {
                newThis.state.chart.xAxis[0].setExtremes(
                  0,
                  pointValue + 2250,
                  true,
                  false
                );
              } else {
                newThis.state.chart.xAxis[0].setExtremes(
                  pointValue - 1125,
                  pointValue + 1125,
                  true,
                  false
                );
              }
              chart1.draggablePlotLine.attr({
                x: e.chartX,
              });
            }
          }
        }
      };

      newThis.state.charts[
        window.chartid
      ].draggablePlotLine.element.onmousedown = function () {
        chart1.draggablePlotLine.drag = true;
      };

      newThis.state.charts[window.chartid].draggablePlotLine.element.onmouseup =
        function () {
          chart1.draggablePlotLine.drag = false;
        };

      if (val - 500 <= 0) {
        newThis.state.chart.xAxis[0].setExtremes(0, val + 2250, true, false);
      } else {
        newThis.state.chart.xAxis[0].setExtremes(val - 1125, val + 1125);
      }

      /*************Add Plotband***********************/
      const closestArray = newThis.state.result3[window.chartid].map(
        (point) => point.x
      );
      const jBeat = parseInt(window.container) * deviceFrequency;

      // Find the closest beat
      const closest = closestArray.reduce((prev, curr) =>
        Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev
      );

      const plotbandExists = window.beatArr.includes(closest + jBeat);

      // Always sync selected beat for modal input (fix stale beat after scroll)
      const selectedBeatObj = newThis.state.result3[window.chartid].find(
        (point) => point.x === closest
      );
      const selectedBeatNumber =
        (selectedBeatObj && (selectedBeatObj.beat || selectedBeatObj.beat_order || selectedBeatObj.indexcounter)) ||
        closest + jBeat;

      window.selectedBeatNumber = selectedBeatNumber;
      if (newThis && newThis.setState) {
        newThis.setState({ beat_order: selectedBeatNumber });
      }

      if (!event.shiftKey) {
        if (!plotbandExists) {
          let plotband = {
            color: "#ff9999",
            from: closest - 100,
            to: closest + 100,
            id: "plotband-" + closest,
          };
          newThis.state.chart.xAxis[0].addPlotBand(plotband);
          window.beatArr.push(closest + jBeat);
        } else {
          const index = window.beatArr.indexOf(closest + jBeat);
          if (index > -1) {
            window.beatArr.splice(index, 1);
          }
          newThis.state.chart.xAxis[0].removePlotBand("plotband-" + closest);
        }
      } else {
        handleShiftKeyPlotbands(
          closest,
          jBeat,
          closestArray,
          newThis.state.chart
        );
      }

      /*************Add Plotband***********************/
    }

    function handleShiftKeyPlotbands(closest, jBeat, closestArray, chart) {
      let plotband = [];

      if (window.beatArr.length === 1) {
        let comStart, comEnd;
        if (closest > window.beatArr[0] - jBeat) {
          comEnd = closest;
          comStart = window.beatArr[0] - jBeat;
        } else {
          comStart = closest;
          comEnd = window.beatArr[0] - jBeat;
        }
        window.beatArr = [];
        for (let i = 0; i < closestArray.length; i++) {
          if (closestArray[i] >= comStart && closestArray[i] <= comEnd) {
            plotband.push({
              color: "#ff3333",
              // Narrow band (±25) for range-select so adjacent beats
              // stay visually distinct (was ±100 → merged into blobs).
              from: closestArray[i] - 25,
              to: closestArray[i] + 25,
              id: "plotband-" + closestArray[i],
            });
            window.beatArr.push(closestArray[i] + jBeat);
          }
        }
        chart.update({ xAxis: { plotBands: plotband } });
      } else {
        resetPlotbands(closest, jBeat, chart);
      }
    }

    function resetPlotbands(closest, jBeat, chart) {
      chart.update({ xAxis: { plotBands: [] } });
      window.beatArr = [];
      let plotband = [
        {
          color: "#ff9999",
          from: closest - 100,
          to: closest + 100,
          id: "plotband-" + closest,
        },
      ];
      chart.update({ xAxis: { plotBands: plotband } });
      window.beatArr.push(closest + jBeat);
    }

    function setDataOnly(res, self) {
      /* console.log('Initial res',window.mainArray);
              console.log('start',self.state.start);
              console.log('end',self.state.end);*/

      var timeCounter = self.state.start;
      if (res != undefined) {
        var ind = 0;
        for (var i = 0; i < window.arrAxios.length; i++) {
          var slot = window.mainArray[window.arrAxios[i]];
          // Guard: slot may be undefined when arrAxios index is beyond mainArray length
          if (slot && slot.length == 0 && res[ind]) {
            slot.push(res[ind][0]);
            ind = ind + 1;
          }
        }
        res = [];
        for (var i = self.state.start; i <= self.state.end; i++) {
          // Guard: skip missing slots so the loop doesn't throw
          if (window.mainArray[i] && window.mainArray[i][0] != undefined) {
            res.push(window.mainArray[i][0]);
            kk = kk + 1;
          }
        }
      } else {
        var kk = 0;
        var res = [];
        for (var i = self.state.start; i <= self.state.end; i++) {
          //console.log('i value',i);
          // Guard: same as above
          if (window.mainArray[i] && window.mainArray[i][0] != undefined) {
            res.push(window.mainArray[i][0]);
            kk = kk + 1;
          }
        }
      }

      //console.log('FInal res',window.mainArray);

      if (!self.preEcgValues) {
        self.preEcgValues = res;
        self.ecgValues      = flattenAt(res, 0);
        self.activityValues = flattenAt(res, 1);
        self.peakValues     = flattenAt(res, 2);
      } else {
        if (self.state.scrollStatus === "next") {
          self.preEcgValues = self.preEcgValues.filter(
            (e, i) => i > self.state.limitScrollStart - 1
          );
          //console.log("preEcgValues",self.preEcgValues.length);

          self.preEcgValues = self.preEcgValues.concat(res);
        } else if (self.state.scrollStatus === "prev") {
          self.preEcgValues = self.preEcgValues.filter(
            (e, i) => i < self.state.limitScrollStart + 3
          );
          // console.log("preValues",self.preEcgValues.length);
          self.preEcgValues = res.concat(self.preEcgValues);
        } else {
          // Guard: mainArray[timeCounter] may be undefined; .filter(i<0) is just [], skip
          self.preEcgValues = (window.mainArray[timeCounter] || []).filter(
            (e, i) => i < 0
          );

          // console.log("preEcgValues",self.preEcgValues.length);
          self.preEcgValues = self.preEcgValues.concat(res);
          //console.log("preEcgValues",self.preEcgValues.length);
          //console.log("preEcgValues",self.preEcgValues);
        }

        //console.log("preEcgValues",self.preEcgValues.length);
        self.ecgValues      = flattenAt(self.preEcgValues, 0);
        self.activityValues = flattenAt(self.preEcgValues, 1);
        self.peakValues     = flattenAt(self.preEcgValues, 2);
      }

      mainEcgArray = self.ecgValues;
      mainActivityArray = self.activityValues;

      self.setState({
        mainEcgArray: mainEcgArray,
      });
      self.setState({
        mainActivityArray: mainActivityArray,
      });
      result3 = chunkPeakArray(self.peakValues, self.state.start);

      self.setState({
        result3: result3,
      });
      //  console.log("state result",self.state.result3);
      window.result3 = result3;

      var starr = [],
        defarr = [];

      var i = 0;
      var t = 0;
      var j = 1;

      var stcolor = "09ff08",
        defcolour = "09ff08";

      var currentDataSet = [];
      var self = self;

      var beatInd = self.state.start;
      var myVar2 = setInterval(function () {
        var sliceStartI = i * deviceFrequency;
        var sliceEndI = sliceStartI + deviceFrequency + 1;

        currentDataSet = self.state.mainEcgArray.slice(sliceStartI, sliceEndI);

        // A strip with zero classified beats leaves result3[i] as an empty
        // (but truthy) array — result3[i][0] is then undefined, and reading
        // .peaktime off it throws. Uncaught inside this setInterval, that
        // stops `i` from ever advancing again, so the loop never reaches
        // i > 9 below — which is also where the Witals24 "Jump to event"
        // deep-link fetch fires. A direct jump can land on a sparse/empty
        // strip far more easily than normal sequential browsing ever would,
        // so guard this instead of assuming result3[i][0] exists.
        if (self.state.result3[i] && self.state.result3[i][0]) {
          var time1 = document.createTextNode(
            self.state.result3[i][0].peaktime
          );

          document.getElementById("span" + timeCounter).innerHTML = "";
          document.getElementById("span" + timeCounter).appendChild(time1);
          timeCounter = timeCounter + 1;
        }
        var k = 0;
        /***********color***********/

        starr.push([]);
        defarr.push([]);
        // Cache result3[i] in a local so the per-j inner checks don't
        // crash when result3[i] is undefined (scrolled past the loaded
        // data range). The old code did `result3[i][k] != null` which
        // implicitly dereferenced result3[i] — throws if it's missing.
        var stripBeats = (self.state.result3 && self.state.result3[i]) || null;
        for (var j = 0; j < currentDataSet.length; j++) {
          if (
            stripBeats &&
            stripBeats[k] != null &&
            (j + 70 == stripBeats[k].x ||
              stripBeats[k].x < 70)
          ) {
            stcolor = "09ff08";
            defcolour = "09ff08";

            // O(1) Set lookup — replaces 15-branch if/else chain.
            if (KNOWN_ARRHYTHMIAS.has(stripBeats[k].arrhythmia)) {
              stcolor = stripBeats[k].color;
            }

            if (k < stripBeats.length - 1) {
              k++;
            }
          }

          defarr[i].push({
            x: j,
            y: parseFloat(currentDataSet[j]),
            segmentColor: "#09ff08",
          });
          starr[i].push({
            x: j,
            y: parseFloat(currentDataSet[j]),
            segmentColor: stcolor,
          });
        }

        /***********color**********/

        /**********setStateColor*********/

        self.setState({
          starr: starr,
        });

        self.setState({
          defarr: defarr,
        });

        /**********setStateColor*********/
        if (self.state.charts[i] != undefined) {
          self.state.charts[i].series[0].setData(starr[i], true);
        }
        // Guard: mainArray[beatInd] may be undefined when patient has fewer strips than expected
        if (!window.mainArray[beatInd] || window.mainArray[beatInd].length == 0) {
          window.mainArray.splice(beatInd, 1, defarr[i]);
        }
        //console.log('MainArray',window.mainArray);
        i = i + 1;
        j = j + 1;
        beatInd = beatInd + 1;
        if (i > 9) {
          clearInterval(myVar2);
          try {
            if (window.prev_tab == "Events") {
              self.updateMainChartODC(self.state.start, self.state.end);
              // window.prev_tab=window.tab;
              window.tab = "Beats";
              window.prev_tab = "Beats";
            }
            if (
              self.props.match.params.start != undefined &&
              window.diaryFlag == 0
            ) {
              window.diaryFlag = 1;
              self.updateMainChartODC(
                self.props.match.params.start,
                self.props.match.params.end
              );
            }
          } catch (err) {
            console.error(
              "[setDataOnly] updateMainChartODC threw after clearInterval:",
              err
            );
          }
        }
      }, 1);
    }
    window.arrAxios = [];
    var count = 0;
    //  console.log('MainArray',window.mainArray);
    for (var ii = start; ii <= end; ii++) {
      // Guard: mainArray[ii] is undefined if the slot was never pushed
      // (e.g. ii beyond window.sc, or mainArray reset between renders).
      // Treat missing slot the same as an empty slot — needs to be fetched.
      if (!window.mainArray[ii] || window.mainArray[ii].length == 0) {
        window.arrAxios.push(ii);
      }
    }
    var newArrAxios = [];

    if (window.arrAxios.length > 0) {
      var newArrAxiosRes = [];
      this.getRepos(userid, databaseid).then((value) => {
        for (var ij = 0; ij < window.arrAxios.length; ij++) {
          newArrAxiosRes[ij] = value[ij].data;
        }
        setDataOnly(newArrAxiosRes, this);
        if (window.resumeFlag == 0) {
          this.renderResumeChart(
            userid,
            databaseid,
            window.container,
            window.stripXValue
          );
          window.resumeFlag = 0;
        }
      });
    } else {
      setDataOnly(newArrAxios, this);
    }
  }

  async getRepos(userid, databaseid) {
    var ops = [];
    for (var ii = 0; ii < window.arrAxios.length; ii++) {
      let op = axios.get(
        apiUrl +
        "api/common/getEcgNewData?start=" +
        window.arrAxios[ii] +
        "&end=" +
        window.arrAxios[ii] +
        "&userid=" +
        userid +
        "&databaseid=" +
        databaseid
      );
      ops.push(op);
    }
    let res = await axios.all(ops);

    return res;
  }
  generateApiUrl(userid, databaseid, index) {
    return (
      apiUrl +
      "api/common/getEcgNewData?start=" +
      index +
      "&end=" +
      index +
      "&userid=" +
      userid +
      "&databaseid=" +
      databaseid
    );
  }

  async executeBatchCalls(userid, databaseid, start, end) {
    var ops = [];
    for (let ii = start; ii < end; ii++) {
      let url = this.generateApiUrl(userid, databaseid, ii);
      let op = axios.get(url);
      // console.log("API call for index: " + ii);
      ops.push(op);
    }
    return await axios.all(ops);
  }
  async getData(userid, databaseid) {
    let batchSize = Math.ceil((window.sc - 10) / 4); // Divide into 4 batches
    let results = [];

    for (let batch = 0; batch < 4; batch++) {
      let start = 10 + batch * batchSize;
      let end = Math.min(start + batchSize, window.sc);
      let batchResults = await this.executeBatchCalls(
        userid,
        databaseid,
        start,
        end
      );
      results.push(...batchResults);
    }
    this.fetchminmaxHr();
    this.getverifierName();

    return results;
  }

  callDiaryDataAPIs(db, userid, start, end, stripX) {
    var userid = userid;
    var databaseid = db;

    this.setState({ start: start, end: end });
    var stripThis = this;

    worker13.postMessage({
      name: "getStripCount",
      url:
        apiUrl +
        "api/common/getStripCount?userid=" +
        userid +
        "&databaseid=" +
        databaseid,
    });
    worker13.onmessage = function (event) { };
    worker13.addEventListener("message", function (res) {
      window.sc = parseInt(res.data);
      if (window.sc != 0) {
        for (var i = 0; i < window.sc; i++) {
          window.mainArray.push([]);
        }

        if (typeof databaseid === "undefined") {
          databaseid = "0";
          worker14.postMessage({
            name: "getLatestDatabaseId",
            url: apiUrl + "api/common/getLatestDatabaseId?userid=" + userid,
          });
          worker14.onmessage = function (event) { };
          worker14.addEventListener("message", function (res) {
            stripThis.setState({
              databaseid: res.data,
            });
            stripThis.renderNewChart(userid, res.data, 1);
          });
          // axios
          //     .get(apiUrl + 'api/common/getLatestDatabaseId?userid=' + userid)
          //     .then(res => {
          //         stripThis.setState({
          //             databaseid: res.data
          //         });
          //         stripThis.renderNewChart(userid, res.data, 1);
          //         //this.nextBtnLink(userid,res.data);
          //         //this.prevBtnLink(userid,res.data);
          //     })
          //     .catch(err => {
          //         console.log(err);
          //     });
        } else {
          stripThis.setState({
            databaseid: databaseid,
          });

          stripThis.renderNewChart(
            userid,
            databaseid,
            1,
            stripThis.state.start,
            stripThis.state.end
          );
          //this.nextBtnLink(userid,databaseid);
          //this.prevBtnLink(userid,databaseid);
        }
      }
    });
    //     axios
    //         .get(apiUrl+'api/common/getStripCount?userid=' + userid + '&databaseid=' + databaseid)
    //         .then(res => {
    //              window.sc = parseInt(res.data);
    //             if(window.sc!=0)
    //             {

    //             for (var i = 0; i < window.sc; i++) {
    //                 window.mainArray.push([]);
    //             }

    //     if (typeof databaseid === 'undefined') {
    //         databaseid = "0";
    //         axios
    //             .get(apiUrl + 'api/common/getLatestDatabaseId?userid=' + userid)
    //             .then(res => {
    //                 this.setState({
    //                     databaseid: res.data
    //                 });
    //                 this.renderNewChart(userid, res.data, 1);
    //                 //this.nextBtnLink(userid,res.data);
    //                 //this.prevBtnLink(userid,res.data);
    //             })
    //             .catch(err => {
    //                 console.log(err);
    //             });
    //     } else {
    //         this.setState({
    //             databaseid: databaseid
    //         });

    //         this.renderNewChart(userid, databaseid, 1, this.state.start, this.state.end);
    //         //this.nextBtnLink(userid,databaseid);
    //         //this.prevBtnLink(userid,databaseid);
    //     }
    // }
    //         })
    //         .catch(err => {
    //             console.log(err)
    //         });

    var setPatientReportStatus = (res) => {
      this.state.patientReportStatus = res;
      this.setState({
        reportStatus: res.data,
      });
    };
    if (Object.keys(this.state.patientReportStatus).length > 0) {
      setPatientReportStatus(this.state.patientReportStatus);
    } else {
      axios
        .get(
          apiUrl +
          "api/patients/patientReportStatus?userid=" +
          this.props.match.params.userid
        )
        .then(setPatientReportStatus)
        .catch((err) => {
        });
    }
    var setPatientMenuTree = (res) => {
      this.state.patientMenuTree = res;
      this.setState({
        treemenu: res.data,
      });
    };

    if (Object.keys(this.state.patientMenuTree).length > 0) {
      setPatientMenuTree(this.state.patientMenuTree);
    } else {
      var pmenu = this;
      worker.postMessage({
        name: "patinentmenutree",
        url:
          apiUrl +
          "api/common/patinentmenutreeNew?userid=" +
          this.props.match.params.userid,
      });
      worker.onmessage = function (event) { };
      worker.addEventListener("message", function (res) {
        pmenu.state.patientMenuTree = res;
        pmenu.setState({
          treemenu: res.data,
        });
      });
      // axios
      //     .get(apiUrl + 'api/common/patinentmenutreeNew?userid=' + this.props.match.params.userid)
      //     .then(
      //         setPatientMenuTree
      //     )
      //     .catch(err => {
      //         console.log(err);
      //     });
    }

    if (this.state.reportLinkStatus == 0) {
      axios
        .get(
          `${apiUrl}api/common/getReport?userid=` +
          this.props.match.params.userid
        )
        .then((res) => {
          this.state.reportLinkStatus = 1;
          if (res.data != "") {
            this.setState({
              reoprtLink: res.data,
            });
          }
        })
        .catch((err) => {
        });
    }
    this.checkFullVerify();
  }
  callDataAPIs() {
    var userid = this.props.match.params.userid;
    var databaseid = this.props.match.params.databaseid;
    var stripThis = this;
    worker13.postMessage({
      name: "getStripCount",
      url:
        apiUrl +
        "api/common/getStripCount?userid=" +
        userid +
        "&databaseid=" +
        databaseid,
    });
    worker13.onmessage = function (event) { };
    worker13.addEventListener("message", function (res) {
      window.sc = parseInt(res.data);
      if (window.sc != 0) {
        for (var i = 0; i < window.sc; i++) {
          window.mainArray.push([]);
        }

        if (typeof databaseid === "undefined") {
          databaseid = "0";
          worker14.postMessage({
            name: "getLatestDatabaseId",
            url: apiUrl + "api/common/getLatestDatabaseId?userid=" + userid,
          });
          worker14.onmessage = function (event) { };
          worker14.addEventListener("message", function (res) {
            stripThis.setState({
              databaseid: res.data,
            });
            stripThis.renderNewChart(userid, res.data, 1);
          });
          // axios
          //     .get(apiUrl + 'api/common/getLatestDatabaseId?userid=' + userid)
          //     .then(res => {
          //         stripThis.setState({
          //             databaseid: res.data
          //         });
          //         stripThis.renderNewChart(userid, res.data, 1);
          //         //this.nextBtnLink(userid,res.data);
          //         //this.prevBtnLink(userid,res.data);
          //     })
          //     .catch(err => {
          //         console.log(err);
          //     });
        } else {
          stripThis.setState({
            databaseid: databaseid,
          });

          stripThis.renderNewChart(
            userid,
            databaseid,
            1,
            stripThis.state.start,
            stripThis.state.end
          );
          //this.nextBtnLink(userid,databaseid);
          //this.prevBtnLink(userid,databaseid);
        }
      }
    });
    //     axios
    //         .get(apiUrl+'api/common/getStripCount?userid=' + userid + '&databaseid=' + databaseid)
    //         .then(res => {
    //              window.sc = parseInt(res.data);
    //             if(window.sc!=0)
    //             {

    //             for (var i = 0; i < window.sc; i++) {
    //                 window.mainArray.push([]);
    //             }

    //     if (typeof databaseid === 'undefined') {
    //         databaseid = "0";
    //         axios
    //             .get(apiUrl + 'api/common/getLatestDatabaseId?userid=' + this.props.match.params.userid)
    //             .then(res => {
    //                 this.setState({
    //                     databaseid: res.data
    //                 });
    //                 this.renderNewChart(userid, res.data, 1);
    //                 //this.nextBtnLink(userid,res.data);
    //                 //this.prevBtnLink(userid,res.data);
    //             })
    //             .catch(err => {
    //                 console.log(err);
    //             });
    //     } else {
    //         this.setState({
    //             databaseid: databaseid
    //         });

    //         this.renderNewChart(userid, databaseid, 1, this.state.start, this.state.end);
    //           if(this.props.match.params.start!=undefined)
    //           {
    //           document.getElementById('chart_tab_2').click();
    //         }
    //         //this.nextBtnLink(userid,databaseid);
    //         //this.prevBtnLink(userid,databaseid);

    //     }
    // }
    // else{
    //     //alert('Sorry!!!The data is Backed Up')

    // }

    //         })
    //         .catch(err => {
    //             console.log(err)
    //         });

    var setPatientReportStatus = (res) => {
      this.state.patientReportStatus = res;
      this.setState({
        reportStatus: res.data,
      });
    };

    var setPatientMenuTree = (res) => {
      this.state.patientMenuTree = res;
      this.setState({
        treemenu: res.data,
      }, () => {
        if (res.data && Object.keys(res.data).length > 0) {
          this.populateTimeOptions(res.data);
        }
      });
    };
    if (Object.keys(this.state.patientMenuTree).length > 0) {
      setPatientMenuTree(this.state.patientMenuTree);
    } else {
      // Speed-up: removed 2-second setTimeout that wrapped this block.
      // The worker call is async, so there's no reason to delay firing it.
      var pmenu = this;
      worker6.postMessage({
        name: "patinentmenutree",
        url:
          apiUrl +
          "api/common/patinentmenutreeNew?userid=" +
          pmenu.props.match.params.userid,
      });
      worker6.onmessage = function (event) { };
      worker6.addEventListener("message", function (res) {
        pmenu.state.patientMenuTree = res;
        pmenu.setState({
          treemenu: res.data,
        }, () => {
          if (res.data && Object.keys(res.data).length > 0) {
            pmenu.populateTimeOptions(res.data);
          }
        });
      });
    }

    if (Object.keys(this.state.patientReportStatus).length > 0) {
      setPatientReportStatus(this.state.patientReportStatus);
    } else {
      axios
        .get(
          apiUrl +
          "api/patients/patientReportStatus?userid=" +
          this.props.match.params.userid
        )
        .then((res) => {
          setPatientReportStatus(res);
        })
        .catch((err) => { });
    }

    if (this.state.reportLinkStatus == 0) {
      axios
        .get(
          `${apiUrl}api/common/getReport?userid=` +
          this.props.match.params.userid
        )
        .then((res) => {
          this.state.reportLinkStatus = 1;
          if (res.data != "") {
            this.setState({
              reoprtLink: res.data,
            });
          }
        })
        .catch((err) => { });
    }
    this.checkFullVerify();
  }

  fetchSummary(e) {
    window.prev_tab = window.tab;
    window.tab = "Summary";
    var mmhrf = this;
    if (this.props.match.params.start == undefined) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../dist/img/Summary_White.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../dist/img/SelectedEvents.png"/>';
    } else if (this.props.match.params.start != undefined) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../../../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../../../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../../../../dist/img/Summary_White.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../../../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../../../../dist/img/SelectedEvents.png"/>';
    }

    var databaseid = this.props.match.params.databaseid;
    axios
      .get(
        apiUrl +
        "api/common/getAllPeakValues?userid=" +
        this.props.match.params.userid +
        "&databaseid=" +
        databaseid
      )
      .then((res) => {
        if (res.data != null) {
          this.setState({
            summaryData: res.data,
          });
        }
      })
      .catch((err) => {
      });
    var wrk5this = this;
    worker5.postMessage({
      name: "getMinMaxHeartrateCurrent",
      url:
        apiUrl +
        "api/common/getMinMaxHeartrateCurrent?userid=" +
        this.props.match.params.userid +
        "&databaseid=" +
        databaseid,
    });
    worker5.onmessage = function (event) { };
    worker5.addEventListener("message", function (res) {
      if (res.data != null) {
        wrk5this.setState({
          minMaxHrDataCurr: res.data,
        });
      }
    });
    // workersum2.postMessage({ name:'getMinMaxHeartrateFull',url: apiUrl+'api/common/getMinMaxHeartrateFull?userid='+this.props.match.params.userid});
    // workersum2.onmessage = function (event) {};
    // workersum2.addEventListener("message", function (res) {
    //     if (res.data != null) {
    //         wrk5this.setState({
    //             minMaxHrDataFull: res.data
    //         });
    //     }
    // });
    worker11.postMessage({
      name: "getHeartRates",
      url:
        apiUrl +
        "api/common/getHeartRates?userid=" +
        this.props.match.params.userid +
        "&databaseid=" +
        databaseid,
    });
    worker11.onmessage = function (event) { };
    worker11.addEventListener("message", function (res) {
      wrk5this.setState({
        heartRatesData: res.data,
      });
    });
    worker8.postMessage({
      name: "details",
      url:
        apiUrl +
        "api/patients/details?userid=" +
        this.props.match.params.userid,
    });
    worker8.onmessage = function (event) { };
    worker8.addEventListener("message", function (res) {
      wrk5this.setState({
        patientwrkdetails: res.data,
      });
    });
    worker9.postMessage({
      name: "getPatientTotalDetails",
      url:
        apiUrl +
        "api/common/getPatientTotalDetails?userid=" +
        this.props.match.params.userid,
    });
    worker9.onmessage = function (event) { };
    worker9.addEventListener("message", function (res) {
      wrk5this.setState({
        patientwrktotaldetails: res.data,
      });
    });
    worker10.postMessage({
      name: "getdailydeatils",
      url:
        apiUrl +
        "api/common/getdailydeatils?userid=" +
        this.props.match.params.userid,
    });
    worker10.onmessage = function (event) { };
    worker10.addEventListener("message", function (res) {
      wrk5this.setState({
        patientwrkdailydetails: res.data,
      });
    });
    worker12.postMessage({
      name: "getArrhythmiaCount",
      url:
        apiUrl +
        "api/common/getArrhythmiaCount?userid=" +
        this.props.match.params.userid,
    });
    worker12.onmessage = function (event) { };
    worker12.addEventListener("message", function (res) {
      wrk5this.setState({
        arrCount: res.data,
      });
    });
  }
  getverifierName(e) {
    const databaseid = this.props.match.params.databaseid; // Get databaseid from route params
    const userid = this.props.match.params.userid; // Get userid from route params

    if (!userid || !databaseid) {
      return Promise.resolve();
    }

    // Priority 4: return promise so caller can run in parallel via Promise.all
    return axios
      .get(`${apiUrl}api/common/verifierName`, {
        params: {
          userid: userid,
          databaseid: databaseid,
        },
      })
      .then((response) => {
        this.setState({ verifierNameData: response.data });
      })
      .catch((error) => {
      });
  }

  fetchminmaxHr(e) {
    const databaseid = this.props.match.params.databaseid;
    const userid = this.props.match.params.userid;
    const apiBase = apiUrl + "api/common/";

    // Priority 4: return promise so caller can run in parallel via Promise.all

    // Fetch summary data
    // axios.get(`${apiBase}getAllPeakValues?userid=${userid}&databaseid=${databaseid}`)
    //   .then((res) => {
    //     if (res.data != null) {
    //       this.setState({ summaryData: res.data });
    //       console.log('summary data', this.state.summaryData);
    //       console.log('min max data', this.state.minMaxHrDataCurr);
    //     }
    //   })
    //   .catch((err) => console.log(err));

    // Fetch min/max heart rate current data
    return axios
      .get(
        `${apiBase}getMinMaxHeartrateCurrent?userid=${userid}&databaseid=${databaseid}`
      )
      .then((res) => {
        if (res.data != null) {
          this.setState({ minMaxHrDataCurr: res.data }, () => {
            const {
              afib,
              ipr,
              irr,
              pac,
              pvc,
              st,
              sp,
              nsr,
              pqt,
              pabsent,
              sqt,
              vt,
              sb,
            } = this.state.minMaxHrDataCurr;

            const setMinMaxHeartRates = (category, name) => {
              if (category && category.length > 0) {
                const heartRates = category.map((item) => item.heartrate);
                const maxHeartRate = Math.max(...heartRates);
                const minHeartRate = Math.min(...heartRates);

                // console.log(`${name} heart rates:`, heartRates);
                // console.log(`Max ${name} heart rate:`, maxHeartRate);
                // console.log(`Min ${name} heart rate:`, minHeartRate);

                // Dynamically set state for each category’s min and max
                this.setState({
                  [`${name}MinHr`]: minHeartRate,
                  [`${name}MaxHr`]: maxHeartRate,
                });
              } else {
                // console.log(`${name} has no heart rate data.`);
                this.setState({
                  [`${name}MinHr`]: null,
                  [`${name}MaxHr`]: null,
                });
              }
            };

            setMinMaxHeartRates(afib, "afib");
            setMinMaxHeartRates(ipr, "ipr");
            setMinMaxHeartRates(irr, "irr");
            setMinMaxHeartRates(pac, "pac");
            setMinMaxHeartRates(pvc, "pvc");
            setMinMaxHeartRates(st, "st");
            setMinMaxHeartRates(sp, "sp");
            setMinMaxHeartRates(nsr, "nsr");
            setMinMaxHeartRates(pqt, "pqt");
            setMinMaxHeartRates(pabsent, "pabsent");
            setMinMaxHeartRates(sqt, "sqt");
            setMinMaxHeartRates(vt, "vt");
            setMinMaxHeartRates(sb, "sb");
          });
        }
      })
      .catch((err) => {});

    // Fetch heart rates data
    // axios.get(`${apiBase}getHeartRates?userid=${userid}&databaseid=${databaseid}`)
    //   .then((res) => {
    //     if (res.data != null) {
    //       this.setState({ heartRatesData: res.data });
    //       console.log('heartreate:',this.state.heartRatesData)
    //     }
    //   })
    //   .catch((err) => console.log(err));

    // Fetch patient details
    // axios.get(apiUrl + `api/patients/details?userid=${userid}`)
    //   .then((res) => {
    //     if (res.data != null) {
    //       console.log('patientdetails:', res.data)
    //       // this.setState({ patientwrkdetails: res.data });
    //     }
    //   })
    //   .catch((err) => console.log(err));

    // Fetch patient total details
    // axios.get(`${apiBase}getPatientTotalDetails?userid=${userid}`)
    //   .then((res) => {
    //     if (res.data != null) {
    //       this.setState({ patientwrktotaldetails: res.data });
    //     }
    //   })
    //   .catch((err) => console.log(err));

    // Fetch daily patient details
    // axios.get(`${apiBase}getdailydeatils?userid=${userid}`)
    //   .then((res) => {
    //     if (res.data != null) {
    //       this.setState({ patientwrkdailydetails: res.data });
    //     }
    //   })
    //   .catch((err) => console.log(err));

    // Fetch arrhythmia count
    // axios.get(`${apiBase}getArrhythmiaCount?userid=${userid}`)
    //   .then((res) => {
    //     if (res.data != null) {
    //       this.setState({ arrCount: res.data });
    //       // console.log('arr count :!!!!!!',this.state.arrCount)
    //     }
    //   })
    //   .catch((err) => console.log(err));
  }

  selectedEvents(e) {
    window.prev_tab = window.tab;
    window.tab = "Selected Events";
    if (this.props.match.params.start == undefined) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../dist/img/SelectedEventsSelected.png"/>';
    } else if (this.props.match.params.start != undefined) {
      document.getElementById("chart_tab_1").innerHTML =
        '<img id="eventsimg" src="../../../../../dist/img/Events.png"/>';
      document.getElementById("chart_tab_2").innerHTML =
        '<img id="beatsimg" src="../../../../../dist/img/Beats.png"/>';
      // document.getElementById("chart_tab_3").innerHTML =
      //   '<img id="summaryimg" src="../../../../../dist/img/Summary.png"/>';
      //document.getElementById("chart_tab_4").innerHTML="<img id=\"heartrateimg\" src=\"../../../../../dist/img/HeartRate.png\"/>";
      document.getElementById("chart_tab_5").innerHTML =
        '<img id="selectimg" src="../../../../../dist/img/SelectedEventsSelected.png"/>';
    }

    var datasets = [];
    var self = this;
    var testArr = {};

    var testArrNew = {};
    worker.postMessage({
      name: "patinentmenutree",
      url:
        apiUrl +
        "api/common/patinentmenutree?userid=" +
        this.props.match.params.userid,
    });
    worker.onmessage = function (event) { };
    worker.addEventListener("message", function (res) {
      datasets = res.data;

      self.getRepos1(self.props.match.params.userid, datasets).then((value) => {
        for (var ij = 0; ij < datasets.length; ij++) {
          if (value[ij].data[0].length != 0) {
            var strdat = "";

            //console.log('testDatasets',value[ij].data);
            var keys = Object.keys(value[ij].data[0]);

            for (var ik = 0; ik < keys.length; ik++) {
              if (testArr[keys[ik]] != undefined) {
                var strapp =
                  testArr[keys[ik]] + "," + value[ij].data[0][keys[ik]];
                testArr[keys[ik]] = strapp.split(",");
              } else {
                //console.log('testDatasets',value[ij].data[1]);
                testArr[keys[ik]] = value[ij].data[0][keys[ik]];
              }
            }
          }
        }
        self.setState({
          imagess: testArr,
        });
        // Show ALL classes by default. Previously this was set to
        // Object.keys(testArr)[0] which auto-filtered down to the first
        // class only — for some patients that first key is something like
        // "max" with no grid thumbnails, leaving the 3rd tab looking empty.
        // User can still click any class filter button to narrow down.
        window.filterId2 = "all";

        self.filter2(window.filterId2);
      });
    });
  }
  async getRepos1(userid, datasets) {
    var ops = [];

    for (var ii = 0; ii < datasets.length; ii++) {
      let op = axios.get(
        `${apiUrl}api/common/getselectedfolderfiles_Newpath?userid=` +
        this.props.match.params.userid +
        "&databaseid=" +
        datasets[ii]
      );
      ops.push(op);
    }
    let res = await axios.all(ops);
    return res;
  }
  async getReposNew(userid, datasets) {
    var ops = [];
    let op = axios.get(
      `${apiUrl}api/common/getselectedfolderfiles_Newpath?userid=` +
      this.props.match.params.userid
    );
    ops.push(op);
    let res = await axios.all(ops);
    return res;
  }

  superImposeData(e) {
    e.preventDefault();

    // if status is unverify, show error message and abort
    if (this.state.superimposeStatus === "unverify") {
      this.setState({ superimposeErrorMessage: "The selected dataset is unverified" });
      // return;
    }

    // if user requested verify but the dataset isn't actually verified, prevent call
    if (
      this.state.superimposeStatus === "verify" &&
      this.state.verifyCheck &&
      this.state.verifyCheck.data === 0
    ) {
      this.setState({ superimposeErrorMessage: "The selected dataset is unverified" });
      // return;
    }

    // clear error message on successful validation
    this.setState({ superimposeErrorMessage: "" });

    var userid = this.props.match.params.userid;
    var databaseid = this.props.match.params.databaseid;

    // Get the beat order from the input field
    const beatOrder = this.state.beat_order;
    if (!beatOrder || String(beatOrder).trim() === "") {
      alert("Please enter a beat order to use as template");
      return;
    }

    // Parse beat order as integer
    const val_in = [parseInt(beatOrder)];
    if (isNaN(val_in[0])) {
      alert("Please enter a valid beat order number");
      return;
    }

    // Show loading state
    this.setState({ superimposeLoading: true });

    // Close the Bootstrap modal by clicking the close button
    const closeButton = document.querySelector('#SuperModal .close');
    if (closeButton) {
      closeButton.click();
    }

    // Prepare request payload for new API
    const requestData = {
      userid: userid,
      all_datasets: true,
      template_dataset: databaseid,
      beat: val_in[0],
      label: this.state.newArrhy,
      verify_status: this.state.superimposeStatus === "verify" ? 1 : 0,
      start_db_id: this.state.superimpose_start_date || null,
      end_db_id: this.state.superimpose_end_date || null,
      thr: parseFloat(this.state.threshold) || 0.86,
      pre_ms: this.state.preMS || null,
      post_ms: this.state.postMS || null,
      apply: false,

    };

    if (this.state.superimpose_apply === "yes") {
      const applyRequest = { ...requestData, apply: true };

      axios
        .post(`${apiUrl4}api/common/superimpose_selection`, applyRequest) //web- apiurl4
        .then((res) => {

          if (res.data.success) {
            this.setState({
              superimposePreviewModal: false,
              superimposeLoading: false,
              superimposeMatchingBeats: null,
              superimposeConfig: null,
            });
            window.location.reload();
            toast.success("Superimpose applied successfully!");
          } else {
            throw new Error(res.data.error || res.data.errorOutput || "Failed to apply changes");
          }
        })
        .catch((err) => {
          const errorMessage = err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err.message || "An error occurred while applying changes.";
          alert("Error: " + errorMessage);
          this.setState({
            superimposeLoading: false,
          });
        });
      return;
    }


    // Call the new superimpose_selection API
    axios
      .post(`${apiUrl4}api/common/superimpose_selection`, requestData)
      .then((res) => {
        
        if (res.data.success) {
          // Parse the output to extract matching beats
          const output = res.data.output || "";
          const matchingBeatsMatch = output.match(/First 30 matched indexcounters: \[(.*?)\]/);
          const databaseIdMatch = output.match(/Database_ID: (.*?)[\n\r]/);
          const matchesFoundMatch = output.match(/Matches found: (\d+) \/ (\d+)/);
          
          let matchingBeats = [];
          if (matchingBeatsMatch && matchingBeatsMatch[1]) {
            const beatsStr = matchingBeatsMatch[1].trim();
            matchingBeats = beatsStr.split(',').map(b => parseInt(b.trim())).filter(b => !isNaN(b));
          }

          const mockResponse = {
            status: "success",
            message: "Found matching beats for preview",
            matching_beats: matchingBeats,
            total_matches: matchesFoundMatch ? parseInt(matchesFoundMatch[1]) : matchingBeats.length,
            database_id: databaseIdMatch ? databaseIdMatch[1] : databaseid,
            raw_output: output,
            parameters: requestData
          };
          
          this.setState({
            superimposeMatchingBeats: mockResponse,
            superimposePreviewModal: true,
            superimposeLoading: false,
            superimposeConfig: requestData,
          });
        } else {
          throw new Error(res.data.error || res.data.errorOutput || "Unknown error occurred");
        }
      })
      .catch((err) => {
        
        let errorMessage = "An error occurred while processing your request.";
        
        if (err.response) {
          errorMessage = err.response.data && err.response.data.error 
            ? err.response.data.error 
            : `Server Error: ${err.response.status} - ${err.response.statusText || 'Unknown error'}`;
        } else if (err.request) {
          errorMessage = "No response from server. Please check your connection.";
        } else {
          errorMessage = err.message || errorMessage;
        }

        // if the server complains about python execution failing and the user had asked for verify,
        // it's likely because the dataset isn't verified; show a clearer message.
        if (
          (errorMessage.toLowerCase().includes("python script execution failed") ||
            errorMessage.toLowerCase().includes("python script error")) &&
          requestData &&
          requestData.verify_status === 1
        ) {
          errorMessage = "The selected dataset is unverified";
        }
        
        alert("Error: " + errorMessage);
        this.setState({
          superimposeLoading: false,
        });
      });
  }

  // Apply the superimpose changes after user confirms from preview
  applySuperimpose() {
    var userid = this.props.match.params.userid;
    var databaseid = this.props.match.params.databaseid;

    const previousConfig = this.state.superimposeConfig;
    
    if (!previousConfig) {
      alert("Configuration not found. Please try again.");
      return;
    }

    this.setState({ superimposeLoading: true });

    // Update request to include apply: true
    const requestData = {
  ...previousConfig,
  apply: true
};


    // Call the API with apply=true
    axios
      .post(`${apiUrl4}api/common/superimpose_selection`, requestData)
      .then((res) => {
        
        if (res.data.success) {
          this.setState({
            superimposePreviewModal: false,
            superimposeLoading: false,
            superimposeMatchingBeats: null,
            superimposeConfig: null,
          });
          toast.success("Superimpose applied successfully!");
          // Dead setTimeout removed (body was commented-out reload)
        } else {
          throw new Error(res.data.error || res.data.errorOutput || "Failed to apply changes");
        }
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data && err.response.data.error 
          ? err.response.data.error 
          : err.message || "An error occurred while applying changes.";
        alert("Error: " + errorMessage);
        this.setState({
          superimposeLoading: false,
        });
      });
  }

  closeSuperimposePreview() {
    this.setState({
      superimposePreviewModal: false,
      superimposeMatchingBeats: null,
      superimposeConfig: null,
    });
  }

  captureImage(e) {
    e.preventDefault();

    if (window.confirm("Do you want to capture?")) {
      $(".closePopup").click();
      this.enableKey();
      var beats = window.beatArr;
      var databaseid = this.props.match.params.databaseid;
      var userid = this.props.match.params.userid;
      var last_beat = beats[beats.length - 1];
      const config = {
        stripcount: this.state.stripcount,
        labelinfo: this.state.labelinfo,
        newName: this.state.newName,
        sel_arr: this.state.sel_arr,
        arr_list: this.state.arr_list,
        graph_color: this.state.graph_color,
      };
      // console.log('https://web.mybiocalculus.com/html/Welcome/captureImage/' + userid + '/' + databaseid + '/' + last_beat+'/'+ config.stripcount+'/'+config.labelinfo+'/'+config.sel_arr+'/'+config.arr_list+'/'+config.newName);

      if (!last_beat) {
        return;
      } else {
        axios
          .post(`${apiUrl}api/graph/CaptureEvent_graph_new`, { //apiurl4 -web, 
            userid: userid, // https://data.mybiocalculus.com/api/api/graph/CaptureEvent_graph_new_web1
            databaseid: databaseid,
            last_beat: last_beat,
            stripcount: config.stripcount,
            labelinfo: config.labelinfo,
            sel_arr: config.sel_arr,
            arr_list: config.arr_list,
            newName: config.newName,
            graph_color: config.graph_color,
          })
          .then((res) => {
            if (res.data != null) {
              alert("Captured");
              toast.success("Captured!!");
            } else {
              alert("Error in capture Image");
            }
          })
          .catch((err) => {
            alert("Error in capture Image");
          });

        var minus_val = window.container * deviceFrequency;
        for (var i = 0; i < beats.length; i++) {
          this.state.chart.xAxis[0].removePlotBand(
            "plotband-" + (beats[i] - minus_val)
          );
        }
        window.beatArr = [];
      }
    }
  }

  quickRecat(e) {
    e.preventDefault();
    // this.setState({showModalSpinner:true})

    if (
      window.confirm(`Do you want to Proceed With ${this.state.fullCurrent}`)
    ) {
      $(".closePopup").click();
      this.enableKey();
      var databaseid = this.props.match.params.databaseid;
      var userid = this.props.match.params.userid;
      const config = {
        hrgt: this.state.hrgt,
        hrlt: this.state.hrlt,
        beatgt: this.state.beatgt,
        beatlt: this.state.beatlt,
        checkArr: this.state.checkArr,
        qRecatArr: this.state.qRecatArr,
        newArr: this.state.newArr,
        fullCurrent: this.state.fullCurrent,
        lowr: this.state.lowr,
        highr: this.state.highr,

        prev_arh: this.state.prev_arh,
        next_arh: this.state.next_arh,
        low_2_high: this.state.low_2_high,
        high_2_high: this.state.high_2_high,
      };

      // console.log('https://web.mybiocalculus.com/html/Welcome/captureImage/' + userid + '/' + databaseid + '/' + last_beat+'/'+ config.stripcount+'/'+config.labelinfo+'/'+config.sel_arr+'/'+config.arr_list+'/'+config.newName);
      axios

        .post(`${apiUrl}api/graph/Quickrecategorize`, {
          userid,
          databaseid,
          hrtgt: config.hrgt,
          hrlt: config.hrlt,
          beatgt: config.beatgt,
          beatlt: config.beatlt,
          checkArr: config.checkArr,
          qRecatArr: config.qRecatArr,
          fullCurrent: config.fullCurrent,
          newArr: config.newArr,
          lowr: config.lowr,
          highr: config.highr,
          prev_arh: config.prev_arh,
          next_arh: config.next_arh,
          low_2_high: config.low_2_high,
          high_2_high: config.high_2_high,
          selectedstarttime: this.state.selectedstarttime,
          selectedendtime: this.state.selectedendtime,
        })
        .then((res) => {
          // Quick Recategorize success — non-blocking auto-dismissing toast
          // instead of alert("Done") so the verifier doesn't have to click
          // OK between every QR action. Speeds up the workflow noticeably.
          toast.success("Quick Recategorize done");
          // //window.location.reload();
          // this.setState({showModalSpinner:false})
        })
        .catch((err) => {
          // Errors STILL block via alert() — the verifier needs to
          // acknowledge so they don't mistake failed QR for success.
          alert("Error in Quick Recategorize");
        });
    }
  }

  // Save the current Quick Recategorization form values to localStorage,
  // keyed per patient. Restored on next mount of this component.
  // localStorage is browser-local — other users on different machines are unaffected.
  saveQuickRecatPreset() {
    try {
      const userid = this.props.match.params && this.props.match.params.userid;
      if (!userid) {
        alert("Cannot save preset: patient id missing");
        return;
      }
      const preset = {
        hrgt: this.state.hrgt,
        hrlt: this.state.hrlt,
        beatgt: this.state.beatgt,
        beatlt: this.state.beatlt,
        lowr: this.state.lowr,
        highr: this.state.highr,
        low_2_high: this.state.low_2_high,
        high_2_high: this.state.high_2_high,
        prev_arh: this.state.prev_arh,
        next_arh: this.state.next_arh,
        selectedstarttime: this.state.selectedstarttime,
        selectedendtime: this.state.selectedendtime,
        checkArr: this.state.checkArr,
        fullCurrent: this.state.fullCurrent,
        qRecatArr: this.state.qRecatArr,
        newArr: this.state.newArr,
      };
      localStorage.setItem("qrecat:" + userid, JSON.stringify(preset));
      alert("Preset saved. It will load automatically next time for this patient.");
    } catch (err) {
      console.warn("[quickRecat] save preset failed:", err);
      alert("Could not save preset (storage may be full or disabled).");
    }
  }

  // Clear the saved preset for this patient and reset form fields to factory defaults.
  resetQuickRecatPreset() {
    try {
      const userid = this.props.match.params && this.props.match.params.userid;
      if (userid) localStorage.removeItem("qrecat:" + userid);
    } catch (err) { /* ignore */ }
    this.setState({
      hrgt: 0,
      hrlt: 0,
      beatgt: 0,
      beatlt: 0,
      lowr: 0,
      highr: 0,
      low_2_high: 0,
      high_2_high: 0,
      prev_arh: "Current",
      next_arh: "Current",
      selectedstarttime: "",
      selectedendtime: "",
      checkArr: "equal",
      fullCurrent: "Current",
      qRecatArr: "Current",
      newArr: "un",
    });
  }

  populateTimeOptions(treemenu) {
    let optionnewon = []; // For ascending order
    let optionnewendon = []; // For descending order

    // Iterate over each date group in treemenu
    Object.keys(treemenu).forEach((dateKey) => {
      treemenu[dateKey].forEach((entry) => {
        const MainTimeon = entry.date.split("T");
        const timeon = MainTimeon[1].split("+")[0]; // Extract time portion, ignoring timezone

        // Create the formatted time string: "date time"
        const timeStr = `${dateKey} ${timeon}`;

        // Push to both arrays
        optionnewon.push(timeStr);
        optionnewendon.push(timeStr);
      });
    });

    // Sort optionnewon (ascending order) by full date-time
    optionnewon.sort((a, b) => {
      const fullDateA = new Date(a);
      const fullDateB = new Date(b);
      return fullDateA - fullDateB;
    });

    // Sort optionnewendon (descending order) by full date-time
    optionnewendon.sort((a, b) => {
      const fullDateA = new Date(a);
      const fullDateB = new Date(b);
      return fullDateB - fullDateA;
    });

    this.setState({ 
      starttime: optionnewendon,
      endtime: optionnewon,
      availableTimeOptions: optionnewon,
      superimpose_start_date: optionnewon.length > 0 ? optionnewon[0] : "",
      superimpose_end_date: optionnewon.length > 0 ? optionnewon[optionnewon.length - 1] : "",
    });
  }

  disableKey(e) {
    this.setState({ keyIntegrationStatus: 0 });
    const treemenu = this.state.treemenu;
    let optionnewon = []; // For ascending order
    let optionnewendon = []; // For descending order

    // Iterate over each date group in treemenu
    Object.keys(treemenu).forEach((dateKey) => {
      treemenu[dateKey].forEach((entry) => {
        const MainTimeon = entry.date.split("T");
        const timeon = MainTimeon[1].split("+")[0]; // Extract time portion, ignoring timezone

        // Create the formatted time string: "date time"
        const timeStr = `${dateKey} ${timeon}`;

        // Push to both arrays
        optionnewon.push(timeStr);
        optionnewendon.push(timeStr);
      });
    });

    // Sort optionnewon (ascending order) by full date-time
    optionnewon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateA - fullDateB; // Ascending order: compare full date-time
    });

    // Sort optionnewendon (descending order) by full date-time
    optionnewendon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateB - fullDateA; // Descending order: compare full date-time
    });

    // Output the results
    // console.log('Sorted Ascending:', optionnewon);
    this.setState({ 
      starttime: optionnewendon,
      endtime: optionnewon,
      availableTimeOptions: optionnewon,
      superimpose_start_date: optionnewon.length > 0 ? optionnewon[0] : "",
      superimpose_end_date: optionnewon.length > 0 ? optionnewon[optionnewon.length - 1] : "",
    });

    // console.log(".....................", optionnewon);
  }
  enableKey(e) {
    this.setState({ keyIntegrationStatus: 1 });
    // clear superimpose error message when modal closes
    this.setState({ superimposeErrorMessage: "" });
  }
  //     analyzeDataset(e) {
  //         var userid = this.props.match.params.userid;
  //     var databaseid = this.props.match.params.databaseid;
  //     e.currentTarget.innerHTML="Analyzing...";
  //     //const userid = this.props.match.params.userid;
  //     axios
  //         .get('https://web.mybiocalculus.com/html/welcome/analyzeDataset/?userid=' + userid + '&&databaseid=' + databaseid+ '&&url=' + window.analyzeLink)
  //         .then(res => {
  //           console.log(res.data);
  //           window.location.href = '/';
  //         })
  //         .catch(err => {
  //             console.log(err);
  //         });
  //   }

  /*  _onSelect(e)
  {
    
    if(e.value=='RPeaks')
    {
        window.analyzeLink='/home/biocalculusssh/web_analysis/rpeaks_codes/analyze_last_correct.py';
    }
    else if(e.value=='Classic')
    {
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_peak/analyze_last_correct.py';
    }
    else if(e.value=='Classical')
    {
        window.analyzeLink='/home/biocalculusssh/web_analysis/classical_code/analyze_last_correct.py';
    }
    else if(e.value=='Classic Negative')
    {
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_negpeak/analyze_last_correct.py';
    }
    else if(e.value=='AI')
    {
        window.analyzeLink='/home/biocalculusssh/web_analysis/ai_codes/analyze_last_correct.py';
    }
    else if(e.value=='AIcodes')
    {
        window.analyzeLink='/home/biocalculusssh/web_analysis/saroja_aicodes/analyze_last_correct.py';
    }
   
  }*/

  handleModal(db) {
    this.setState({ clickdb: db });
    this.setState({ isModalOpen: true });
  }
  resetModal() {
    this.setState({ isModalOpen: false });
  }
  resetmodaldis() {
    this.setState({ ismodaldisOpen: false });
  }

  handlemodaldis(db) {
    this.setState({ ismodaldisOpen: true });
  }

  resetModalReport() {
    this.setState({ isModalReportOpen: false });
  }
  handleModalInside(db) {
    this.setState({ clickdb: db });
    this.setState({ isModalInsideOpen: true });
  }

  handleModalReport(db) {
    this.setState({ isModalReportOpen: true });
  }

  resetModalData() {
    this.setState({ isModaldataOpen: false });
  }

  handleModalData(db) {
    this.setState({ isModaldataOpen: true });
  }

  handleDiary(db, maindt) {
    //  console.log("db",db);
    //   console.log("userid",this.props.match.params.userid);
    //  console.log("maindt",maindt);
    var MainTime = db.split("T");
    var time = MainTime[1].split("+");
    db = MainTime[0] + " " + time[0];
    //   console.log(MainTime[0]+""+time[0]);
    //this.setState({"showModalSpinner":true});
    var searchArr = [];

    axios
      .get(
        apiUrl +
        "api/common/getAllRPeakValues?userid=" +
        this.props.match.params.userid +
        "&databaseid=" +
        db
      )
      .then((res) => {
        this.setState({ showModalSpinner: false });

        searchArr.push(res.data);
        var queryTime = maindt.split(" ")[1];

        var closest = "23:59:59";
        var rpeakI;
        Object.keys(searchArr).map((val, key) => {
          searchArr[val].map((value, key) => {
            const time1 = value.peaktime;

            if (time1 >= queryTime && (time1 < closest || time1 < closest)) {
              closest = value.peaktime;

              rpeakI = value.rpeakindex;
              //  console.log('key',key);
              //  console.log("closest",closest);
              //  console.log("rpeakI",rpeakI);
              //this.callDiaryDataAPIs(db,this.props.match.params.userid,start,end,window.stripXValue);
            }
          });
        });

        if (rpeakI > 15000) {
          var stripIndex = Math.floor(rpeakI / 15000);
        } else {
          var stripIndex = 0;
        }
        window.stripXValue = parseInt(rpeakI) - stripIndex * 15000;
        var start = stripIndex,
          end = stripIndex + 9;
        //console.log("rpeakindex",rpeakI);

        if (Number.isNaN(window.stripXValue)) {
          alert("dataset not available");
        } else {
          window.location.href =
            "/verifier-chart/" +
            this.props.match.params.userid +
            "/" +
            db +
            "/" +
            start +
            "/" +
            end +
            "/" +
            window.stripXValue;
        }
      })
      .catch((err) => {
        this.setState({ showModalSpinner: false });
        alert(err);
      });
  }
  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      // when status is changed, perform immediate validation
      if (name === "superimposeStatus") {
        // clear any existing message first
        this.setState({ superimposeErrorMessage: "" }, () => {
          // if user selected verify but the dataset is not marked verified, show message
          if (
            value === "verify" &&
            this.state.verifyCheck &&
            this.state.verifyCheck.data === 0
          ) {
            this.setState({
              superimposeErrorMessage: "The selected dataset is unverified",
            });
          }
        });
      }
    });

    if (name == "arr_list") {
      this.setState({ ["newName"]: value });
    }
  };
  onStarttimeChange = (e) => {
    var value = e.currentTarget.value;
    this.setState({ selectedstarttime: value });
  };

  onEndtimeChange = (e) => {
    var value = e.currentTarget.value;
    this.setState({ selectedendtime: value });
  };

  afibSubmit(e) {
    e.preventDefault();

    const userid = this.props.match.params.userid;
    const databaseid = this.state.databaseid || this.props.match.params.databaseid;
    const beatOrder = this.state.beat_order;

    if (!beatOrder || String(beatOrder).trim() === "") {
      alert("Please enter a beat number");
      return;
    }

    const beatNumber = parseInt(beatOrder, 10);
    if (isNaN(beatNumber)) {
      alert("Please enter a valid beat number");
      return;
    }

    const verifyStatus = this.state.afibStatus === "verify" ? 1 : 0;
    const applyUpdate = this.state.afibApply === "yes";

    this.setState({ showModalSpinner: true, responseMessage: "", afibOutputText: "" });

    const closeButton = document.querySelector("#AfibModal .close");
    if (closeButton) {
      closeButton.click();
    }

    const requestData = {
      userid: userid,
      dataset: databaseid,
      normal_beat: beatNumber,
      start_dataset: this.state.afibDbStartTime || null,
      end_dataset: this.state.afibDbEndTime || null,
      verify_status: verifyStatus,
      update: applyUpdate,
    };

    axios
  
      .post(`${apiUrl4}api/common/fib_detection`, requestData) //web1 - https://web1.mybiocalculus.com/api/common/fib_detection
      .then((res) => {
        const outputText =
          res.data.output ||
          res.data.message ||
          (typeof res.data === "string" ? res.data : JSON.stringify(res.data));
        toast.success(res.data.message || "Afib applied successfully");
        this.setState({
          afibOutputText: outputText,
          showModalSpinner: false,
        });

        const closeBtn = document.querySelector("#AfibModal .close");
        if (closeBtn) {
          closeBtn.click();
        }

        setTimeout(() => {
          this.setState({ afibOutputModalOpen: true });
        }, 200);
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.error) ||
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          "Failed to apply Afib";
        toast.error(`Failed to apply Afib: ${msg}`);
        this.setState({ showModalSpinner: false, afibOutputText: `Error: ${msg}` });

        setTimeout(() => {
          this.setState({ afibOutputModalOpen: true });
        }, 200);
      });
  }

  vtSubmit(e) {
    e.preventDefault();

    const userid = this.props.match.params.userid;
    const databaseid = this.state.databaseid || this.props.match.params.databaseid;
    const beatOrder = this.state.beat_order;

    if (!beatOrder || String(beatOrder).trim() === "") {
      alert("Please enter a beat number");
      return;
    }

    const beatNumber = parseInt(beatOrder, 10);
    if (isNaN(beatNumber)) {
      alert("Please enter a valid beat number");
      return;
    }

    const verifyStatus = this.state.vtStatus === "verify" ? 1 : 0;
    const applyUpdate = this.state.vtApply === "yes";

    this.setState({ showModalSpinner: true, responseMessage: "", vtOutputText: "" });

    const closeButton = document.querySelector("#VTModal .close");
    if (closeButton) {
      closeButton.click();
    }

    const requestData = {
      userid: userid,
      dataset: databaseid,
      normal_beat: beatNumber,
      start_dataset: this.state.vtDbStartTime || null,
      end_dataset: this.state.vtDbEndTime || null,
      verify_status: verifyStatus,
      update: applyUpdate,
    };

    axios
      .post(`${apiUrl4}api/common/vt_detect`, requestData)
      .then((res) => {
        const outputText =
          res.data.output ||
          res.data.message ||
          (typeof res.data === "string" ? res.data : JSON.stringify(res.data));
        toast.success(res.data.message || "VT applied successfully");
        this.setState({
          vtOutputText: outputText,
          showModalSpinner: false,
        });

        const closeBtn = document.querySelector("#VTModal .close");
        if (closeBtn) {
          closeBtn.click();
        }

        setTimeout(() => {
          this.setState({ vtOutputModalOpen: true });
        }, 200);
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.error) ||
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          "Failed to apply VT";
        toast.error(`Failed to apply VT: ${msg}`);
        this.setState({ showModalSpinner: false, vtOutputText: `Error: ${msg}` });

        setTimeout(() => {
          this.setState({ vtOutputModalOpen: true });
        }, 200);
      });
  }

  twoDSubmit(e) {
    e.preventDefault();

    const userid = this.props.match.params.userid;
    const databaseid = this.state.databaseid || this.props.match.params.databaseid;
    const beatOrder = this.state.beat_order;

    if (!beatOrder || String(beatOrder).trim() === "") {
      alert("Please enter a beat number");
      return;
    }

    const beatNumber = parseInt(beatOrder, 10);
    if (isNaN(beatNumber)) {
      alert("Please enter a valid beat number");
      return;
    }

    const verifyStatus = this.state.twoDStatus === "verify" ? 1 : 0;
    const applyUpdate = this.state.twoDApply === "yes";

    this.setState({ showModalSpinner: true, responseMessage: "", twoDOutputText: "" });

    const closeButton = document.querySelector("#TwoDModal .close");
    if (closeButton) {
      closeButton.click();
    }

    const requestData = {
      userid: userid,
      dataset: databaseid,
      normal_beat: beatNumber,
      start_dataset: this.state.twoDDbStartTime || null,
      end_dataset: this.state.twoDDbEndTime || null,
      verify_status: verifyStatus,
      update: applyUpdate,
    };

    axios
      .post(`${apiUrl4}api/common/2d_detection`, requestData)
      .then((res) => {
        const outputText =
          res.data.output ||
          res.data.message ||
          (typeof res.data === "string" ? res.data : JSON.stringify(res.data));
        toast.success(res.data.message || "2D applied successfully");
        this.setState({
          twoDOutputText: outputText,
          showModalSpinner: false,
        });

        const closeBtn = document.querySelector("#TwoDModal .close");
        if (closeBtn) {
          closeBtn.click();
        }

        setTimeout(() => {
          this.setState({ twoDOutputModalOpen: true });
        }, 200);
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.error) ||
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          "Failed to apply 2D";
        toast.error(`Failed to apply 2D: ${msg}`);
        this.setState({ showModalSpinner: false, twoDOutputText: `Error: ${msg}` });

        setTimeout(() => {
          this.setState({ twoDOutputModalOpen: true });
        }, 200);
      });
  }

  missedBeatDetect() {
    const userid = this.props.match.params.userid;
    const dataset = this.state.databaseid || this.props.match.params.databaseid;

    this.setState({ missedBeatLoading: true, missedBeatOutputText: "" });

    axios
      .post("https://web.mybiocalculus.com:3002/api/common/missed_beat_detection", {
        userid: userid,
        dataset: dataset,
        update: true,
        
      })
      .then((res) => {
        const outputText =
          res.data.output ||
          res.data.message ||
          (typeof res.data === "string" ? res.data : JSON.stringify(res.data));
        this.setState({ missedBeatOutputText: outputText, missedBeatLoading: false });
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          "Failed to detect missed beats";
        this.setState({ missedBeatOutputText: `Error: ${msg}`, missedBeatLoading: false });
      });
  }

  missedBeatsSubmit(e) {
    e.preventDefault();
    const userid = this.props.match.params.userid;
    const startDb = this.state.missedBeatsStartTime;
    const endDb = this.state.missedBeatsEndTime;
    const status = this.state.missedBeatsStatus;
   

    if (!startDb || !endDb) {
      toast.error("Please select Start Time and End Time");
      return;
    }

    this.setState({ showModalSpinner: true });

    let apiData;
    if (startDb === endDb) {
      // Single dataset - use range format with same start and end
      apiData = {
        userid: userid,
        start_db: startDb,
        end_db: startDb,
        update: true,
        verify_status:status
      };
    } else {
      // Range selection
      apiData = {
        userid: userid,
        start_db: startDb,
        end_db: endDb,
        update: false,
        verify_status:status
      };
    }

    axios
      .post(`${apiUrl4}api/common/missed_beat_detection_selection`, apiData)
      .then((res) => {
        const apiParams = JSON.stringify(apiData, null, 2);
        const outputText = `Parameters sent:\n${apiParams}\n\nResponse:\n${res.data.output || res.data.message || "Missed beats detection completed"}`;
        toast.success(res.data.message || "Missed beats detection completed");
        this.setState({
          missedBeatOutputText: outputText,
          showModalSpinner: false
        });
        // Close modal and open output modal
        const closeButton = document.querySelector("#MissedBeatsModal .close");
        if (closeButton) {
          closeButton.click();
        }
        setTimeout(() => {
          this.setState({ missedBeatOutputModalOpen: true });
        }, 200);
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          "Failed to detect missed beats";
        toast.error("Failed to detect missed beats: " + msg);
        this.setState({ showModalSpinner: false });
      });
  }

  removeHrSubmit(e) {
    e.preventDefault();
    const start = parseInt(this.state.hrlt);
    const end = parseInt(this.state.hrgt);

    if (isNaN(start) || isNaN(end) || start > end) {
      toast.error("Please enter a valid beat range (HR Less ≤ HR Greater)");
      return;
    }

    const userid = this.props.match.params.userid;
    const databaseid = this.state.databaseid || this.props.match.params.databaseid;
    const startDb = this.state.removeHrStartDate;
    const endDb = this.state.removeHrEndDate;
    const apply = this.state.removeHrApply;
    const status = this.state.removeHrStatus;
   
     
      
    const applyUpdate =
      apply === true || apply === "true" || apply === "yes" ? true : false;
    
    this.setState({ showModalSpinner: true });

    axios
      .post(`${apiUrl4}api/common/remove_beats_by_hr_reindexing_exclude`, {
        userid: userid,
        all_datasets: true,
        start_db_time: startDb,
        end_db_time: endDb,
        verify_status: status,
        remove_hr_between: [this.state.hrlt, this.state.hrgt],
        include_label: this.state.removeHrIncludeArr || [],
        exclude_label: this.state.removeHrExcludeArr || [],
        update: applyUpdate
      })
      .then((res) => {
        const outputText = res.data.output || res.data.message || "Beats deleted successfully";
        toast.success(res.data.message || "Beats deleted successfully");

        const updatedRarr = (this.state.rarr || []).map((chartData) =>
          chartData.filter((point) => point.beat < start || point.beat > end)
        );

        this.setState({
          rarr: updatedRarr,
          hrlt: "",
          hrgt: "",
          removeHrOutputText: outputText,
          showModalSpinner: false,
        });

        const closeButton = document.querySelector("#RemoveHrModal .close");
        if (closeButton) {
          closeButton.click();
        }

        setTimeout(() => {
          this.setState({ removeHrOutputModalOpen: true });
        }, 200);

        if (this.state.chart && this.state.chart.series && this.state.chart.series[5]) {
          this.state.chart.series[5].setData(updatedRarr[0] || []);
        }

      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          "Failed to delete beats";
        toast.error(`Failed to delete beats: ${msg}`);
        this.setState({ showModalSpinner: false });
      });
  }

  handleRemoveHrIncludeChange(values) {
    this.setState({ removeHrIncludeArr: values });
  }

  handleRemoveHrExcludeChange(values) {
    this.setState({ removeHrExcludeArr: values });
  }

  openChartPopup(source) {
    const popup = document.querySelector("#popup");
    if (popup) {
      popup.className = "popup-open";
    }
  }

  closePopup(source) {
    // Clear any marquee/shift+click/click selection state so the next
    // popup open starts fresh — leaving stale beatArr or plotbands
    // around would cause future arrhythmia clicks to act on the wrong
    // (or removed) beats.
    this.clearSelectionState();

    const popup = document.querySelector("#popup");
    if (popup) {
      popup.className = "popup-close";
    }
  }

  // Centralised "drop everything the user had selected" — used by
  // closePopup AND after every recategorize action so applying a label
  // doesn't leave a stale selection behind.
  clearSelectionState() {
    try {
      window.beatArr = [];
      window.selectedBeatNumber = null;

      // Find the LIVE popup chart. Three fallbacks:
      //   1. window.popupChart — set in renderMainChart on every new
      //      StockChart instantiation. Most reliable.
      //   2. this.state.chart — may be stale (set once at mount).
      //   3. Look up by tt_container id in Highcharts' global chart list.
      var ch = (typeof window !== "undefined" && window.popupChart) || null;
      if (!ch && this.state && this.state.chart) ch = this.state.chart;
      if (!ch && typeof Highcharts !== "undefined" && Highcharts.charts) {
        for (var ci = 0; ci < Highcharts.charts.length; ci++) {
          var c = Highcharts.charts[ci];
          if (c && c.renderTo && c.renderTo.id === "tt_container") {
            ch = c;
            break;
          }
        }
      }

      if (ch && ch.xAxis && ch.xAxis[0]) {
        var ax = ch.xAxis[0];
        // Destroy the SVG band elements directly.
        var alive = (ax.plotLinesAndBands || []).slice();
        for (var i = 0; i < alive.length; i++) {
          if (alive[i] && alive[i].destroy) {
            try { alive[i].destroy(); } catch (e) {}
          }
        }
        ax.plotLinesAndBands = [];
        if (ax.options)     ax.options.plotBands     = [];
        if (ax.userOptions) ax.userOptions.plotBands = [];
        // Propagate the empty plotBands to chart-level config so the
        // next redraw (or chart.update) doesn't pull stale entries back.
        try { ch.update({ xAxis: { plotBands: [] } }, false); } catch (e) {}
        try { ch.redraw(false); } catch (e) {}
      }

      // Clear the renderNewChart-scope `plotband` closure that
      // clickFunction pushes onto. Without this, the next single click
      // on a strip replays whatever was in the array from the previous
      // marquee/click.
      if (window.popupPlotbandRef && window.popupPlotbandRef.length) {
        window.popupPlotbandRef.length = 0;
      }

      // Cross-strip marquee bands live on strip mini-charts, not on the
      // popup. Remove each tracked band by id so a fresh selection
      // (or label apply) leaves no red strip thumbnails behind.
      if (window.crossStripBands) {
        var charts = (this.state && this.state.charts) || [];
        var startOffset = (this.state && this.state.start) || 0;
        for (var sIdx in window.crossStripBands) {
          if (!Object.prototype.hasOwnProperty.call(
                window.crossStripBands, sIdx)) continue;
          var stripIdxInt = parseInt(sIdx, 10);
          var stripChart  = charts[stripIdxInt - startOffset];
          if (!stripChart || !stripChart.xAxis || !stripChart.xAxis[0]) continue;
          var stripAx = stripChart.xAxis[0];
          var bandIds = window.crossStripBands[sIdx] || [];
          for (var bi = 0; bi < bandIds.length; bi++) {
            try { stripAx.removePlotBand(bandIds[bi]); } catch (e) {}
          }
          try { stripChart.redraw(false); } catch (e) {}
        }
        window.crossStripBands = null;
      }
    } catch (e) {
      // Non-fatal — selection state is best-effort.
    }
  }

  // Strip mini-charts live in divs with id "containerN". Given a screen
  // point, walk up from the element under that point to find the
  // enclosing strip and return N. Returns null if the point isn't over
  // any strip. Used by the cross-strip marquee to detect mouseup target.
  findStripIndexAt(clientX, clientY) {
    if (typeof document === "undefined") return null;
    var el = document.elementFromPoint(clientX, clientY);
    while (el && el !== document.body) {
      var id = el.id || "";
      if (id.length > 9 && id.indexOf("container") === 0) {
        var n = parseInt(id.replace("container", ""), 10);
        if (!isNaN(n)) return n;
      }
      el = el.parentElement;
    }
    return null;
  }

  // Cross-strip Cmd+drag: marquee spans multiple minute strips. Apply
  // red plotbands to each spanned strip's mini-chart and populate
  // window.beatArr with global beat coords for the existing label-apply
  // pipeline (recategorize). NO popup opens — verifier confirms via
  // strip thumbnails and applies a label via Ctrl-shortcut.
  //
  // opts:
  //   startStrip:   int  — strip index where drag began
  //   endStrip:     int  — strip index where drag ended (≠ startStrip)
  //   startXValue:  num  — xAxis value on startStrip where drag began
  //   endXValue:    num  — xAxis value on endStrip   where drag ended
  applyCrossStripSelection(opts) {
    var charts      = (this.state && this.state.charts)  || [];
    var result3     = (this.state && this.state.result3) || [];
    var startOffset = (this.state && this.state.start)   || 0;

    var minStrip = Math.min(opts.startStrip, opts.endStrip);
    var maxStrip = Math.max(opts.startStrip, opts.endStrip);

    // Wipe any prior selection (popup bands AND strip bands) so a fresh
    // cross-strip drag starts clean.
    this.clearSelectionState();

    var globalBeats = [];
    var bandsByStrip = {};

    for (var s = minStrip; s <= maxStrip; s++) {
      var stripChart = charts[s - startOffset];
      var stripBeats = result3[s - startOffset] || [];
      if (!stripChart || !stripChart.xAxis || !stripChart.xAxis[0]) continue;

      // Per-strip x range:
      //   - startStrip: from drag-start to right edge (or 0..drag-start
      //     for reverse drag)
      //   - middle strips: whole strip [0, deviceFrequency]
      //   - endStrip: from left edge to drag-end (or drag-end..right
      //     edge for reverse drag)
      var xMin, xMax;
      if (s === opts.startStrip) {
        if (opts.endStrip > opts.startStrip) {
          xMin = opts.startXValue; xMax = deviceFrequency;
        } else {
          xMin = 0; xMax = opts.startXValue;
        }
      } else if (s === opts.endStrip) {
        if (opts.endStrip > opts.startStrip) {
          xMin = 0; xMax = opts.endXValue;
        } else {
          xMin = opts.endXValue; xMax = deviceFrequency;
        }
      } else {
        xMin = 0; xMax = deviceFrequency;
      }

      var ax = stripChart.xAxis[0];
      var stripBandIds = [];
      var jOff = s * deviceFrequency;

      // Populate globalBeats from per-beat picks (used by recategorize).
      // The visible band is rendered ONCE per strip as a single region
      // covering the full dragged range — a per-beat band at strip
      // thumbnail scale (~1100 px / 15000 units = 0.07 px/unit) renders
      // ~8 px wide with ~30 px gaps between bands, giving the visual
      // impression of "some beats not selected" even though every beat
      // is in window.beatArr.
      for (var k = 0; k < stripBeats.length; k++) {
        var bx = stripBeats[k] && stripBeats[k].x;
        if (bx == null) continue;
        if (bx >= xMin && bx <= xMax) {
          globalBeats.push(bx + jOff);
        }
      }

      // Render one region band per strip if any beats were picked.
      // Semi-transparent so the underlying ECG line stays readable.
      var stripPicked = globalBeats.filter(function (gb) {
        return gb >= jOff && gb <= jOff + deviceFrequency;
      }).length;
      if (stripPicked > 0) {
        var regionId = "xstrip-region-" + s;
        stripBandIds.push(regionId);
        try {
          ax.addPlotBand({
            color: "rgba(255, 51, 51, 0.35)",
            from:  xMin,
            to:    xMax,
            id:    regionId,
          });
        } catch (e) {}
        bandsByStrip[s] = stripBandIds;
      }
      try { stripChart.redraw(false); } catch (e) {}
    }

    window.beatArr = globalBeats;
    window.crossStripBands = bandsByStrip;

    console.log(
      "[xstrip] selected:" +
      " strips=" + minStrip + ".." + maxStrip +
      " beats=" + globalBeats.length +
      " strips_with_bands=" + Object.keys(bandsByStrip).length
    );
  }

  handleKeyPress(event) {
    if (event.key === "F2" || (event.ctrlKey && event.key === "z")) {
      event.preventDefault();
      this.prevBtnLink(
        this.props.match.params.userid,
        this.props.match.params.databaseid
      );
    }
    if (event.key === "F3" || (event.ctrlKey && event.key === "x")) {
      event.preventDefault();
      this.nextBtnLink(
        this.props.match.params.userid,
        this.props.match.params.databaseid
      );
    }
    if (
      (event.ctrlKey && event.key === "g") ||
      (event.ctrlKey && event.key === "G")
    ) {
      event.preventDefault(); // Prevent default browser action if necessary

      // Find the link element
      const chartTab = document.querySelector("#chart_tab_6");
      if (chartTab) {
        // Trigger the click programmatically
        chartTab.click();
      }
      this.fetchminmaxHr();
    }
    if (event.key === "Escape") {
      // 40 is the key code for the down arrow key
      this.closePopup("keyboard");
    }
    if (
      (event.ctrlKey && event.key === "v") ||
      (event.ctrlKey && event.key === "V")
    ) {
      // 40 is the key code for the down arrow key
      this.verify();
    }
    if (
      (event.ctrlKey && event.key === "o") ||
      (event.ctrlKey && event.key === "O")
    ) {
      this.openChartPopup("keyboard");
    }
    if (
      (event.ctrlKey && event.key === "q") ||
      (event.ctrlKey && event.key === "Q")
    ) {
      document.getElementById("quickRecat").click();
    }
    if (
      (event.ctrlKey && event.key === "c") ||
      (event.ctrlKey && event.key === "C")
    ) {
      const captureButton = document.querySelector(
        '[data-target="#captureModal"]'
      );
      if (captureButton) {
        captureButton.click();
      }
    }
    // Cross-strip mode has no popup, so .arythmia-btn isn't in the DOM.
    // Fallback: if beats are selected (window.beatArr non-empty) but the
    // button isn't found, call recategorize directly via a synthetic
    // event. Popup-open case keeps using the click for backwards-compat
    // (the button's bound handlers may include side effects).
    var labelShortcut = (key, label) => {
      if (event.key !== key && event.key !== key.toUpperCase()) return false;
      if (!event.ctrlKey) return false;
      var btn = document.querySelector('.arythmia-btn[value="' + label + '"]');
      if (btn) {
        btn.click();
      } else if (window.beatArr && window.beatArr.length > 0) {
        this.recategorize({ currentTarget: { value: label } });
      }
      return true;
    };
    if (labelShortcut("s", "Sinus Tachycardia"))      return;
    if (labelShortcut("b", "Sinus Bradycardia"))      return;
    if (labelShortcut("a", "PAC"))                    return;
    if (labelShortcut("t", "Ventricular Tachycardia")) return;
    if (labelShortcut("f", "UN"))                     return;
    if (labelShortcut("u", "AFib"))                   return;
  }

  render() {
    //selWrap
    let titleFlag = 0;
    const options = [
      "RPeaks",
      "Classic",
      "Classical",
      "Classic Negative",
      "AI",
      "AIcodes",
    ];
    const { errors } = this.state;
    const customStyles = {
      content: {
        background: "transparent",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    const defaultOption = options[0];
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    const userid = this.props.match.params.userid;
    var databaseid = this.props.match.params.databaseid;
    const text = "Recategorizing......";
    if (typeof databaseid === "undefined") {
      databaseid = "0";
    }
    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        {/* Type-10 "new patient assigned" popup — lists what the admin just
            assigned and which server it's on, since the verifier may be
            logged into a different server right now. Rendered conditionally
            on state rather than via Bootstrap's $(...).modal() plugin,
            which isn't loaded in this bundle. */}
        {this.state.newAssignmentAlerts.length > 0 && (
          <div
            style={{
              position: "fixed",
              top: 0, right: 0, bottom: 0, left: 0,
              zIndex: 1050,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(0,0,0,0.65)",
            }}
          >
            <style>{`
              @keyframes emergencyPulse {
                0%   { box-shadow: 0 0 0 0 rgba(220,53,69,0.7); }
                70%  { box-shadow: 0 0 0 18px rgba(220,53,69,0); }
                100% { box-shadow: 0 0 0 0 rgba(220,53,69,0); }
              }
              @keyframes emergencyBlink {
                0%, 100% { opacity: 1; }
                50% { opacity: 0.35; }
              }
            `}</style>
            <div
              style={{
                background: "#fff",
                color: "#333",
                borderRadius: 10,
                width: "100%",
                maxWidth: 480,
                margin: 16,
                overflow: "hidden",
                border: "2px solid #dc3545",
                animation: "emergencyPulse 1.6s infinite",
              }}
            >
              <div
                style={{
                  padding: "18px 20px",
                  background: "linear-gradient(135deg, #dc3545, #a42434)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                }}
              >
                <span style={{ fontSize: 24, animation: "emergencyBlink 1s infinite" }}>🚨</span>
                <h4
                  style={{
                    margin: 0,
                    textAlign: "center",
                    fontWeight: 800,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                  }}
                >
                  Emergency File{this.state.newAssignmentAlerts.length === 1 ? "" : "s"} Assigned
                </h4>
                <span style={{ fontSize: 24, animation: "emergencyBlink 1s infinite" }}>🚨</span>
              </div>
              <div style={{ padding: "18px 20px" }}>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {this.state.newAssignmentAlerts.map((a) => (
                    <li
                      key={a.id}
                      style={{
                        padding: "12px 14px",
                        marginBottom: 10,
                        background: "#fff5f5",
                        border: "1px solid #f5c2c7",
                        borderLeft: "4px solid #dc3545",
                        borderRadius: 8,
                      }}
                    >
                      <div style={{ fontWeight: 700, color: "#842029" }}>
                        {a.patientName}
                        {a.deviceId != null ? ` (Device ${a.deviceId})` : ""}
                      </div>
                      <div style={{ color: "#777", fontSize: 13 }}>
                        Server: {a.server || "—"}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div style={{ padding: "14px 20px", borderTop: "1px solid #f1f1f1", textAlign: "right" }}>
                <button
                  type="button"
                  onClick={this.acknowledgeNewAssignments}
                  style={{
                    background: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "10px 24px",
                    fontWeight: 700,
                    fontSize: 14,
                    letterSpacing: 0.5,
                    cursor: "pointer",
                  }}
                >
                  GOT IT
                </button>
              </div>
            </div>
          </div>
        )}
        <input type="hidden" value={this.state.nextDbId} id="nextDbId" />
        <input type="hidden" value={this.state.prevDbId} id="prevDbId" />
        {/* <TopNav
          profileLink={this.state.profileLink}
          userid={userid}
          databaseid={databaseid}
        /> */}

        {this.state.verifiertype !== "6" && (
          <SideBarGraph
            userid={userid}
            onSelectModal={this.handleModal}
            menus={this.state.menus}
            treemenu={this.state.treemenu}
            databaseid={databaseid}
          />
        )}
        {this.state.verifiertype === "6" && (
          <style>{`
            .page-wrapper { margin-left: 0 !important; }
            .arythmia-btn { display: none !important; }
          `}</style>
        )}
        <AddModal
          userid={userid}
          isOpen={this.state.isModalOpen}
          onResetModal={this.resetModal}
          clickdb={this.state.clickdb}
          start={this.props.match.params.start}
        />

        <AddModalInside
          clickdb={this.state.clickdb}
          userid={this.state.userid}
          isOpen={this.state.isModalInsideOpen}
          onResetModal={this.resetModal}
          start={this.props.match.params.start}
        />
        <AddModalReport
          userid={userid}
          onSelectModalReport={this.resetModalReport}
          isOpen={this.state.isModalReportOpen}
          treemenu={this.state.treemenu}
        />

        <Addmodaldisclosure
          userid={userid}
          onSelectmodaldis={this.resetmodaldis}
          isOpen={this.state.ismodaldisOpen}
          treemenu={this.state.treemenu}
        />
        <ReactModal isOpen={this.state.showModalSpinner} style={customStyles}>
          <Loader type="Puff" color="#00BFFF" height={100} width={100} />
          <div className="bounce-container">
            {text.split("").map((char, index) => (
              <span
                key={index}
                className="bounce-letter"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {char}
              </span>
            ))}
          </div>
        </ReactModal>
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "-1%" }}>
          <div className="container-fluid" style={{ marginTop: "3%" }}>
            <div className="row">
              <div className="col-lg-12 col-sm-12">
                <div className="panel panel-default card-view graphMainCont">
                  <div className="panel-wrapper collapse in">
                    <div className="panel-body">
                      <div className="pills-struct">
                        <ul
                          role="tablist"
                          className="nav nav-pills"
                          id="myTabs_6"
                        >
                          <li
                            role="presentation"
                            className="active"
                            style={{ height: "30px" }}
                          >
                            <a
                              data-toggle="tab"
                              id="chart_tab_2"
                              onClick={this.setTab.bind(this)}
                              role="tab"
                              href="#chart_beats"
                              aria-expanded="true"
                              style={{ height: "30px" }}
                            >
                              {this.props.match.params.start == undefined && (
                                <img
                                  id="beatsimg"
                                  src="../../dist/img/Beats.png"
                                />
                              )}
                              {this.props.match.params.start != undefined && (
                                <img
                                  id="beatsimg"
                                  src="../../../../dist/img/Beats.png"
                                />
                              )}
                            </a>
                          </li>
                          <li role="presentation" style={{ height: "30px" }}>
                            <a
                              aria-expanded="false"
                              data-toggle="tab"
                              onClick={this.setTab.bind(this)}
                              role="tab"
                              id="chart_tab_1"
                              href="#chart_events"
                              style={{ height: "30px" }}
                            >
                              {this.props.match.params.start == undefined && (
                                <img
                                  id="eventsimg"
                                  src="../../dist/img/EventsSelected.png"
                                />
                              )}
                              {this.props.match.params.start != undefined && (
                                <img
                                  id="eventsimg"
                                  src="../../../../dist/img/EventsSelected.png"
                                />
                              )}
                            </a>
                          </li>

                          {/* <li
                            role="presentation"
                            className=""
                            style={{ height: "30px" }}
                          >
                            <a
                              data-toggle="tab"
                              id="chart_tab_3"
                              onClick={this.fetchSummary.bind(this)}
                              role="tab"
                              href="#chart_summary"
                              aria-expanded="false"
                              style={{ height: "30px" }}
                            >
                              <img
                                id="summaryimg"
                                src="../../dist/img/Summary.png"
                              />
                            </a>
                          </li> */}

                          <li
                            className=""
                            role="presentation"
                            style={{ height: "30px" }}
                          >
                            <a
                              data-toggle="tab"
                              role="tab"
                              id="chart_tab_5"
                              onClick={this.selectedEvents.bind(this)}
                              href="#chart_sel_events"
                              aria-expanded="false"
                              style={{ height: "30px" }}
                            >
                              <img
                                id="selectimg"
                                src="../../dist/img/SelectedEvents.png"
                              />
                            </a>
                          </li>
                          {/* Findings tab removed */}
                          {/* <li role="presentation"  style={{"height":"30px"}}>
                            <a  data-toggle="tab" id="chart_tab_settings" onClick={this.setTab.bind(this)} role="tab" href="#chart_settings" aria-expanded="false" style={{"height":"30px"}}><img id="settingsImg" src="../../dist/img/Settings.png"/></a>
                          </li>  */}
                          <li
                            role="presentation"
                            id="chart_tab_report"
                            className="pull-right"
                            style={{ height: "30px" }}
                          >
                            <a
                              onClick={this.fulldisclosure.bind(this)}
                              href="#"
                              title="Generate & download Full Disclosure PDF"
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                background:
                                  "linear-gradient(135deg, #2ECD99 0%, #25a87c 100%)",
                                color: "#ffffff",
                                padding: "6px 14px",
                                borderRadius: "20px",
                                fontWeight: 600,
                                fontSize: "13px",
                                letterSpacing: "0.3px",
                                boxShadow: "0 2px 6px rgba(46,205,153,0.35)",
                                marginRight: "8px",
                                marginTop: "-2px",
                                textDecoration: "none",
                                transition: "transform 0.15s ease, box-shadow 0.15s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-1px)";
                                e.currentTarget.style.boxShadow =
                                  "0 4px 10px rgba(46,205,153,0.5)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow =
                                  "0 2px 6px rgba(46,205,153,0.35)";
                              }}
                            >
                              <span aria-hidden="true">📄</span>
                              Full Disclosure
                            </a>
                          </li>
                          {/* Generate Report — always visible. The
                              orange "Please Wait" pill that used to swap
                              in when reportStatus === 3 has been removed:
                              the in-progress feedback comes from the
                              progress bar inside the AddModalReport flow,
                              and the old pill could get stuck if
                              reportStatus didn't refresh in state. */}
                          <li
                            role="presentation"
                            id="chart_tab_report"
                            className="pull-right"
                            style={{ height: "30px" }}
                          >
                            <a
                              onClick={this.generateReport.bind(this)}
                              href="#"
                              title="Generate the analysis report"
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                background:
                                  "linear-gradient(135deg, #3F8EFC 0%, #2C6BD6 100%)",
                                color: "#ffffff",
                                padding: "6px 14px",
                                borderRadius: "20px",
                                fontWeight: 600,
                                fontSize: "13px",
                                letterSpacing: "0.3px",
                                boxShadow: "0 2px 6px rgba(63,142,252,0.35)",
                                marginRight: "8px",
                                marginTop: "-2px",
                                textDecoration: "none",
                                transition: "transform 0.15s ease, box-shadow 0.15s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-1px)";
                                e.currentTarget.style.boxShadow =
                                  "0 4px 10px rgba(63,142,252,0.5)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow =
                                  "0 2px 6px rgba(63,142,252,0.35)";
                              }}
                            >
                              <span aria-hidden="true">📊</span>
                              Generate Report
                            </a>
                          </li>
                          {/* Email/Mail icon removed */}
                          {/* PDF/Report icon removed */}

                          <a
                            className="pull-right"
                            data-toggle="tab"
                            id="chart_tab_8"
                            onClick={this.setTab.bind(this)}
                            role="tab"
                            href="#diary_findings"
                            aria-expanded="false"
                            title="Diary Notes"
                            style={{
                              height: "26px",
                              width: "26px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "50%",
                              background: "#3F8E48",
                              boxShadow: "0 2px 6px rgba(63,142,72,0.4)",
                              marginLeft: "6px",
                              transition: "transform 180ms ease, box-shadow 180ms ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-1px)";
                              e.currentTarget.style.boxShadow = "0 4px 10px rgba(63,142,72,0.55)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 2px 6px rgba(63,142,72,0.4)";
                            }}
                          >
                            <svg
                              id="addDiaryImg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                              <path d="M9 7h7" />
                              <path d="M9 11h7" />
                              <path d="M9 15h4" />
                            </svg>
                          </a>
                        </ul>
                        <div className="clearfix"></div>
                        <div className="tab-content" id="myTabContent_6">
                          <div
                            id="chart_beats"
                            className="tab-pane fade active in"
                            role="tabpanel"
                          >
                            <div className="beat" id="beat">
                              <div className="panel-body">
                                <div className="row">
                                  <div className="col-md-4">
                                    <div
                                      className="display"
                                      id="graphPrev"
                                    ></div>
                                  </div>
                                  <div
                                    className="col-md-4 text-center txt-light"
                                    style={{ marginTop: "-30px" }}
                                  >
                                    Database Id :: {this.state.databaseid}
                                    {this.state.myBlock && (
                                      <span
                                        title="Your assigned portion(s) of this recording"
                                        style={{ display: "inline-flex", flexWrap: "wrap", gap: "4px", marginLeft: "10px", verticalAlign: "middle" }}
                                      >
                                        {String(this.state.myBlock)
                                          .split(",")
                                          .map((s) => s.trim())
                                          .filter(Boolean)
                                          .map((label, i) => (
                                            <span
                                              key={i}
                                              style={{
                                                display: "inline-block",
                                                padding: "1px 7px", fontSize: "10px", fontWeight: 700,
                                                textTransform: "uppercase", letterSpacing: "0.3px",
                                                color: "#1a6fa3", background: "#e8f4fd",
                                                border: "1px solid #a9d6f5", borderRadius: "9px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {label}
                                            </span>
                                          ))}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-md-4 text-right">
                                    <div
                                      className="display"
                                      id="graphNext"
                                    ></div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div
                                    className="col-sm-6"
                                    style={{ width: "100%" }}
                                  >
                                    <h2
                                      className="panel-title txt-light rechead"
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: "10px",
                                        position: "relative",        // anchor for absolute child
                                      }}
                                    >
                                      <div style={{ flex: "1", textAlign: "left" }}>
                                        {/* <button
        className="arythmia-btn"
        id="quickRecat"
        data-toggle="modal"
        onClick={this.disableKey.bind(this)}
        data-target="#quickModal"
      >
        Quick Recategorize
      </button> */}
                                        <button
                                          id="afibBtn"
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          data-target="#AfibModal"
                                          onClick={() => {
                                            if (window.selectedBeatNumber) {
                                              this.setState({ beat_order: window.selectedBeatNumber });
                                            }
                                            this.setState({ afibDbStartTime: this.props.match.params.databaseid });
                                            this.setState({ afibDbEndTime: this.props.match.params.databaseid });
                                          }}
                                          style={{ marginRight: "10px" }}
                                        >
                                          Afib
                                        </button>
                                        
                                        {/* <button
                                          id="vtBtn"
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          data-target="#VTModal"
                                          onClick={() => {
                                            if (window.selectedBeatNumber) {
                                              this.setState({ beat_order: window.selectedBeatNumber });
                                            }
                                            this.setState({ vtDbStartTime: this.props.match.params.databaseid });
                                            this.setState({ vtDbEndTime: this.props.match.params.databaseid });
                                          }}
                                          style={{ marginRight: "10px" }}
                                        >
                                          VT
                                        </button> */}
                                        <button
                                          id="missedbeatbtn"
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          data-target="#MissedBeatsModal"
                                          onClick={() => {
                                            this.setState({ missedBeatsStartTime: this.props.match.params.databaseid });
                                            this.setState({ missedBeatsEndTime: this.props.match.params.databaseid });
                                          }}
                                          style={{ marginRight: "10px" }}
                                        >
                                          Missed Beats
                                        </button>
                                        <button
                                          id="prevBtn"
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          data-target="#RemoveHrModal"
                                          onClick={() => {
                                            this.setState({ removeHrStartDate: this.props.match.params.databaseid });
                                            this.setState({ removeHrEndDate: this.props.match.params.databaseid });
                                          }}
                                        >
                                          Remove HR
                                        </button>
                                        {(this.state.verifiertype === "8" ||
                                          this.state.verifiertype === "10") && (
                                          <button
                                            id="SmallDatas"
                                            className="arythmia-btn"
                                            style={{ marginLeft: "10px" }}
                                            onClick={(e) => {
                                              axios
                                                .post(
                                                  `${apiUrl}api/common/deletesmallfiles`,
                                                  {
                                                    userid,
                                                  }
                                                )
                                                .then((res) => {
                                                  toast.success(
                                                    "Deleted 40 seconds data successfully!!!!!!!!!"
                                                  );
                                                });
                                            }}
                                          >
                                            40 sec delete
                                          </button>
                                        )}
                                        {(this.state.verifiertype === "8" ||
                                          this.state.verifiertype === "10") && (
                                          <>
                                            <style>
                                              {`@keyframes spin {
                                                0% { transform: rotate(0deg); }
                                                100% { transform: rotate(360deg); }
                                               }
                                              `}
                                            </style>

                                            <button
                                              id="loadDatas"
                                              className="arythmia-btn"
                                              style={{ marginLeft: "10px" }}
                                              onClick={(e) => {
                                                this.setState({
                                                  showModalSpinner: true,
                                                }); // show modal while loading

                                                const toastId =
                                                  toast.loading(
                                                    "Loading data..."
                                                  );

                                                axios
                                                  .post(
                                                    `${apiUrl}api/common/load_data`,
                                                    {
                                                      userid:
                                                        this.props.match.params
                                                          .userid,
                                                    }
                                                  )
                                                  .then((res) => {
                                                    toast.success(
                                                      "Load data successfully!",
                                                      { id: toastId }
                                                    );
                                                  })
                                                  .catch((err) => {
                                                    toast.error(
                                                      "Failed to load data!",
                                                      { id: toastId }
                                                    );
                                                  })
                                                  .finally(() => {
                                                    this.setState({
                                                      showModalSpinner: false,
                                                    }); // hide modal after done
                                                  });
                                              }}
                                            >
                                              Load Data
                                            </button>
                                            <div
                                              style={{
                                                position: "relative",
                                                display: "inline-block",
                                                marginLeft: "10px",
                                              }}
                                            >
                                              <select
                                                id="arrBtn"
                                                className="arythmia-btn"
                                                value=""
                                                style={{ color: "black", backgroundColor: "white" }}
                                                onChange={(e) => {
                                                  const label = e.target.value;
                                                  if (!label) return;
                                                  // disableKey also fills availableTimeOptions
                                                  this.disableKey();
                                                  this.setState({
                                                    arrModalOpen: true,
                                                    arrLabel: label,
                                                    ...(window.selectedBeatNumber
                                                      ? { beat_order: window.selectedBeatNumber }
                                                      : {}),
                                                    arrStartTime: this.props.match.params.databaseid || "",
                                                    arrEndTime: this.props.match.params.databaseid || "",
                                                    arrStatus: "unverify",
                                                    arrApply: "no",
                                                  });
                                                }}
                                              >
                                                <option value="" hidden>
                                                  Arrhythmia
                                                </option>
                                                <option value="Afib" style={{ color: "Black" }}>
                                                  Afib
                                                </option>
                                                <option value="2D" style={{ color: "Black" }}>
                                                  2D
                                                </option>
                                                <option value="VT" style={{ color: "Black" }}>
                                                  VT
                                                </option>
                                                <option value="JB" style={{ color: "Black" }}>
                                                  JB
                                                </option>
                                              </select>

                                              {this.state.arrModalOpen && (
                                                <div
                                                  className="modal fade in"
                                                  role="dialog"
                                                  style={{
                                                    display: "block",
                                                    background: "rgba(0,0,0,0.5)",
                                                    overflowY: "auto",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  <div className="modal-dialog">
                                                    <div className="modal-content">
                                                      <div className="modal-header">
                                                        <button
                                                          type="button"
                                                          className="close"
                                                          onClick={() => {
                                                            this.enableKey();
                                                            this.setState({ arrModalOpen: false });
                                                          }}
                                                        >
                                                          &times;
                                                        </button>
                                                        <h4 className="modal-title text-center">
                                                          {this.state.arrLabel}
                                                        </h4>
                                                      </div>
                                                      <div className="modal-body">
                                                        <div className="row row-sm-offset">
                                                          <div className="col-md-6 multi-horizontal">
                                                            <div className="form-group">
                                                              <label style={{ color: "Black" }}>Beat No </label>
                                                              <input
                                                                type="number"
                                                                inputMode="numeric"
                                                                className="form-control"
                                                                name="beat_order"
                                                                onChange={this.onChange}
                                                                value={this.state.beat_order}
                                                                style={{ backgroundColor: "white", color: "black" }}
                                                              />
                                                            </div>
                                                          </div>
                                                          <div className="col-md-6 multi-horizontal">
                                                            <div className="form-group">
                                                              <label style={{ color: "Black" }}>Status </label>
                                                              <select
                                                                name="arrStatus"
                                                                className="form-control"
                                                                value={this.state.arrStatus}
                                                                onChange={this.onChange}
                                                                style={{ backgroundColor: "white", color: "black" }}
                                                              >
                                                                <option value="verify">Verify</option>
                                                                <option value="unverify">Unverify</option>
                                                              </select>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className="row row-sm-offset">
                                                          <div className="col-md-6 multi-horizontal">
                                                            <div className="form-group">
                                                              <label style={{ color: "Black" }}>Start Time </label>
                                                              <select
                                                                name="arrStartTime"
                                                                className="form-control"
                                                                value={this.state.arrStartTime}
                                                                onChange={this.onChange}
                                                                style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                                              >
                                                                <option value="">Select Start Time</option>
                                                                {this.state.availableTimeOptions.map((time, index) => (
                                                                  <option key={index} value={time}>
                                                                    {time}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                            </div>
                                                          </div>
                                                          <div className="col-md-6 multi-horizontal">
                                                            <div className="form-group">
                                                              <label style={{ color: "Black" }}>End Time </label>
                                                              <select
                                                                name="arrEndTime"
                                                                className="form-control"
                                                                value={this.state.arrEndTime}
                                                                onChange={this.onChange}
                                                                style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                                              >
                                                                <option value="">Select End Time</option>
                                                                {this.state.availableTimeOptions.map((time, index) => (
                                                                  <option key={index} value={time}>
                                                                    {time}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className="row row-sm-offset">
                                                          <div className="col-md-6 multi-horizontal">
                                                            <div className="form-group">
                                                              <label style={{ color: "Black" }}>Apply </label>
                                                              <select
                                                                name="arrApply"
                                                                className="form-control"
                                                                value={this.state.arrApply}
                                                                onChange={this.onChange}
                                                                style={{ backgroundColor: "white", color: "black" }}
                                                              >
                                                                <option value="yes">Yes</option>
                                                                <option value="no">No</option>
                                                              </select>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="modal-footer">
                                                        <div className="row row-sm-offset">
                                                          <div className="col-md-6 multi-horizontal">
                                                            <button
                                                              type="button"
                                                              className="btn btn-success"
                                                              onClick={() => {
                                                                // Reuse the existing Afib / 2D / VT submit handlers by
                                                                // copying this modal's fields into their state.
                                                                const targets = {
                                                                  Afib: { prefix: "afib", submit: this.afibSubmit },
                                                                  VT: { prefix: "vt", submit: this.vtSubmit },
                                                                };
                                                                const target = targets[this.state.arrLabel];
                                                                if (!target) {
                                                                  toast(this.state.arrLabel + " is not available yet");
                                                                  return;
                                                                }
                                                                const beat = parseInt(this.state.beat_order, 10);
                                                                if (isNaN(beat)) {
                                                                  alert("Please enter a beat number");
                                                                  return;
                                                                }
                                                                this.enableKey();
                                                                this.setState(
                                                                  {
                                                                    arrModalOpen: false,
                                                                    [target.prefix + "DbStartTime"]: this.state.arrStartTime,
                                                                    [target.prefix + "DbEndTime"]: this.state.arrEndTime,
                                                                    [target.prefix + "Status"]: this.state.arrStatus,
                                                                    [target.prefix + "Apply"]: this.state.arrApply,
                                                                  },
                                                                  () => target.submit.call(this, { preventDefault() {} })
                                                                );
                                                              }}
                                                            >
                                                              Submit
                                                            </button>
                                                          </div>
                                                          <div className="col-md-6 multi-horizontal text-left">
                                                            <button
                                                              type="button"
                                                              className="btn btn-default closePopup"
                                                              onClick={() => {
                                                                this.enableKey();
                                                                this.setState({ arrModalOpen: false });
                                                              }}
                                                            >
                                                              Close
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>

                                            {this.state.showModalSpinner && (
                                              <div
                                                style={{
                                                  position: "fixed",
                                                  top: 0,
                                                  left: 0,
                                                  width: "100%",
                                                  height: "100%",
                                                  background: "rgba(0,0,0,0.5)",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  zIndex: 9999,
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    background: "#fff",
                                                    padding: "20px 40px",
                                                    borderRadius: "10px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid #f3f3f3",
                                                      borderTop:
                                                        "4px solid #3498db",
                                                      borderRadius: "50%",
                                                      width: "40px",
                                                      height: "40px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                      margin: "0 auto 15px",
                                                    }}
                                                  ></div>
                                                  <p
                                                    style={{
                                                      margin: 0,
                                                      color: "#333",
                                                    }}
                                                  >
                                                    Loading, please wait...
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>

                                      {/* Center group — Prev / Capture / Verify
                                          / Unverify / Next.
                                          Absolutely positioned at row center
                                          so it stays directly under "Database
                                          Id" regardless of what other flex
                                          children (Add label, Permission, …)
                                          are after it. */}
                                      <div style={{
                                        position: "absolute",
                                        left: "50%",
                                        top: "50%",
                                        transform: "translate(-50%, -50%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "10px",
                                        zIndex: 1,
                                      }}>
                                        <button
                                          id="prevBtn"
                                          className="arythmia-btn"
                                          title="Previous (Ctrl+Z)"
                                          onClick={this.newDataClick.bind(this)}
                                        >
                                          ⏮
                                        </button>
                                        <button
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          onClick={this.disableKey.bind(this)}
                                          data-target="#captureModal"
                                        >
                                          Capture Image
                                        </button>
                                        <button
                                          className="arythmia-btn"
                                          id="verfiyBtn"
                                          onClick={this.verify.bind(this)}
                                        >
                                          Verify
                                        </button>
                                        {["8", "10"].includes(
                                          localStorage.getItem("verifiertype")
                                        ) &&
                                          this.state.verifiedStatus === 1 && (
                                            <button
                                              id="unverifyBtn"
                                              className="arythmia-btn"
                                              onClick={async (e) => {
                                                await axios.post(
                                                  `${apiUrl}api/users/UnverifyPatient/${this.props.match.params.userid}/${this.state.databaseid}`
                                                );
                                                $("#unverifyBtn").css(
                                                  "display",
                                                  "none"
                                                );
                                              }}
                                            >
                                              Unverify
                                            </button>
                                          )}
                                        <button
                                          id="nextBtn"
                                          className="arythmia-btn"
                                          title="Next (Ctrl+X)"
                                          onClick={this.newDataClick.bind(this)}
                                        >
                                          ⏭
                                        </button>
                                      </div>

                                      {/* No empty balancer needed — center
                                          group is absolutely positioned. */}

                                      
                                      {/* Verified-by badge — only renders when
                                          the dataset is actually verified AND a
                                          verifier name is on file. Hides entirely
                                          (no "N/A / N/A" placeholder) for
                                          unverified records. */}
                                      {(this.state.verifiertype === "8" ||
                                        this.state.verifiertype === "10")
                                        && this.state.verifierNameData
                                        && this.state.verifierNameData.verifierName && (
                                          <div
                                            style={{
                                              display: "flex",
                                              position: "fixed",
                                              top: "5.5%",
                                              left: "61%",
                                              height: "20px",
                                            }}
                                          >
                                            <p style={{ color: "white", display: "flex", alignItems: "center", gap: "4px", margin: 0 }}>
                                              ✅{" "}
                                              {this.state.verifierNameData.verifierName}
                                              {this.state.verifierNameData.verifyTime && (
                                                <>
                                                  {" "}/{" "}
                                                  {this.state.verifierNameData.verifyTime}
                                                </>
                                              )}
                                            </p>
                                          </div>
                                        )}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          padding: "10px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginLeft: "auto",
                                          }}
                                        >
                                          {this.state.verifiertype === "8" && (
                                            <button
                                              id="add-label"
                                              className="arythmia-btn"
                                              style={{ marginLeft: "10px" }}
                                              onClick={() => {
                                                window.location.href = "/addlabel-chart/" + userid + "/" + this.state.databaseid;
                                              }}
                                            >
                                              Add label
                                            </button>
                                          )}
                                          {this.state.verifiertype === "8" && (
                                            <button
                                              id="Permission"
                                              className="arythmia-btn"
                                              onClick={(e) => {
                                                axios
                                                  .post(
                                                    `${apiUrl}api/common/userrecordpermission`,
                                                    {
                                                      userid,
                                                    }
                                                  )
                                                  .then((res) => {
                                                    toast.success(
                                                      "Permission changed"
                                                    );
                                                  });
                                              }}
                                              style={{ marginLeft: "10px" }}
                                            >
                                              Permission
                                            </button>
                                          )}
                                          {this.state.verifiertype === "8" && (
                                            null
                                          )}
                                          {this.state.verifiertype === "8" && (
                                            <button
                                              id="assign-btn"
                                              className="arythmia-btn"
                                              title="Assign Verifiers"
                                              style={{ marginLeft: "10px", fontSize: "16px" }}
                                              onClick={this.handleAssignVerifierClick}
                                            >
                                              👥
                                            </button>
                                          )}

                                          {this.state.verifiertype === "8" && (
                                            null
                                          )}
                                        </div>
                                        <button
                                          type="button"
                                          title="Comments"
                                          style={{
                                            cursor: "pointer",
                                            marginLeft: "10px",
                                            background: "#1d4a6e",
                                            border: "1px solid #2e6fa3",
                                            color: "#fff",
                                            borderRadius: "6px",
                                            padding: "4px 10px",
                                            fontSize: "16px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 5,
                                          }}
                                          onClick={(e) => {
                                            this.getInfo();
                                            this.setState({ keyIntegrationStatus: 0, isCommentModalOpen: true });
                                          }}
                                        >
                                          💬
                                          {(this.state.comments || "").trim().split("\n").filter(l => l.trim()).length > 0 && (
                                            <span style={{ background: "#e8f4fd", color: "#1a6fa3", borderRadius: 8, padding: "0 5px", fontSize: "10px", fontWeight: 700 }}>
                                              {(this.state.comments || "").trim().split("\n").filter(l => l.trim()).length}
                                            </span>
                                          )}
                                        </button>
                                      </div>

                                      <div
                                        style={{
                                          flex: "0 0 auto",
                                          textAlign: "right",
                                        }}
                                      >
                                        <select
                                          id="gainValue"
                                          style={{ color: "black", backgroundColor: "white" }}
                                          onChange={this.gainBtn.bind(this)}
                                        >
                                          <option
                                            value="1"
                                            style={{ color: "Black" }}
                                          >
                                            1X
                                          </option>
                                          <option
                                            value="2"
                                            style={{ color: "Black" }}
                                          >
                                            2X
                                          </option>
                                          <option
                                            value="3"
                                            style={{ color: "Black" }}
                                          >
                                            3X
                                          </option>
                                        </select>
                                      </div>
                                    </h2>
                                    <div
                                      className="beats-container"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {/* {this.state.minMaxHrDataCurr && this.state.minMaxHrDataCurr.nsr && this.state.minMaxHrDataCurr.nsr.length !== 0 && (<p style={{ margin: "0 10px",fontSize:"15px" ,border:"1px solid white"}}>NSR:  <span className="beats-value-container">beats:{this.state.minMaxHrDataCurr.nsr.length}  </span> <span className="beats-value-container">min:{this.state.nsrMinHr}</span>  <span className="beats-value-container"></span>  max:{this.state.nsrMaxHr} </p>
                                      )} */}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.pvc &&
                                        this.state.minMaxHrDataCurr.pvc
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              PVC
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.pvc
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.pvcMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.pvcMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.pac &&
                                        this.state.minMaxHrDataCurr.pac
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              PAC
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.pac
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.pacMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.pacMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.st &&
                                        this.state.minMaxHrDataCurr.st
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              ST
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.st
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.stMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.stMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.vt &&
                                        this.state.minMaxHrDataCurr.vt
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              VT
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.vt
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.vtMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.vtMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.afib &&
                                        this.state.minMaxHrDataCurr.afib
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              AFIB
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.afib
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.afibMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.afibMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.sb &&
                                        this.state.minMaxHrDataCurr.sb
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              SB
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.sb
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.sbMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.sbMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.sp &&
                                        this.state.minMaxHrDataCurr.sp
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              SP
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.sp
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.spMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.spMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.ipr &&
                                        this.state.minMaxHrDataCurr.ipr
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              2AVB
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.ipr
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.iprMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.iprMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.irr &&
                                        this.state.minMaxHrDataCurr.irr
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              CHB
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.irr
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.irrMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.irrMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.pqt &&
                                        this.state.minMaxHrDataCurr.pqt
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              JB
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.pqt
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.pqtMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.pqtMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.pabsent &&
                                        this.state.minMaxHrDataCurr.pabsent
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              3AVB
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr
                                                  .pabsent.length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.pabsentMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.pabsentMaxHr}
                                            </span>
                                          </p>
                                        )}
                                      {this.state.minMaxHrDataCurr &&
                                        this.state.minMaxHrDataCurr.sqt &&
                                        this.state.minMaxHrDataCurr.sqt
                                          .length !== 0 && (
                                          <p
                                            style={{
                                              marginRight: "30px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span className="beats-value-container">
                                              SVT
                                            </span>
                                            <span className="beats-value-container">
                                              Beats:{" "}
                                              {
                                                this.state.minMaxHrDataCurr.sqt
                                                  .length
                                              }
                                            </span>
                                            <span className="beats-value-container">
                                              Min: {this.state.sqtMinHr}
                                            </span>
                                            <span className="beats-value-container">
                                              Max: {this.state.sqtMaxHr}
                                            </span>
                                          </p>
                                        )}
                                    </div>
                                  </div>

                                  <div className="values-container"></div>
                                  <div className="col-sm-1"></div>
                                  <div className="col-sm-5 text-right">
                                    {/* <h2 className="panel-title txt-light rechead"> */}
                                    {/* <ul role="tablist" className="nav nav-pills" id="myTabs_6">
                                     <li role="presentation" className="pull-left">
                                    <Dropdown options={options} onChange={this._onSelect.bind(this)} value={defaultOption} placeholder="Select an option" /></li>
                                          <li role="presentation" className="pull-right">
                                          <a  data-toggle="tab" id="chart_tab_6" onClick={this.analyzeDataset.bind(this)} role="tab" href="#chart_g_events" aria-expanded="false">Analyze</a>
                                        </li>
                                        </ul> */}
                                    &nbsp;
                                    {/* <span className="pull-right">
                                        Recategorize To!
                                      </span>
                                    </h2> */}
                                    {/* <button
                                      className="arythmia-btn"
                                      value="Normal Sinus Rhythm"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      NSR
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Sinus Tachycardia"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      ST
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Sinus Bradycardia"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      SB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="PAC"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      PAC
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="PVC"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      PVC
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Ventricular Tachycardia"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      VT
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="AFib"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      AF
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Sinus Pause"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      SP
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="P Absent"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      3AVB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Irregular RR"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      CHB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Irregular PR"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      2AVB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Short QT"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      SVT
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Prolonged QT"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      JB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Undiagnosed"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      UN
                                    </button> */}
                                  </div>
                                </div>

                                {/*  */}
                                <div
                                  id="popup"
                                  className="popup-close"
                                  style={{ position: "absolute" }}
                                >
                                  <div
                                    className="draggable-area"
                                    style={{ cursor: "move", padding: "10px" }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      {/* Add a missed beat: press, then
                                          click the exact spot on the wave.
                                          Esc cancels. Logic lives in
                                          window.__armAddBeat (renderNewChart). */}
                                      <button
                                        id="addBeatBtn"
                                        className="arythmia-btn"
                                        title="Add a missed beat — press, then click the exact spot on the wave (Esc cancels)"
                                        onClick={() =>
                                          window.__armAddBeat &&
                                          window.__armAddBeat()
                                        }
                                        style={{
                                          marginLeft: "auto",
                                          padding: "7px 18px",
                                          fontSize: "15px",
                                          fontWeight: 600,
                                        }}
                                      >
                                        ＋ Add beat
                                      </button>
                                      {/* Remove a beat: press, then click
                                          the beat marker to delete. Esc
                                          cancels. Logic: window.__armRemoveBeat */}
                                      <button
                                        id="removeBeatBtn"
                                        className="arythmia-btn"
                                        title="Remove a beat — press, then click near the beat to delete (Esc cancels)"
                                        onClick={() =>
                                          window.__armRemoveBeat &&
                                          window.__armRemoveBeat()
                                        }
                                        style={{
                                          padding: "7px 18px",
                                          fontSize: "15px",
                                          fontWeight: 600,
                                        }}
                                      >
                                        − Remove beat
                                      </button>
                                      <button
                                        className="close-button"
                                        onClick={() =>
                                          this.closePopup("button")
                                        }
                                      >
                                        ❌
                                      </button>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div
                                      className="col-sm-6"
                                      style={{ top: "10px" }}
                                    >
                                      <h2 className="panel-title txt-light rechead">
                                        <button
                                          className="arythmia-btn"
                                          id="superImpose"
                                          data-toggle="modal"
                                          data-target="#SuperModal"
                                          onClick={() => {
                                            if (window.selectedBeatNumber) {
                                              this.setState({
                                                beat_order: window.selectedBeatNumber,
                                                superimpose_start_date: this.props.match.params.databaseid,
                                                superimpose_end_date: this.props.match.params.databaseid
                                              });
                                            }
                                          }}
                                        >
                                          Superimpose
                                        </button>
                                        
                                        {/* <button
                                          id="twoDBtn"
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          data-target="#TwoDModal"
                                          onClick={() => {
                                            if (window.selectedBeatNumber) {
                                              this.setState({ beat_order: window.selectedBeatNumber });
                                            }
                                            this.setState({ twoDDbStartTime: this.props.match.params.databaseid, twoDDbEndTime: this.props.match.params.databaseid });
                                          }}
                                          style={{ marginRight: "10px" }}
                                        >
                                          2D
                                        </button> */}
                                        
                                        <button
                                          className="arythmia-btn"
                                          id="quickRecat"
                                          data-toggle="modal"
                                          onClick={this.disableKey.bind(this)}
                                          data-target="#quickModal"
                                          style={{ marginLeft: "10px" }}
                                        >
                                          Quick Recategorize
                                        </button>
                                        <button
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          onClick={this.disableKey.bind(this)}
                                          style={{ marginLeft: "10px" }}
                                          data-target="#captureModal"
                                        >
                                          Capture Image
                                        </button>

                                        {/* <button
                                          className="arythmia-btn"
                                          id="quickRecat"
                                          data-toggle="modal"
                                          onClick={this.disableKey.bind(this)}
                                          data-target="#quickModal"
                                          style={{marginLeft:"10px"}}
                                        >
                                          PAC Run
                                        </button> */}
                                        {/* <button
                                          className="arythmia-btn"
                                          id="quickRecat"
                                          data-toggle="modal"
                                          onClick={this.disableKey.bind(this)}
                                          data-target="#quickModal"
                                          style={{marginLeft:"10px"}}
                                        >
                                          J Beat Run
                                        </button> */}
                                      </h2>
                                      {/* <button className="arythmia-btn nsr-btn">NSR</button>
                                  <button className="arythmia-btn st-btn">ST</button>
                                  <button className="arythmia-btn sb-btn" >SB</button>
                                  <button className="arythmia-btn pac-btn">PAC</button>
                                  <button className="arythmia-btn pvc-btn">PVC</button>
                                  <button className="arythmia-btn vt-btn">VT</button>
                                  <button className="arythmia-btn af-btn">AF</button>
                                  <button className="arythmia-btn sp-btn">SP</button>
                                  <button className="arythmia-btn pa-btn">3AVB</button>
                                  <button className="arythmia-btn irr-btn">CHB</button>
                                  <button className="arythmia-btn ipr-btn">2AVB</button>
                                  <button className="arythmia-btn sqt-btn">SVT</button>
                                  <button className="arythmia-btn lqt-btn">JB</button>
                                  <button className="arythmia-btn un-btn">UN</button>
                                  <button className="arythmia-btn st-btn" value='Sinus Tachycardia' onClick={this.colorGraph.bind(this)}>Color Chart</button> */}
                                    </div>

                                    <div
                                      className="col-sm-5 text-right"
                                      style={{ width: "100%" }}
                                    >
                                      <h2 className="panel-title txt-light rechead">
                                        {/* <ul role="tablist" className="nav nav-pills" id="myTabs_6">
                                 <li role="presentation" className="pull-left">
                                <Dropdown options={options} onChange={this._onSelect.bind(this)} value={defaultOption} placeholder="Select an option" /></li>
                                      <li role="presentation" className="pull-right">
                                      <a  data-toggle="tab" id="chart_tab_6" onClick={this.analyzeDataset.bind(this)} role="tab" href="#chart_g_events" aria-expanded="false">Analyze</a>
                                    </li>
                                    </ul> */}
                                        &nbsp;
                                        <span className="pull-right">
                                          Recategorize To
                                        </span>
                                      </h2>
                                      <button
                                        className="arythmia-btn"
                                        value="Normal Sinus Rhythm"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#3D761D" }}
                                      >
                                        NSR
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Sinus Tachycardia"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#00FFFF" }}
                                      >
                                        ST
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Sinus Bradycardia"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#FF9900" }}
                                      >
                                        SB
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="PAC"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#0000FF" }}
                                      >
                                        PAC
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="PVC"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#FF00FF" }}
                                      >
                                        PVC
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Ventricular Tachycardia"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#A64D79" }}
                                      >
                                        VT
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="AFib"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#9900FF" }}
                                      >
                                        AF
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Sinus Pause"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#FF0000" }}
                                      >
                                        SP
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="P Absent"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#bfbebb" }}
                                      >
                                        3AVB
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Irregular RR"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#7F6000" }}
                                      >
                                        CHB
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Irregular PR"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#351C75" }}
                                      >
                                        2AVB
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Short QT"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#980000" }}
                                      >
                                        SVT
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Prolonged QT"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#46BDC6" }}
                                      >
                                        JB
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Junctional Escape Rhythm"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#E69138" }}
                                      >
                                        JER
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Accelerated Junctional Rhythm"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#6FA8DC" }}
                                      >
                                        AJR
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Paced"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#c96936" }}
                                      >
                                        PB
                                      </button>
                                      <button
                                        className="arythmia-btn"
                                        value="Undiagnosed"
                                        onClick={this.recategorize.bind(this)}
                                        style={{ backgroundColor: "#FFD966" }}
                                      >
                                        UN
                                      </button>
                                    </div>
                                  </div>
                                  <div id="tt_container"></div>
                                </div>
                                {/* <div className="text-right">
                                 
                                </div> */}
                                <input
                                  type="hidden"
                                  name="beatSlected"
                                  id="beatSlected"
                                  value="[]"
                                />
                                <br />

                                <div
                                  id="selWrap"
                                  className="sel selwrap-container"
                                  onScroll={this.listenScrollEvent.bind(this)}
                                  onClick={this.openChartPopup.bind(this)}
                                ></div>

                                <input
                                  type="hidden"
                                  name="selectedChart"
                                  id="selectedChart"
                                  value={this.state.selectedChart}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            id="chart_events"
                            className="tab-pane fade "
                            role="tabpanel"
                          >
                            <div className="row">
                              <div className="col-md-12">
                                <div className="">
                                  <div className="panel-wrapper collapse in">
                                    <div className="panel-body">
                                      <div className="row">
                                        <div
                                          className="col-sm-6"
                                          style={{ width: "100%" }}
                                        >
                                          <h2
                                            className="panel-title txt-light rechead"
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <div
                                              style={{
                                                flex: "1",
                                                textAlign: "left",
                                              }}
                                            >
                                              {/* <button
        className="arythmia-btn"
        id="quickRecat"
        data-toggle="modal"
        onClick={this.disableKey.bind(this)}
        data-target="#quickModal"
      >
        Quick Recategorize
      </button> */}
                                            </div>

                                            <div
                                              style={{
                                                flex: "1",
                                                textAlign: "center",
                                              }}
                                            >
                                              <button
                                                id="prevBtn"
                                                className="arythmia-btn"
                                                title="Previous (Ctrl+Z)"
                                                onClick={this.newDataClick.bind(
                                                  this
                                                )}
                                              >
                                                ⏮
                                              </button>
                                              {/* <button
                                          className="arythmia-btn"
                                          data-toggle="modal"
                                          onClick={this.disableKey.bind(this)}
                                          style={{ marginLeft: "10px" }}
                                          data-target="#captureModal"
                                        >
                                          Capture Image
                                        </button> */}
                                              {this.state.verifiedStatus ===
                                                0 && (
                                                  <button
                                                    id="verifyBtn"
                                                    className="arythmia-btn"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={(e) =>
                                                      this.verify(e)
                                                    }
                                                  >
                                                    Verify
                                                  </button>
                                                )}
                                              {this.state.verifiedStatus ===
                                                1 && (
                                                  <button
                                                    id="verifyBtn"
                                                    className="arythmia-btn"
                                                    style={{ display: "none" }}
                                                  >
                                                    Verified
                                                  </button>
                                                )}
                                              {["8", "10"].includes(
                                                localStorage.getItem("verifiertype")
                                              ) &&
                                                this.state.verifiedStatus ===
                                                1 && (
                                                  <button
                                                    id="unverifyBtn"
                                                    className="arythmia-btn"
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                    onClick={async (e) => {
                                                      await axios.post(
                                                        `${apiUrl}api/users/UnverifyPatient/${this.props.match.params.userid}/${this.state.databaseid}`
                                                      );
                                                      $("#unverifyBtn").css(
                                                        "display",
                                                        "none"
                                                      );
                                                    }}
                                                  >
                                                    Unverify
                                                  </button>
                                                )}
                                              <button
                                                id="nextBtn"
                                                className="arythmia-btn"
                                                title="Next (Ctrl+X)"
                                                onClick={this.newDataClick.bind(
                                                  this
                                                )}
                                                style={{ marginLeft: "10px" }}
                                              >
                                                ⏭
                                              </button>
                                            </div>

                                            <div
                                              style={{
                                                flex: "1",
                                                textAlign: "right",
                                              }}
                                            >
                                              <select
                                                id="gainValue"
                                                style={{ color: "Black" }}
                                                onChange={this.gainBtn.bind(
                                                  this
                                                )}
                                              >
                                                <option
                                                  value="1"
                                                  style={{ color: "Black" }}
                                                >
                                                  1X
                                                </option>
                                                <option
                                                  value="2"
                                                  style={{ color: "Black" }}
                                                >
                                                  2X
                                                </option>
                                                <option
                                                  value="3"
                                                  style={{ color: "Black" }}
                                                >
                                                  3X
                                                </option>
                                              </select>
                                            </div>
                                          </h2>
                                        </div>

                                        <div className="col-sm-1"></div>
                                        <div className="col-sm-5 text-right">
                                          {/* <h2 className="panel-title txt-light rechead"> */}
                                          {/* <ul role="tablist" className="nav nav-pills" id="myTabs_6">
                                     <li role="presentation" className="pull-left">
                                    <Dropdown options={options} onChange={this._onSelect.bind(this)} value={defaultOption} placeholder="Select an option" /></li>
                                          <li role="presentation" className="pull-right">
                                          <a  data-toggle="tab" id="chart_tab_6" onClick={this.analyzeDataset.bind(this)} role="tab" href="#chart_g_events" aria-expanded="false">Analyze</a>
                                        </li>
                                        </ul> */}
                                          &nbsp;
                                          {/* <span className="pull-right">
                                        Recategorize To!
                                      </span>
                                    </h2> */}
                                          {/* <button
                                      className="arythmia-btn"
                                      value="Normal Sinus Rhythm"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      NSR
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Sinus Tachycardia"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      ST
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Sinus Bradycardia"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      SB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="PAC"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      PAC
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="PVC"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      PVC
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Ventricular Tachycardia"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      VT
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="AFib"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      AF
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Sinus Pause"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      SP
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="P Absent"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      3AVB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Irregular RR"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      CHB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Irregular PR"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      2AVB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Short QT"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      SVT
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Prolonged QT"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      JB
                                    </button>
                                    <button
                                      className="arythmia-btn"
                                      value="Undiagnosed"
                                      onClick={this.recategorize.bind(this)}
                                    >
                                      UN
                                    </button> */}
                                        </div>
                                      </div>
                                      <h2 className="panel-title txt-light rechead">
                                        Cardiac Event Detected
                                      </h2>
                                      <div className="filter-wrap mb-10">
                                        <ul id="filters" className="filterMain">
                                          {Object.keys(this.state.images).map(
                                            (val, key) => {
                                              if (titleFlag == 0) {
                                                titleFlag = 1;
                                                window.filterId = val;
                                                return (
                                                  <li
                                                    key={key}
                                                    id={val}
                                                    value={val}
                                                    onClick={this.filter.bind(
                                                      this
                                                    )}
                                                  >
                                                    <a
                                                      href="#"
                                                      data-filter={"." + val}
                                                      className="active"
                                                    >
                                                      {window.filterId}
                                                    </a>
                                                  </li>
                                                );
                                              } else {
                                                return (
                                                  <li
                                                    key={key}
                                                    id={val}
                                                    value={val}
                                                    onClick={this.filter.bind(
                                                      this
                                                    )}
                                                  >
                                                    <a
                                                      href="#"
                                                      data-filter={"." + val}
                                                    >
                                                      {val}
                                                    </a>
                                                  </li>
                                                );
                                              }
                                            }
                                          )}
                                        </ul>
                                        <hr />
                                        <div className="clearfix"></div>
                                      </div>
                                      <h5 className="panel-title txt-light rechead">
                                        Recategorize To
                                      </h5>
                                      <div className="row mt-5 mt-5hed">
                                        <div className="col-sm-12">
                                          <button
                                            className="arythmia-btn nsr-btn"
                                            value="nsr"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            NSR
                                          </button>
                                          <button
                                            className="arythmia-btn st-btn"
                                            value="st"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            ST
                                          </button>
                                          <button
                                            className="arythmia-btn sb-btn"
                                            value="sb"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            SB
                                          </button>
                                          <button
                                            className="arythmia-btn pac-btn"
                                            value="pac"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            PAC
                                          </button>
                                          <button
                                            className="arythmia-btn pvc-btn"
                                            value="pvc"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            PVC
                                          </button>
                                          <button
                                            className="arythmia-btn vt-btn"
                                            value="vt"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            VT
                                          </button>
                                          <button
                                            className="arythmia-btn af-btn"
                                            value="af"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            AF
                                          </button>
                                          <button
                                            className="arythmia-btn sp-btn"
                                            value="sp"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            SP
                                          </button>
                                          <button
                                            className="arythmia-btn pa-btn"
                                            value="pa"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                            style={{
                                              backgroundColor: "#bfbebb",
                                            }}
                                          >
                                            3AVB
                                          </button>
                                          <button
                                            className="arythmia-btn irr-btn"
                                            value="irr"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            CHB
                                          </button>
                                          <button
                                            className="arythmia-btn ipr-btn"
                                            value="ipr"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            2AVB
                                          </button>
                                          <button
                                            className="arythmia-btn sqt-btn"
                                            value="sqt"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            SVT
                                          </button>
                                          <button
                                            className="arythmia-btn lqt-btn"
                                            value="lqt"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            JB
                                          </button>
                                          <button
                                            className="arythmia-btn un-btn"
                                            value="un"
                                            onClick={this.recategorizeImg.bind(
                                              this
                                            )}
                                          >
                                            UN
                                          </button>
                                          <ul
                                            role="tablist"
                                            className="nav nav-pills"
                                            id="myTabs_6"
                                          >
                                            <li
                                              role="presentation"
                                              className="pull-right"
                                            >
                                              <a
                                                data-toggle="tab"
                                                id="chart_tab_6"
                                                onClick={this.generateEvents.bind(
                                                  this
                                                )}
                                                role="tab"
                                                href="#chart_g_events"
                                                aria-expanded="false"
                                              >
                                                Generate Events
                                              </a>
                                            </li>
                                            {/* <li
                                              role="presentation"
                                              className="pull-right"
                                            >
                                              <a
                                                data-toggle="tab"
                                                id="chart_tab_6"
                                                onClick={(e)=>{
                                                  const generateevent= axios.post(`https://web1.mybiocalculus.comapi/graph/GenerateEvent`,{
                                                    userid: userid,
                                                    databaseid:databaseid
                                                  })
                                                  
                                                }}
                                                role="tab"
                                                href="#chart_g_events"
                                                aria-expanded="false"
                                              >
                                                Generate Events New
                                              </a>
                                            </li> */}
                                            {window.eventclass != "all" && (
                                              <li
                                                role="presentation"
                                                className="pull-right"
                                              >
                                                <a
                                                  onClick={this.addImageToReport.bind(
                                                    this
                                                  )}
                                                >
                                                  Add beat to report
                                                </a>
                                              </li>
                                            )}
                                            {window.eventclass != "all" && (
                                              <li
                                                role="presentation"
                                                className="pull-right"
                                              >
                                                <a
                                                  onClick={this.removeFiles.bind(
                                                    this
                                                  )}
                                                >
                                                  Remove File
                                                </a>
                                              </li>
                                            )}

                                            {window.eventclass != "all" && (
                                              <li
                                                role="presentation"
                                                className="pull-right"
                                                id="SA"
                                              >
                                                <a
                                                  onClick={this.selectAll.bind(
                                                    this
                                                  )}
                                                >
                                                  Select All
                                                </a>
                                              </li>
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="gallery-wrap">
                                        <div className="portfolio-wrap project-gallery">
                                          <div
                                            id="portfolio"
                                            className="row construct project-gallery"
                                          >
                                            {Object.keys(this.state.images).map(
                                              (val, key) => {
                                                return (
                                                  <React.Fragment key={key}>
                                                    {this.state.images[val].map(
                                                      (value, key) => {
                                                        var tempvalue =
                                                          this.splitFn(value);

                                                        return (
                                                          <div
                                                            key={key}
                                                            onDoubleClick={
                                                              this.updateState
                                                            }
                                                            id={tempvalue[1]}
                                                            onClick={
                                                              this.selectImage
                                                            }
                                                            className={
                                                              "col-sm-3 item tall " +
                                                              val
                                                            }
                                                            data-src="dist/img/gallery/mock1.jpg"
                                                            data-sub-html=""
                                                          >
                                                            <p>
                                                              {tempvalue[0]}
                                                            </p>
                                                            <input
                                                              type="checkbox"
                                                              id={value}
                                                              value={
                                                                val +
                                                                "|" +
                                                                value
                                                              }
                                                              className={val}
                                                              name="test"
                                                            />
                                                            <label
                                                              htmlFor={value}
                                                            >
                                                              <img
                                                                className="img-responsive zoom"
                                                                src={
                                                                  `${getfolderfiles}` +'/'+
                                                                  this.state
                                                                    .device_id +
                                                                  "/events_list/" +
                                                                  val +
                                                                  "/" +
                                                                    this.state
                                                              .dblink.replace(/ /g, "%20") +
                                                                  "/" +
                                                                  value
                                                                }
                                                                alt="Image description"
                                                              />
                                                            </label>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </React.Fragment>
                                                );
                                              }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            id="chart_summary"
                            className="tab-pane fade"
                            role="tabpanel"
                          >
                            <VerifierSummary
                              userid={userid}
                              databaseid={databaseid}
                              rpeaks={this.state.summaryData}
                              minMaxHrCurr={this.state.minMaxHrDataCurr}
                              minMaxHrFull={this.state.minMaxHrDataFull}
                              patientwrktotaldetails={
                                this.state.patientwrktotaldetails
                              }
                              patientwrkdailydetails={
                                this.state.patientwrkdailydetails
                              }
                              patientwrkdetails={this.state.patientwrkdetails}
                              arrCount={this.state.arrCount}
                              heartRatesData={this.state.heartRatesData}
                            />
                          </div>

                          <div
                            id="chart_sel_events"
                            className="tab-pane fade"
                            role="tabpanel"
                          >
                            <VerifierSelectedBeats
                              userid={userid}
                              databaseid={databaseid}
                              datasets={this.state.datasets}
                              imagess={this.state.imagess}
                              select={window.eventclass}
                              device_id={this.state.device_id}
                            />
                          </div>

                          {/* <div  id="chart_settings" className="tab-pane fade" role="tabpanel">
                            <SettingsTab userid={userid} reportStatus={this.state.reportStatus}/>
                          </div> */}

                          {/* chart_findings tab pane removed */}
                          <div
                            id="diary_findings"
                            className="tab-pane fade"
                            role="tabpanel"
                          >
                            <DiaryNotes
                              userid={userid}
                              databaseid={databaseid}
                              treemenu={this.state.treemenu}
                              onSelectDiary={this.handleDiary}
                            />
                          </div>

                          <div
                            id="chart_regenerate"
                            className="tab-pane fade"
                            role="tabpanel"
                          >
                            <p>Regenerate</p>
                          </div>
                          <div
                            id="chart_report"
                            className="tab-pane fade"
                            role="tabpanel"
                          >
                            <p>Report</p>
                          </div>
                          <div
                            id="SuperModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    Superimpose
                                  </h4>
                                </div>
                                <form
                                  method="post"
                                  onSubmit={this.superImposeData.bind(this)}
                                >
                                  <div className="modal-body">
                                    {this.state.superimposeErrorMessage && (
                                      <div className="alert alert-danger" style={{ marginBottom: '15px', padding: '10px', borderRadius: '4px' }}>
                                        <strong>Error:</strong> {this.state.superimposeErrorMessage}
                                      </div>
                                    )}
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Beat Number{" "}
                                          </label>
                                          <input
                                            type="number"
                                            inputMode="numeric"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="beat_order"
                                            required=""
                                            id="beat_order"
                                            onChange={this.onChange}
                                            value={this.state.beat_order}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Threshold{" "}
                                          </label>
                                          <input
                                            type="number"
                                            inputMode="numeric"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="threshold"
                                            required=""
                                            id="threshold"
                                            onChange={this.onChange}
                                            value={this.state.threshold}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group" >
                                          <label style={{ color: "Black" }}>
                                            PreMS{" "}
                                          </label>
                                          <input
                                            type="number"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="preMS"
                                            id="preMS"
                                            onChange={this.onChange}
                                            value={this.state.preMS}
                                            placeholder="Distance P wave to QRS"
                                            style={{backgroundColor:"white",color:"black"}}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            PostMS{" "}
                                          </label>
                                          <input
                                            type="number"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrlt,
                                              }
                                            )}
                                            name="postMS"
                                            id="postMS"
                                            onChange={this.onChange}
                                            value={this.state.postMS}
                                            placeholder="Distance QRS to next P wave"
                                            style={{backgroundColor:"white",color:"black"}}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Start Time{" "}
                                          </label>
                                          <select
                                            name="superimpose_start_date"
                                            className="form-control"
                                            value={this.state.superimpose_start_date}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto" }}
                                          >
                                            <option value="">Select Start Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            End Time{" "}
                                          </label>
                                          <select
                                            name="superimpose_end_date"
                                            className="form-control"
                                            value={this.state.superimpose_end_date}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto" }}
                                          >
                                            <option value="">Select End Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Label{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="newArrhy"
                                            value={this.state.newArrhy}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="Normal Sinus Rhythm">Normal Sinus Rhythm</option>
                                            <option value="Sinus Tachycardia">Sinus Tachycardia</option>
                                            <option value="Sinus Bradycardia">Sinus Bradycardia</option>
                                            <option value="PAC">PAC</option>
                                            <option value="PVC">PVC</option>
                                            <option value="Sinus pause">Sinus Pause</option>
                                            <option value="Ventricular Tachycardia">Ventricular Tachycardia</option>
                                            <option value="Atrial Fibrillation">Atrial Fibrillation</option>
                                            <option value="Atrial Flutter">Atrial Flutter</option>
                                            <option value="J Beat">J Beat</option>
                                            <option value="Pacemaker Beat">Pacemaker Beat</option>
                                            <option value="SVT">SVT</option>
                                            <option value="2AVB">2AVB</option>
                                            <option value="CHB">CHB</option>
                                            <option value="Undiagnosed">Undiagnosed</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Status{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="superimposeStatus"
                                            value={this.state.superimposeStatus}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="verify">Verify</option>
                                            <option value="unverify">Unverify</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Apply{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="superimpose_apply"
                                            value={this.state.superimpose_apply}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <button
                                          id="superimposeSubmit"
                                          type="submit"
                                          className="btn btn-success"
                                        >
                                          Submit
                                        </button>
                                      </div>
                                      <div className="col-md-6 multi-horizontal text-left">
                                        <button
                                          id=""
                                          type="button"
                                          className="btn btn-default closePopup"
                                          onClick={this.enableKey}
                                          data-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.responseMessage && (
                                    <div
                                      className="alert alert-info mt-3"
                                      role="alert"
                                    >
                                      <pre>{this.state.responseMessage}</pre>
                                    </div>
                                  )}
                                </form>
                              </div>
                            </div>
                          </div>

                          <div
                            id="AfibModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    Afib
                                  </h4>
                                </div>
                                <form
                                  method="post"
                                  onSubmit={this.afibSubmit.bind(this)}
                                >
                                  <div className="modal-body">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Beat No{" "}
                                          </label>
                                          <input
                                            type="number"
                                            inputMode="numeric"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="beat_order"
                                            required=""
                                            id="afib_beat_order"
                                            onChange={this.onChange}
                                            value={this.state.beat_order}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Status{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="afibStatus"
                                            value={this.state.afibStatus}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="verify">Verify</option>
                                            <option value="unverify">Unverify</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Start Time{" "}
                                          </label>
                                          <select
                                            name="afibDbStartTime"
                                            className="form-control"
                                            value={this.state.afibDbStartTime}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select Start Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            End Time{" "}
                                          </label>
                                          <select
                                            name="afibDbEndTime"
                                            className="form-control"
                                            value={this.state.afibDbEndTime}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select End Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Apply{" "}
                                          </label>
                                          <select
                                            className={classnames(
                                              "form-control"
                                            )}
                                            name="afibApply"
                                            value={this.state.afibApply}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <button
                                          type="button"
                                          className="btn btn-success"
                                          onClick={this.afibSubmit.bind(this)}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                      <div className="col-md-6 multi-horizontal text-left">
                                        <button
                                          id=""
                                          type="button"
                                          className="btn btn-default closePopup"
                                          onClick={this.enableKey}
                                          data-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.responseMessage && (
                                    <div
                                      className="alert alert-info mt-3"
                                      role="alert"
                                    >
                                      <pre>{this.state.responseMessage}</pre>
                                    </div>
                                  )}
                                </form>
                              </div>
                            </div>
                          </div>

                          <div
                            id="VTModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    VT
                           </h4>
                                </div>
                                <form
                                  method="post"
                                  onSubmit={this.vtSubmit.bind(this)}
                                >
                                  <div className="modal-body">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Beat No{" "}
                                          </label>
                                          <input
                                            type="number"
                                            inputMode="numeric"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="beat_order"
                                            required=""
                                            id="vt_beat_order"
                                            onChange={this.onChange}
                                            value={this.state.beat_order}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Status{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="vtStatus"
                                            value={this.state.vtStatus}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="verify">Verify</option>
                                            <option value="unverify">Unverify</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Start Time{" "}
                                          </label>
                                          <select
                                            name="vtDbStartTime"
                                            className="form-control"
                                            value={this.state.vtDbStartTime}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select Start Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            End Time{" "}
                                          </label>
                                          <select
                                            name="vtDbEndTime"
                                            className="form-control"
                                            value={this.state.vtDbEndTime}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select End Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Apply{" "}
                                          </label>
                                          <select
                                            className={classnames(
                                              "form-control"
                                            )}
                                            name="vtApply"
                                            value={this.state.vtApply}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <button
                                          type="button"
                                          className="btn btn-success"
                                          onClick={this.vtSubmit.bind(this)}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                      <div className="col-md-6 multi-horizontal text-left">
                                        <button
                                          id=""
                                          type="button"
                                          className="btn btn-default closePopup"
                                          onClick={this.enableKey}
                                          data-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.responseMessage && (
                                    <div
                                      className="alert alert-info mt-3"
                                      role="alert"
                                    >
                                      <pre>{this.state.responseMessage}</pre>
                                    </div>
                                  )}
                                </form>
                              </div>
                            </div>
                          </div>

                          <div
                            id="TwoDModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    2D
                                  </h4>
                                </div>
                                <form
                                  method="post"
                                  onSubmit={this.twoDSubmit.bind(this)}
                                >
                                  <div className="modal-body">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Beat No{" "}
                                          </label>
                                          <input
                                            type="number"
                                            inputMode="numeric"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="beat_order"
                                            required=""
                                            id="twoD_beat_order"
                                            onChange={this.onChange}
                                            value={this.state.beat_order}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Status{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="twoDStatus"
                                            value={this.state.twoDStatus}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="verify">Verify</option>
                                            <option value="unverify">Unverify</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Start Time{" "}
                                          </label>
                                          <select
                                            name="twoDDbStartTime"
                                            className="form-control"
                                            value={this.state.twoDDbStartTime}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select Start Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            End Time{" "}
                                          </label>
                                          <select
                                            name="twoDDbEndTime"
                                            className="form-control"
                                            value={this.state.twoDDbEndTime}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select End Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Apply{" "}
                                          </label>
                                          <select
                                            className={classnames(
                                              "form-control"
                                            )}
                                            name="twoDApply"
                                            value={this.state.twoDApply}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <button
                                          type="button"
                                          className="btn btn-success"
                                          onClick={this.twoDSubmit.bind(this)}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                      <div className="col-md-6 multi-horizontal text-left">
                                        <button
                                          id=""
                                          type="button"
                                          className="btn btn-default closePopup"
                                          onClick={this.enableKey}
                                          data-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.responseMessage && (
                                    <div
                                      className="alert alert-info mt-3"
                                      role="alert"
                                    >
                                      <pre>{this.state.responseMessage}</pre>
                                    </div>
                                  )}
                                </form>
                              </div>
                            </div>
                          </div>

                          <ReactModal
                            isOpen={this.state.afibOutputModalOpen}
                            onRequestClose={() => this.setState({ afibOutputModalOpen: false })}
                            style={{
                              content: {
                                ...customStyles.content,
                                zIndex: 20000,
                              },
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                                zIndex: 20000,
                              },
                            }}
                          >
                            <div style={{ minWidth: "300px", maxWidth: "90vw" }}>
                              <h4 style={{ marginTop: 0, color: "black" }}>
                                Afib Output
                              </h4>
                              <div
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "6px",
                                  padding: "12px",
                                  maxHeight: "60vh",
                                  overflowY: "auto",
                                  whiteSpace: "pre-wrap",
                                  color: "black",
                                }}
                              >
                                {this.state.afibOutputText}
                              </div>
                              <div style={{ marginTop: "15px", textAlign: "right" }}>
                                <button
                                  className="btn btn-default"
                                  onClick={() => this.setState({ afibOutputModalOpen: false })}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </ReactModal>

                          <ReactModal
                            isOpen={this.state.vtOutputModalOpen}
                            onRequestClose={() => this.setState({ vtOutputModalOpen: false })}
                            style={{
                              content: {
                                ...customStyles.content,
                                zIndex: 20000,
                              },
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                                zIndex: 20000,
                              },
                            }}
                          >
                            <div style={{ minWidth: "300px", maxWidth: "90vw" }}>
                              <h4 style={{ marginTop: 0, color: "black" }}>
                                VT Output
                              </h4>
                              <div
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "6px",
                                  padding: "12px",
                                  maxHeight: "60vh",
                                  overflowY: "auto",
                                  whiteSpace: "pre-wrap",
                                  color: "black",
                                }}
                              >
                                {this.state.vtOutputText}
                              </div>
                              <div style={{ marginTop: "15px", textAlign: "right" }}>
                                <button
                                  className="btn btn-default"
                                  onClick={() => this.setState({ vtOutputModalOpen: false })}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </ReactModal>

                          <ReactModal
                            isOpen={this.state.twoDOutputModalOpen}
                            onRequestClose={() => this.setState({ twoDOutputModalOpen: false })}
                            style={{
                              content: {
                                ...customStyles.content,
                                zIndex: 20000,
                              },
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                                zIndex: 20000,
                              },
                            }}
                          >
                            <div style={{ minWidth: "300px", maxWidth: "90vw" }}>
                              <h4 style={{ marginTop: 0, color: "black" }}>
                                2D Output
                              </h4>
                              <div
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "6px",
                                  padding: "12px",
                                  maxHeight: "60vh",
                                  overflowY: "auto",
                                  whiteSpace: "pre-wrap",
                                  color: "black",
                                }}
                              >
                                {this.state.twoDOutputText}
                              </div>
                              <div style={{ marginTop: "15px", textAlign: "right" }}>
                                <button
                                  className="btn btn-default"
                                  onClick={() => this.setState({ twoDOutputModalOpen: false })}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </ReactModal>

                          <div
                            id="MissedBeat"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    Missed Beats
                                  </h4>
                                </div>
                                <div className="modal-body">
                                  {this.state.missedBeatLoading ? (
                                    <p style={{ color: "black" }}>Loading...</p>
                                  ) : (
                                    <div
                                      style={{
                                        background: "#f8f9fa",
                                        border: "1px solid #dee2e6",
                                        borderRadius: "6px",
                                        padding: "12px",
                                        maxHeight: "60vh",
                                        overflowY: "auto",
                                        whiteSpace: "pre-wrap",
                                        color: "black",
                                      }}
                                    >
                                      {this.state.missedBeatOutputText || "No output"}
                                    </div>
                                  )}
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            id="RemoveHrModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    Remove HR
                                  </h4>
                                </div>
                               {/* onSubmit={this.superImposeData.bind(this)} */}
                               
                                  <div className="modal-body">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            HR Greater{" "}
                                          </label>
                                          <input
                                            type="number"
                                            inputMode="numeric"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="hrlt"
                                            required=""
                                            id="removeHr_hrlt"
                                            onChange={this.onChange}
                                            value={this.state.hrlt}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            HR Less{" "}
                                          </label>
                                          <input
                                            type="number"
                                            inputMode="numeric"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="hrgt"
                                            required=""
                                            id="removeHr_hrgt"
                                            onChange={this.onChange}
                                            value={this.state.hrgt}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Include
                                          </label>
                                          <MultiSelectDropdown
                                            options={arrhythmiaOptions}
                                            defaultSelected={this.state.removeHrIncludeArr}
                                            onChange={this.handleRemoveHrIncludeChange}
                                            placeholder="Include"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Exclude
                                          </label>
                                          <MultiSelectDropdown
                                            options={arrhythmiaOptions}
                                            defaultSelected={this.state.removeHrExcludeArr}
                                            onChange={this.handleRemoveHrExcludeChange}
                                            placeholder="Exclude"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Start Date{" "}
                                          </label>
                                          <select
                                            name="removeHrStartDate"
                                            className="form-control"
                                            value={this.state.removeHrStartDate}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select Start Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            End Date{" "}
                                          </label>
                                          <select
                                            name="removeHrEndDate"
                                            className="form-control"
                                            value={this.state.removeHrEndDate}
                                            onChange={this.onChange}
                                            style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                          >
                                            <option value="">Select End Time</option>
                                            {this.state.availableTimeOptions.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Status{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="removeHrStatus"
                                            value={this.state.removeHrStatus}
                                            onChange={(e) => this.setState({ removeHrStatus: e.target.value })}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            
                                            <option value={1}>Verify</option>
                                            <option value={0}>Unverify</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Apply{" "}
                                          </label>
                                          <select
                                            className="form-control"
                                            name="removeHrApply"
                                            value={this.state.removeHrApply}
                                            onChange={this.onChange}
                                            style={{ backgroundColor: "white", color: "black" }}
                                          >
                                            <option value={true}>Yes</option>
                                            <option value={false}>No</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                   
                                  </div>
                                  <div className="modal-footer">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <button
                                          type="submit"
                                          className="btn btn-success"
                                          onClick={this.removeHrSubmit}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                      <div className="col-md-6 multi-horizontal text-left">
                                        <button
                                          id=""
                                          type="button"
                                          className="btn btn-default closePopup"
                                          onClick={this.enableKey}
                                          data-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.responseMessage && (
                                    <div
                                      className="alert alert-info mt-3"
                                      role="alert"
                                    >
                                      <pre>{this.state.responseMessage}</pre>
                                    </div>
                                  )}
                              
                              </div>
                            </div>
                          </div>

                          <ReactModal
                            isOpen={this.state.removeHrOutputModalOpen}
                            onRequestClose={() => this.setState({ removeHrOutputModalOpen: false })}
                            style={{
                              content: {
                                ...customStyles.content,
                                zIndex: 20000,
                              },
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                                zIndex: 20000,
                              },
                            }}
                          >
                            <div style={{ minWidth: "300px", maxWidth: "90vw" }}>
                              <h4 style={{ marginTop: 0, color: "black" }}>
                                Remove HR Output
                              </h4>
                              <div
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "6px",
                                  padding: "12px",
                                  maxHeight: "60vh",
                                  overflowY: "auto",
                                  whiteSpace: "pre-wrap",
                                  color: "black",
                                }}
                              >
                                {this.state.removeHrOutputText}
                              </div>
                              <div style={{ marginTop: "15px", textAlign: "right" }}>
                                <button
                                  className="btn btn-default"
                                  onClick={() => this.setState({ removeHrOutputModalOpen: false })}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </ReactModal>

                          <div
                            id="MissedBeatsModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    Missed Beats
                                  </h4>
                                </div>
                                <div className="modal-body">
                                  <div className="row row-sm-offset">
                                    <div className="col-md-6 multi-horizontal">
                                      <div className="form-group">
                                        <label style={{ color: "Black" }}>
                                          Start Time{" "}
                                        </label>
                                        <select
                                          name="missedBeatsStartTime"
                                          className="form-control"
                                          value={this.state.missedBeatsStartTime}
                                          onChange={this.onChange}
                                          style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                        >
                                          <option value="">Select Start Time</option>
                                          {this.state.availableTimeOptions.map((time, index) => (
                                            <option key={index} value={time}>
                                              {time}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-6 multi-horizontal">
                                      <div className="form-group">
                                        <label style={{ color: "Black" }}>
                                          End Time{" "}
                                        </label>
                                        <select
                                          name="missedBeatsEndTime"
                                          className="form-control"
                                          value={this.state.missedBeatsEndTime}
                                          onChange={this.onChange}
                                          style={{ maxHeight: "200px", overflowY: "auto", backgroundColor: "white", color: "black" }}
                                        >
                                          <option value="">Select End Time</option>
                                          {this.state.availableTimeOptions.map((time, index) => (
                                            <option key={index} value={time}>
                                              {time}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row row-sm-offset">
                                    <div className="col-md-6 multi-horizontal">
                                      <div className="form-group">
                                        <label style={{ color: "Black" }}>
                                          Status{" "}
                                        </label>
                                        <select
                                          className="form-control"
                                          name="missedBeatsStatus"
                                          value={this.state.missedBeatsStatus}
                                          onChange={(e)=>{this.setState({missedBeatsStatus:e.target.value})}}
                                          style={{ backgroundColor: "white", color: "black" }}
                                        >
                                          <option value={1}>Verify</option>
                                          <option value={0}>Unverify</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <div className="row row-sm-offset">
                                    <div className="col-md-6 multi-horizontal">
                                      <button
                                        type="submit"
                                        className="btn btn-success"
                                        onClick={this.missedBeatsSubmit}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                    <div className="col-md-6 multi-horizontal text-left">
                                      <button
                                        id=""
                                        type="button"
                                        className="btn btn-default closePopup"
                                        onClick={this.enableKey}
                                        data-dismiss="modal"
                                      >
                                        Close
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <ReactModal
                            isOpen={this.state.missedBeatOutputModalOpen}
                            onRequestClose={() => this.setState({ missedBeatOutputModalOpen: false })}
                            style={{
                              content: {
                                ...customStyles.content,
                                zIndex: 20000,
                              },
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                                zIndex: 20000,
                              },
                            }}
                          >
                            <div style={{ minWidth: "300px", maxWidth: "90vw" }}>
                              <h4 style={{ marginTop: 0, color: "black" }}>
                                Missed Beats Detection Output
                              </h4>
                              <div
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "6px",
                                  padding: "12px",
                                  maxHeight: "60vh",
                                  overflowY: "auto",
                                  whiteSpace: "pre-wrap",
                                  color: "black",
                                }}
                              >
                                {this.state.missedBeatOutputText}
                              </div>
                              <div style={{ marginTop: "15px", textAlign: "right" }}>
                                <button
                                  className="btn btn-default"
                                  onClick={() => this.setState({ missedBeatOutputModalOpen: false })}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </ReactModal>

                          {/* Superimpose Preview Modal */}
                          <ReactModal
                            isOpen={this.state.superimposePreviewModal}
                            onRequestClose={this.closeSuperimposePreview.bind(this)}
                            style={{
                              content: {
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                marginRight: '-50%',

                                transform: 'translate(-50%, -50%)',
                                width: '90%',
                                maxWidth: '900px',
                                maxHeight: '85vh',
                                overflow: 'scroll',
                                backgroundColor: '#f8f9fa',
                                padding: '0',
                                borderRadius: '12px',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
                              },
                              overlay: {
                                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                zIndex: 9999
                              }
                            }}
                          >
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                              {/* Header */}
                              <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center', 
                                padding: '20px 25px',
                                backgroundColor: '#fff',
                                borderBottom: '2px solid #e9ecef',
                                borderRadius: '12px 12px 0 0'
                              }}>
                                <h3 style={{ 
                                  margin: 0, 
                                  color: '#2c3e50',
                                  fontSize: '22px',
                                  fontWeight: '600'
                                }}>
                                  Superimpose Preview - Matching Beats
                                </h3>
                                <button
                                  onClick={this.closeSuperimposePreview.bind(this)}
                                  style={{
                                    background: '#ffffffff',
                                    border: 'none',
                                    fontSize: '3px',
                                    cursor: 'pointer',
                                    color: '#b50000ff',
                                    width: '35px',
                                    height: '35px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s ease'
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = '#fffdfdff'}
                                  onMouseLeave={(e) => e.target.style.background = '#fffdfdff'}
                                >
                                  ×
                                </button>
                              </div>

                              {this.state.superimposeLoading ? (
                                <div style={{ 
                                  textAlign: 'center', 
                                  padding: '60px 40px',
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center'
                                }}>
                                  <Loader
                                    type="TailSpin"
                                    color="#00BFFF"
                                    height={60}
                                    width={60}
                                  />
                                  <p style={{ marginTop: '20px', color: '#666', fontSize: '16px' }}>Loading matching beats...</p>
                                </div>
                              ) : (
                                <>
                                <div style={{ 
                                  flex: 1, 
                                  display: 'flex', 
                                  flexDirection: 'column',
                                  overflow: 'hidden'
                                }}>
                                  {/* Content Area */}
                                  <div style={{ 
                                    padding: '25px', 
                                    flex: 1,
                                    overflowY: 'auto',
                                    backgroundColor: '#f8f9fa'
                                  }}>
                                    {this.state.superimposeMatchingBeats ? (
                                      <div>
                                        {/* Total Matches */}
                                        {this.state.superimposeMatchingBeats.total_matches > 0 && (
                                          <div style={{
                                            backgroundColor: '#fff',
                                            padding: '15px 20px',
                                            borderRadius: '6px',
                                            marginBottom: '20px',
                                            border: '1px solid #dee2e6'
                                          }}>
                                            <span style={{ fontSize: '14px', color: '#666' }}>Total Matches: </span>
                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
                                              {this.state.superimposeMatchingBeats.total_matches}
                                            </span>
                                          </div>
                                        )}

                                        {/* Raw Output */}
                                        {this.state.superimposeMatchingBeats.raw_output && (
                                          <div style={{
                                            backgroundColor: '#fff',
                                            padding: '20px',
                                            borderRadius: '6px',
                                            border: '1px solid #dee2e6'
                                          }}>
                                            <h5 style={{ 
                                              margin: '0 0 15px 0', 
                                              color: '#333',
                                              fontSize: '16px',
                                              fontWeight: '600'
                                            }}>
                                              Output:
                                            </h5>
                                            <div style={{ 
                                              backgroundColor: '#f8f9fa',
                                              padding: '15px',
                                              borderRadius: '4px',
                                              maxHeight: '400px',
                                              overflowY: 'auto',
                                              border: '1px solid #dee2e6'
                                            }}>
                                              <pre style={{ 
                                                whiteSpace: 'pre-wrap', 
                                                wordWrap: 'break-word',
                                                margin: 0,
                                                fontSize: '13px',
                                                lineHeight: '1.6',
                                                color: '#333',
                                                fontFamily: 'Monaco, Consolas, "Courier New", monospace'
                                              }}>
                                                {this.state.superimposeMatchingBeats.raw_output}
                                              </pre>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div style={{
                                        textAlign: 'center',
                                        padding: '40px',
                                        backgroundColor: '#fff',
                                        borderRadius: '8px',
                                        color: '#7f8c8d'
                                      }}>
                                        <p style={{ fontSize: '16px' }}>No matching beats found</p>
                                      </div>
                                    )}
                                  </div>

                                  {/* Footer */}
                                
                                </div>
                                  
                                </>
                              )}
                            </div>
                            
                          <div style={{ 
                                    padding: '20px 25px',
                                    backgroundColor: '#fff',
                                    borderTop: '1px solid #e9ecef',
                                    borderRadius: '0 0 12px 12px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}>
                                    <p style={{ 
                                      margin: 0, 
                                      color: '#7f8c8d',
                                      fontSize: '14px'
                                    }}>
                                      Review the matching beats and click "Apply Changes" to proceed
                                    </p>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                      <button
                                        onClick={this.closeSuperimposePreview.bind(this)}
                                        className="btn btn-default"
                                        style={{ 
                                          minWidth: '120px',
                                          padding: '10px 20px',
                                          fontSize: '15px',
                                          fontWeight: '500'
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={this.applySuperimpose.bind(this)}
                                        className="btn btn-success"
                                        style={{ 
                                          minWidth: '120px',
                                          padding: '10px 20px',
                                          fontSize: '15px',
                                          fontWeight: '500',
                                          backgroundColor: '#27ae60',
                                          borderColor: '#27ae60'
                                        }}
                                      >
                                        Apply Changes
                                      </button>
                                    </div>
                                  </div>
                          </ReactModal>

                          <div
                            id="quickModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog quickRecatDialog" style={{ maxWidth: 1040, width: "94%", margin: "12px auto" }}>
                              <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>
                                <div className="modal-header" style={{ background: "#1e2d38", padding: "12px 18px", borderBottom: "none", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <h4 className="modal-title" style={{ color: "#fff", fontWeight: 700, fontSize: 16, margin: 0, display: "flex", alignItems: "center", gap: 8 }}>
                                    ⚡ Quick Recategorization
                                  </h4>
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                    style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: 16, lineHeight: 1, cursor: "pointer", opacity: 1, textShadow: "none", margin: 0, padding: 0 }}
                                  >
                                    ×
                                  </button>
                                </div>
                                <style>{`
                                  #quickModal .qr-body .form-group { margin-bottom: 10px; }
                                  #quickModal .qr-body label { color:#2d3748 !important; font-size:12px; font-weight:600; text-transform:uppercase; letter-spacing:.3px; margin-bottom:4px; display:block; }
                                  #quickModal .qr-body .form-control { height:34px; font-size:13px; padding:6px 10px; border:1px solid #cbd5e0; border-radius:6px; box-shadow:none; }
                                  #quickModal .qr-body .form-control:focus { border-color:#4299e1; outline:none; }
                                  #quickModal .qr-body select.form-control { padding:4px 8px; }
                                  #quickModal .qr-body .row.row-sm-offset { margin-left:-8px; margin-right:-8px; }
                                  #quickModal .qr-body .row.row-sm-offset > [class*="col-"] { padding-left:8px; padding-right:8px; }
                                  #quickModal .qr-body .row.row-sm-offset > br { display:none; }
                                `}</style>
                                <form method="post" onSubmit={this.quickRecat}>
                                  <div className="modal-body qr-body" style={{ padding: "12px 18px", maxHeight: "calc(100vh - 140px)", overflowY: "auto", background: "#fff" }}>
                                    <div className="row row-sm-offset">
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            HR gt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrgt,
                                              }
                                            )}
                                            name="hrgt"
                                            required=""
                                            id="hrgt"
                                            onChange={this.onChange}
                                            value={this.state.hrgt}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            HR lt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.hrlt,
                                              }
                                            )}
                                            name="hrlt"
                                            required=""
                                            id="hrlt"
                                            onChange={this.onChange}
                                            value={this.state.hrlt}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Beat gt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.beatgt,
                                              }
                                            )}
                                            name="beatgt"
                                            required=""
                                            id="beatgt"
                                            onChange={this.onChange}
                                            value={this.state.beatgt}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Beat lt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.beatlt,
                                              }
                                            )}
                                            name="beatlt"
                                            required=""
                                            id="beatlt"
                                            onChange={this.onChange}
                                            value={this.state.beatlt}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-sm-offset">
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Previous beat HR gt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.lowr,
                                              }
                                            )}
                                            name="lowr"
                                            required=""
                                            id="lowr"
                                            onChange={this.onChange}
                                            value={this.state.lowr}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Previous beat HR lt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.highr,
                                              }
                                            )}
                                            name="highr"
                                            required=""
                                            id="highr"
                                            onChange={this.onChange}
                                            value={this.state.highr}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Next beat HR gt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.low_2_high,
                                              }
                                            )}
                                            name="low_2_high"
                                            required=""
                                            id="low_2_high"
                                            onChange={this.onChange}
                                            value={this.state.low_2_high}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-sm-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Next beat HR lt{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.high_2_high,
                                              }
                                            )}
                                            name="high_2_high"
                                            required=""
                                            id="high_2_high"
                                            onChange={this.onChange}
                                            value={this.state.high_2_high}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Previous Arrhythmia
                                          </label>
                                          <select
                                            name="prev_arh"
                                            className="form-control"
                                            value={this.state.prev_arh}
                                            onChange={this.onChange}
                                          >
                                            <option value="Current">
                                              Current{" "}
                                            </option>
                                            <option value="nsr">
                                              Normal Sinus Rhythm
                                            </option>
                                            <option value="st">
                                              Sinus Tachycardia{" "}
                                            </option>
                                            <option value="sb">
                                              Sinus Bradycardia
                                            </option>
                                            <option value="pac">PAC</option>
                                            <option value="pvc">PVC</option>
                                            <option value="sp">
                                              Sinus pause
                                            </option>
                                            <option value="vt">
                                              Ventricular Tachycardia
                                            </option>
                                            <option value="af">
                                              Atrial Fibrillation{" "}
                                            </option>
                                            <option value="flutter">
                                              Atrial Flutter
                                            </option>
                                            <option value="jbeat">
                                              J Beat
                                            </option>
                                            <option value="Paced">
                                              Pacemaker Beat
                                            </option>
                                            <option value="un">
                                              Undiagnosed
                                            </option>
                                            <option value="Short QT">
                                              SVT
                                            </option>
                                            <option value="Irregular PR">
                                              2AVB
                                            </option>
                                            <option value="P Absent">
                                              3AVB
                                            </option>
                                            <option value="Irregular RR">
                                              CHB
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Next Arrhythmia
                                          </label>
                                          <select
                                            name="next_arh"
                                            className="form-control"
                                            value={this.state.next_arh}
                                            onChange={this.onChange}
                                          >
                                            <option value="Current">
                                              Current{" "}
                                            </option>
                                            <option value="nsr">
                                              Normal Sinus Rhythm
                                            </option>
                                            <option value="st">
                                              Sinus Tachycardia{" "}
                                            </option>
                                            <option value="sb">
                                              Sinus Bradycardia
                                            </option>
                                            <option value="pac">PAC</option>
                                            <option value="pvc">PVC</option>
                                            <option value="sp">
                                              Sinus pause
                                            </option>
                                            <option value="vt">
                                              Ventricular Tachycardia
                                            </option>
                                            <option value="af">
                                              Atrial Fibrillation{" "}
                                            </option>
                                            <option value="flutter">
                                              Atrial Flutter
                                            </option>
                                            <option value="jbeat">
                                              J Beat
                                            </option>
                                            <option value="Paced">
                                              Pacemaker Beat
                                            </option>
                                            <option value="un">
                                              Undiagnosed
                                            </option>
                                            <option value="Short QT">
                                              SVT
                                            </option>
                                            <option value="Irregular PR">
                                              2AVB
                                            </option>
                                            <option value="P Absent">
                                              3AVB
                                            </option>
                                            <option value="Irregular RR">
                                              CHB
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Start time{" "}
                                          </label>
                                          <select
                                            name="starttime"
                                            className="form-control"
                                            value={this.state.selectedstarttime} // Bind value to selectedstarttime, default to empty
                                            onChange={this.onStarttimeChange}
                                          >
                                            <option value="">
                                              Select Start Time
                                            </option>
                                            {this.state.starttime.map(
                                              (time, index) => (
                                                <option
                                                  key={index}
                                                  value={time}
                                                >
                                                  {time}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            End time
                                          </label>
                                          <select
                                            name="endtime"
                                            className="form-control"
                                            value={this.state.selectedendtime} // Bind value to selectedendtime, default to empty
                                            onChange={this.onEndtimeChange}
                                          >
                                            <option value="">
                                              Select End Time
                                            </option>
                                            {this.state.endtime.map(
                                              (time, index) => (
                                                <option
                                                  key={index}
                                                  value={time}
                                                >
                                                  {time}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-sm-offset">                                      
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Check Arrhythmia{" "}
                                          </label>
                                          <select
                                            name="checkArr"
                                            className="form-control"
                                            value={this.state.checkArr}
                                            onChange={this.onChange}
                                          >
                                            <option value="equal">Equal</option>
                                            <option value="notEqual">
                                              Not Equal
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Data{" "}
                                          </label>
                                          <select
                                            name="fullCurrent"
                                            className="form-control"
                                            value={this.state.fullCurrent}
                                            onChange={this.onChange}
                                          >
                                            <option value="Current">
                                              Current
                                            </option>
                                            <option value="unverify">
                                              Unverify
                                            </option>

                                            <option value="verify">
                                              Verify
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            Arrhythmia
                                          </label>
                                          <select
                                            name="qRecatArr"
                                            className="form-control"
                                            value={this.state.qRecatArr}
                                            onChange={this.onChange}
                                          >
                                            <option value="Current">
                                              Current{" "}
                                            </option>
                                            <option value="nsr">
                                              Normal Sinus Rhythm
                                            </option>
                                            <option value="st">
                                              Sinus Tachycardia{" "}
                                            </option>
                                            <option value="sb">
                                              Sinus Bradycardia
                                            </option>
                                            <option value="pac">PAC</option>
                                            <option value="pvc">PVC</option>
                                            <option value="sp">
                                              Sinus pause
                                            </option>
                                            <option value="vt">
                                              Ventricular Tachycardia
                                            </option>
                                            <option value="af">
                                              Atrial Fibrillation{" "}
                                            </option>
                                            <option value="flutter">
                                              Atrial Flutter
                                            </option>
                                            <option value="jbeat">
                                              J Beat
                                            </option>
                                            <option value="Paced">
                                              Pacemaker Beat
                                            </option>
                                            <option value="un">
                                              Undiagnosed
                                            </option>
                                            <option value="Short QT">
                                              SVT
                                            </option>
                                            <option value="Irregular PR">
                                              2AVB
                                            </option>
                                            <option value="P Absent">
                                              3AVB
                                            </option>
                                            <option value="Irregular RR">
                                              CHB
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label style={{ color: "Black" }}>
                                            New Arrhythmia
                                          </label>
                                          <select
                                            name="newArr"
                                            className="form-control"
                                            value={this.state.newArr}
                                            onChange={this.onChange}
                                          >
                                            <option value="un">
                                              Undiagnosed
                                            </option>
                                            <option value="pac">PAC</option>
                                            <option value="pvc">PVC</option>
                                            <option value="st">
                                              Sinus Tachycardia{" "}
                                            </option>
                                            <option value="sb">
                                              Sinus Bradycardia
                                            </option>
                                            <option value="nsr">
                                              Normal Sinus Rhythm
                                            </option>
                                            <option value="sp">
                                              Sinus pause
                                            </option>
                                            <option value="vt">
                                              Ventricular Tachycardia
                                            </option>
                                            <option value="af">
                                              Atrial Fibrillation{" "}
                                            </option>
                                            <option value="flutter">
                                              Atrial Flutter
                                            </option>
                                            <option value="jbeat">
                                              J Beat
                                            </option>
                                            <option value="Paced">
                                              Pacemaker Beat
                                            </option>
                                            <option value="Short QT">
                                              SVT
                                            </option>
                                            <option value="Irregular PR">
                                              2AVB
                                            </option>
                                            <option value="P Absent">
                                              3AVB
                                            </option>
                                            <option value="Irregular RR">
                                              CHB
                                            </option>
                                            <option value="Current">
                                              Current{" "}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer" style={{ padding: "10px 18px", background: "#fff", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, margin: 0 }}>
                                    <div style={{ display: "flex", gap: 8 }}>
                                      <button
                                        type="button"
                                        onClick={this.saveQuickRecatPreset}
                                        title="Save current values as default for this patient (stored locally on your machine only)"
                                        style={{ padding: "7px 16px", fontSize: 13, background: "#3498db", border: "none", borderRadius: 6, color: "#fff", fontWeight: 600, cursor: "pointer" }}
                                      >
                                        💾 Save as Default
                                      </button>
                                      <button
                                        type="button"
                                        onClick={this.resetQuickRecatPreset}
                                        title="Clear saved preset and reset to factory defaults"
                                        style={{ padding: "7px 14px", fontSize: 13, background: "#fff", border: "1px solid #cbd5e0", borderRadius: 6, color: "#64748b", fontWeight: 500, cursor: "pointer" }}
                                      >
                                        ↺ Reset
                                      </button>
                                    </div>
                                    <div style={{ display: "flex", gap: 8 }}>
                                      <button
                                        type="button"
                                        className="btn btn-default closePopup"
                                        onClick={this.enableKey}
                                        data-dismiss="modal"
                                        style={{ padding: "7px 20px", fontSize: 13, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}
                                      >
                                        Close
                                      </button>
                                      <button
                                        type="submit"
                                        className="btn btn-success"
                                        style={{ padding: "7px 22px", fontSize: 13, background: "#1e8449", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: "pointer" }}
                                      >
                                        ✓ Submit
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          {this.state.isCommentModalOpen && (
                            <div className="modal fade in" role="dialog" style={{ display: "block", background: "rgba(0,0,0,0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", zIndex: 1050 }}>
                              <div className="modal-dialog" style={{ maxWidth: 580, margin: "50px auto", width: "90%" }}>
                                <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>

                                  {/* Header */}
                                  <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div>
                                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
                                        💬 Comments
                                      </div>
                                      {this.state.patient_name && (
                                        <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                                          {this.state.patient_name}
                                        </div>
                                      )}
                                    </div>
                                    <button type="button"
                                      onClick={() => this.setState({ isCommentModalOpen: false, newComment: "" })}
                                      style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      ×
                                    </button>
                                  </div>

                                  {/* Comment History */}
                                  {(() => {
                                    const raw = (this.state.comments || "").trim();
                                    const lines = raw ? raw.split("\n").filter(l => l.trim()) : [];
                                    return (
                                      <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: 280, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
                                        {lines.length === 0 ? (
                                          <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
                                        ) : (
                                          lines.map((line, idx) => {
                                            const byMatch = line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i)
                                                         || line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                                            const text   = byMatch ? byMatch[1].trim() : line;
                                            const author = byMatch ? byMatch[2].trim() : "";
                                            const time   = byMatch ? byMatch[3] || "" : "";
                                            const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase() : "?";
                                            const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                                            const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                                            return (
                                              <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                                                  {initials}
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                                    {text}
                                                  </div>
                                                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                                                    <span style={{ fontWeight: 600, color: "#64748b" }}>{author || "Unknown"}</span>
                                                    {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })
                                        )}
                                      </div>
                                    );
                                  })()}

                                  {/* New Comment Input */}
                                  <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
                                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
                                    <textarea
                                      value={this.state.newComment || ""}
                                      onChange={(e) => this.setState({ newComment: e.target.value })}
                                      placeholder="Type your observation, finding or note here…"
                                      maxLength={300}
                                      rows={3}
                                      style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6 }}
                                      onFocus={e => e.target.style.borderColor = "#4299e1"}
                                      onBlur={e => e.target.style.borderColor = "#cbd5e0"}
                                    />
                                    <div style={{ textAlign: "right", fontSize: "11px", color: (this.state.newComment || "").length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
                                      {(this.state.newComment || "").length}/300
                                    </div>
                                  </div>

                                  {/* Footer */}
                                  <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
                                    <button type="button"
                                      onClick={() => this.setState({ isCommentModalOpen: false, newComment: "" })}
                                      style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>
                                      Cancel
                                    </button>
                                    <button type="button"
                                      onClick={this.submitcommentinfo}
                                      disabled={!(this.state.newComment || "").trim()}
                                      style={{ padding: "7px 22px", fontSize: "13px", background: (this.state.newComment || "").trim() ? "#1e8449" : "#a8d5b5", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: (this.state.newComment || "").trim() ? "pointer" : "not-allowed", transition: "background 0.2s" }}>
                                      ✓ Add Comment
                                    </button>
                                  </div>

                                </div>
                              </div>
                            </div>
                          )}

                          <div
                            id="captureModal"
                            className="modal fade"
                            role="dialog"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={this.enableKey}
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title text-center">
                                    Capture Image Configurations
                                  </h4>
                                </div>
                                <form
                                  method="post"
                                  onSubmit={this.captureImage}
                                >
                                  <div className="modal-body">
                                    <div className="row row-sm-offset">
                                      <br />
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label
                                            className="form-control-label mbr-fonts-style display-7"
                                            style={{ color: "Black" }}
                                          >
                                            Strip Count
                                          </label>
                                          <select
                                            name="stripcount"
                                            className="form-control"
                                            value={this.state.stripcount}
                                            onChange={this.onChange}
                                          >
                                            <option value="">Choose </option>
                                            <option value="1">1 Min</option>
                                            <option value="2">2 Min</option>
                                            <option value="5">5 Min</option>
                                            <option value="10">10 Min</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label
                                            className="form-control-label mbr-fonts-style display-7"
                                            style={{ color: "Black" }}
                                          >
                                            Label Info
                                          </label>
                                          <select
                                            name="labelinfo"
                                            className="form-control"
                                            value={this.state.labelinfo}
                                            onChange={this.onChange}
                                          >
                                            <option value="">Choose </option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-sm-offset">
                                      <br />
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label
                                            className="form-control-label mbr-fonts-style display-7"
                                            style={{ color: "Black" }}
                                          >
                                            Add Symptoms And Comments
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.sel_arr,
                                              }
                                            )}
                                            name="sel_arr"
                                            required=""
                                            id="sel_arr"
                                            onChange={this.onChange}
                                            value={this.state.sel_arr}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label
                                            className="form-control-label mbr-fonts-style display-7"
                                            style={{ color: "Black" }}
                                          >
                                            New{" "}
                                          </label>
                                          <input
                                            type="text"
                                            className={classnames(
                                              "form-control",
                                              {
                                                errors: errors.newName,
                                              }
                                            )}
                                            name="newName"
                                            required=""
                                            id="newName"
                                            onChange={this.onChange}
                                            value={this.state.newName}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row row-sm-offset">
                                      <br />
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label
                                            className="form-control-label mbr-fonts-style display-7"
                                            style={{ color: "Black" }}
                                          >
                                            List of Arrhythmia
                                          </label>
                                          <select
                                            name="arr_list"
                                            className="form-control"
                                            value={this.state.arr_list}
                                            onChange={this.onChange}
                                          >
                                            <option value="">Choose </option>
                                            <option
                                              value="CURRENT"
                                              style={{ color: "Black" }}
                                            >
                                              CURRENT
                                            </option>

                                            <option
                                              label="SINUS RHYTHMS"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />

                                            <option value="min">
                                              Minimum HR
                                            </option>
                                            <option value="max">
                                              Maximum HR
                                            </option>
                                            <option value="nsr">
                                              Normal Sinus Rhythm
                                            </option>
                                            <option value="st">
                                              Sinus Tachycardia{" "}
                                            </option>
                                            <option value="sb">
                                              Sinus Bradycardia
                                            </option>
                                            <option value="sa">
                                              Sinus Arrhythmia
                                            </option>

                                            <option
                                              label="ADDITIONAL"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />
                                            <option value="sym">
                                              Diary Notes
                                            </option>

                                            <option
                                              label="ATRIAL ECTOPICS"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />
                                            <option value="pac">PAC</option>
                                            <option value="couplet_pac">
                                              PAC couplet
                                            </option>
                                            <option value="triplet_pac">
                                              PAC Triplet
                                            </option>
                                            <option value="run_pac">
                                              PAC Run
                                            </option>
                                            <option value="bi_pac">
                                              PAC Bigeminy{" "}
                                            </option>
                                            <option value="tri_pac">
                                              PAC Trigeminy
                                            </option>
                                            <option value="blocked_pac">
                                              Blocked PAC
                                            </option>
                                            <option value="at">
                                              Atrial Tachycardia
                                            </option>
                                            <option value="svt">
                                              Supraventricular Tachycardia
                                            </option>
                                            <option value="flutter">
                                              Atrial Flutter
                                            </option>
                                            <option value="af">
                                              Atrial Fibrillation{" "}
                                            </option>
                                            <option value="ncar">
                                              Non Conducted Atrial Response
                                            </option>

                                            <option
                                              label="VENTRICULAR ECTOPICS"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />
                                            <option value="pvc">PVC</option>
                                            <option value="couplet_pvc">
                                              PVC couplet
                                            </option>
                                            <option value="triplet_pvc">
                                              PVC Triplet
                                            </option>
                                            <option value="run_pvc">
                                              PVC Run{" "}
                                            </option>
                                            <option value="bi_pvc">
                                              PVC Bigeminy
                                            </option>
                                            <option value="tri_pvc">
                                              PVC Trigeminy
                                            </option>
                                            <option value="vt">
                                              Ventricular Tachycardia
                                            </option>
                                            <option value="ivr">
                                              IdioVentricular Rhythm
                                            </option>
                                            <option value="aivr">
                                              Accelerated IdioVentricular Rhythm{" "}
                                            </option>

                                            <option
                                              label="BLOCKS"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />
                                            <option value="block">
                                              Sinus Block
                                            </option>
                                            <option value="arrest">
                                              Sinus Arrest
                                            </option>
                                            <option value="sp">
                                              Sinus pause
                                            </option>
                                            <option value="1avb">
                                              First Degree AV Block
                                            </option>
                                            <option value="2avb">
                                              Second Degree AV Block
                                            </option>
                                            <option value="2avb_type1">
                                              Second Degree AV Block Type 1
                                            </option>
                                            <option value="2avb_type2">
                                              Second Degree AV Block Type 2
                                            </option>
                                            <option value="2avb2:1">
                                              Second Degree AV Block 2:1
                                            </option>
                                            <option value="2avb3:1">
                                              Second Degree AV Block 3:1
                                            </option>
                                            <option value="chb">
                                              Complete Heart Block
                                            </option>

                                            <option
                                              label="JUNCTIONAL ECTOPICS"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />
                                            <option value="pjc">PJC</option>
                                            <option value="jc">
                                              Junctional Couplet
                                            </option>
                                            <option value="j">
                                              Junctional Beats
                                            </option>
                                            <option value="jt">
                                              Junctional Tachycardia
                                            </option>
                                            <option value="jer">
                                              Junctional Escape Rhythm
                                            </option>
                                            <option value="ajr">
                                              Accelerated Junctional Rhythm
                                            </option>
                                            <option
                                              label="Paced Beats"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />
                                            <option value="pbt">
                                              Pacemaker Beats
                                            </option>
                                            <option
                                              label="Conduction Delay"
                                              style={{
                                                fontWeight: "bold",
                                                color: "black",
                                              }}
                                              disabled
                                            />
                                            <option value="ivcd">
                                              Intraventricular Conduction Delay
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6 multi-horizontal">
                                        <div className="form-group">
                                          <label
                                            className="form-control-label mbr-fonts-style display-7"
                                            style={{ color: "Black" }}
                                          >
                                            Graph color
                                          </label>
                                          <select
                                            name="graph_color"
                                            className="form-control"
                                            value={this.state.graph_color}
                                            onChange={this.onChange}
                                          >
                                            <option value="">Normal</option>
                                            <option value="Blue">Blue</option>
                                          </select>
                                        </div>
                                      </div>


                                    </div>

                                  </div>
                                  <div className="modal-footer">
                                    <div className="row row-sm-offset">
                                      <div className="col-md-6 multi-horizontal">
                                        <button
                                          type="submit"
                                          className="btn btn-success"
                                        >
                                          Submit
                                        </button>
                                      </div>
                                      <div className="col-md-6 multi-horizontal text-left">
                                        <button
                                          id=""
                                          type="button"
                                          className="btn btn-default closePopup"
                                          onClick={this.enableKey}
                                          data-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <ReactModal
          isOpen={this.state.showVerifierModal}
          style={customStyles}
          contentLabel="Assign Verifier"
          ariaHideApp={false}
        >
          <div style={{ padding: "20px", width: "400px", maxWidth: "90vw" }}>
             <h3 style={{ marginTop: 0, marginBottom: "20px", color: "#333" }}>Assign Verifiers</h3>
             <div style={{ marginBottom: "20px" }}>
               <label style={{ display: "block", marginBottom: "5px", color: "#666" }}>Select Verifiers:</label>
               <Select
                 isMulti
                 value={this.state.selectedVerifiers}
                 onChange={this.handleVerifierChange}
                 options={this.state.verifiersList}
                 className="basic-multi-select"
                 classNamePrefix="select"
                 styles={{ option: (provided) => ({ ...provided, color: 'black' }) }} 
               />
             </div>
             <div style={{ display: "flex", justifyContent: "flex-end" }}>
               <button className="btn btn-success" onClick={this.submitVerifierAssignment} style={{ marginRight: "10px" }}>Submit</button>
               <button className="btn btn-default" onClick={this.closeVerifierModal}>Close</button>
             </div>
          </div>
        </ReactModal>

        {/* Superimpose Loading Overlay */}
        {this.state.superimposeLoading && !this.state.superimposePreviewModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999
          }}>
            <Loader
              type="TailSpin"
              color="#00BFFF"
              height={80}
              width={80}
            />
            <div style={{
              marginTop: '30px',
              color: '#fff',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              <div className="bounce-container">
                {"Fetching Matched Beats...".split("").map((char, index) => (
                  <span
                    key={index}
                    className="bounce-letter"
                    style={{
                      animationDelay: `${index * 0.1}s`,
                      display: 'inline-block',
                      color: '#fff'
                    }}
                  >
                    {char === " " ? "\u00A0" : char}
                  </span>
                ))}
              </div>
            </div>
            <p style={{ 
              color: '#ccc', 
              marginTop: '15px',
              fontSize: '14px'
            }}>
              Please wait while we find matching beats...
            </p>
          </div>
        )}

        </div>
      </div>
    );
  }
}

VerifierChart.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(VerifierChart);
